import _slicedToArray from "D:\\Dolar_2025_29_04\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/esm/slicedToArray";
import _defineProperty from "D:\\Dolar_2025_29_04\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/esm/defineProperty";
import _toConsumableArray from "D:\\Dolar_2025_29_04\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/esm/toConsumableArray";
import { jsx, jsxs, Fragment } from 'react/jsx-runtime';
import { useMemo, useState, useRef, useCallback, useEffect, Fragment as Fragment$1, memo, useLayoutEffect } from 'react';
import { aggregationFns, filterFns, sortingFns, useReactTable, getCoreRowModel, getExpandedRowModel, getFacetedMinMaxValues, getFacetedRowModel, getFacetedUniqueValues, getFilteredRowModel, getGroupedRowModel, getPaginationRowModel, getSortedRowModel } from '@tanstack/react-table';
import { rankItem, rankings, compareItems } from '@tanstack/match-sorter-utils';
import { alpha, lighten, useTheme, darken } from '@mui/material/styles';
import ArrowDownwardIcon from '@mui/icons-material/ArrowDownward';
import ArrowRightIcon from '@mui/icons-material/ArrowRight';
import CancelIcon from '@mui/icons-material/Cancel';
import ClearAllIcon from '@mui/icons-material/ClearAll';
import CloseIcon from '@mui/icons-material/Close';
import DensityLargeIcon from '@mui/icons-material/DensityLarge';
import DensityMediumIcon from '@mui/icons-material/DensityMedium';
import DensitySmallIcon from '@mui/icons-material/DensitySmall';
import DragHandleIcon from '@mui/icons-material/DragHandle';
import DynamicFeedIcon from '@mui/icons-material/DynamicFeed';
import EditIcon from '@mui/icons-material/Edit';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import FilterAltIcon from '@mui/icons-material/FilterAlt';
import FilterListIcon from '@mui/icons-material/FilterList';
import FilterListOffIcon from '@mui/icons-material/FilterListOff';
import FullscreenExitIcon from '@mui/icons-material/FullscreenExit';
import FullscreenIcon from '@mui/icons-material/Fullscreen';
import KeyboardDoubleArrowDownIcon from '@mui/icons-material/KeyboardDoubleArrowDown';
import MoreHorizIcon from '@mui/icons-material/MoreHoriz';
import MoreVertIcon from '@mui/icons-material/MoreVert';
import PushPinIcon from '@mui/icons-material/PushPin';
import RestartAltIcon from '@mui/icons-material/RestartAlt';
import SaveIcon from '@mui/icons-material/Save';
import SearchIcon from '@mui/icons-material/Search';
import SearchOffIcon from '@mui/icons-material/SearchOff';
import SortIcon from '@mui/icons-material/Sort';
import ViewColumnIcon from '@mui/icons-material/ViewColumn';
import VisibilityOffIcon from '@mui/icons-material/VisibilityOff';
import Box from '@mui/material/Box';
import Dialog from '@mui/material/Dialog';
import Grow from '@mui/material/Grow';
import IconButton from '@mui/material/IconButton';
import Tooltip from '@mui/material/Tooltip';
import ListItemIcon from '@mui/material/ListItemIcon';
import Menu from '@mui/material/Menu';
import MenuItem from '@mui/material/MenuItem';
import Button from '@mui/material/Button';
import Checkbox from '@mui/material/Checkbox';
import Radio from '@mui/material/Radio';
import Paper from '@mui/material/Paper';
import Toolbar from '@mui/material/Toolbar';
import useMediaQuery from '@mui/material/useMediaQuery';
import Collapse from '@mui/material/Collapse';
import InputAdornment from '@mui/material/InputAdornment';
import TextField from '@mui/material/TextField';
import { debounce } from '@mui/material/utils';
import LinearProgress from '@mui/material/LinearProgress';
import TablePagination from '@mui/material/TablePagination';
import Alert from '@mui/material/Alert';
import AlertTitle from '@mui/material/AlertTitle';
import Chip from '@mui/material/Chip';
import Divider from '@mui/material/Divider';
import FormControlLabel from '@mui/material/FormControlLabel';
import Switch from '@mui/material/Switch';
import Typography from '@mui/material/Typography';
import Fade from '@mui/material/Fade';
import TableContainer from '@mui/material/TableContainer';
import { useVirtualizer, defaultRangeExtractor } from '@tanstack/react-virtual';
import Table from '@mui/material/Table';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import TableCell from '@mui/material/TableCell';
import Slider from '@mui/material/Slider';
import Stack from '@mui/material/Stack';
import FormHelperText from '@mui/material/FormHelperText';
import Badge from '@mui/material/Badge';
import TableSortLabel from '@mui/material/TableSortLabel';
import TableBody from '@mui/material/TableBody';
import Skeleton from '@mui/material/Skeleton';
import highlightWords from 'highlight-words';
import TableFooter from '@mui/material/TableFooter';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogTitle from '@mui/material/DialogTitle';

/******************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */
function __rest(s, e) {
  var t = {};
  for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
  }
  return t;
}
var MRT_AggregationFns = Object.assign({}, aggregationFns);
var fuzzy$1 = function fuzzy$1(row, columnId, filterValue, addMeta) {
  var itemRank = rankItem(row.getValue(columnId), filterValue, {
    threshold: rankings.MATCHES
  });
  addMeta(itemRank);
  return itemRank.passed;
};
fuzzy$1.autoRemove = function (val) {
  return !val;
};
var contains = function contains(row, id, filterValue) {
  return row.getValue(id).toString().toLowerCase().trim().includes(filterValue.toString().toLowerCase().trim());
};
contains.autoRemove = function (val) {
  return !val;
};
var startsWith = function startsWith(row, id, filterValue) {
  return row.getValue(id).toString().toLowerCase().trim().startsWith(filterValue.toString().toLowerCase().trim());
};
startsWith.autoRemove = function (val) {
  return !val;
};
var endsWith = function endsWith(row, id, filterValue) {
  return row.getValue(id).toString().toLowerCase().trim().endsWith(filterValue.toString().toLowerCase().trim());
};
endsWith.autoRemove = function (val) {
  return !val;
};
var equals = function equals(row, id, filterValue) {
  return row.getValue(id).toString().toLowerCase().trim() === filterValue.toString().toLowerCase().trim();
};
equals.autoRemove = function (val) {
  return !val;
};
var notEquals = function notEquals(row, id, filterValue) {
  return row.getValue(id).toString().toLowerCase().trim() !== filterValue.toString().toLowerCase().trim();
};
notEquals.autoRemove = function (val) {
  return !val;
};
var greaterThan = function greaterThan(row, id, filterValue) {
  return !isNaN(+filterValue) && !isNaN(+row.getValue(id)) ? +row.getValue(id) > +filterValue : row.getValue(id).toString().toLowerCase().trim() > filterValue.toString().toLowerCase().trim();
};
greaterThan.autoRemove = function (val) {
  return !val;
};
var greaterThanOrEqualTo = function greaterThanOrEqualTo(row, id, filterValue) {
  return equals(row, id, filterValue) || greaterThan(row, id, filterValue);
};
greaterThanOrEqualTo.autoRemove = function (val) {
  return !val;
};
var lessThan = function lessThan(row, id, filterValue) {
  return !isNaN(+filterValue) && !isNaN(+row.getValue(id)) ? +row.getValue(id) < +filterValue : row.getValue(id).toString().toLowerCase().trim() < filterValue.toString().toLowerCase().trim();
};
lessThan.autoRemove = function (val) {
  return !val;
};
var lessThanOrEqualTo = function lessThanOrEqualTo(row, id, filterValue) {
  return equals(row, id, filterValue) || lessThan(row, id, filterValue);
};
lessThanOrEqualTo.autoRemove = function (val) {
  return !val;
};
var between = function between(row, id, filterValues) {
  return (['', undefined].includes(filterValues[0]) || greaterThan(row, id, filterValues[0])) && (!isNaN(+filterValues[0]) && !isNaN(+filterValues[1]) && +filterValues[0] > +filterValues[1] || ['', undefined].includes(filterValues[1]) || lessThan(row, id, filterValues[1]));
};
between.autoRemove = function (val) {
  return !val;
};
var betweenInclusive = function betweenInclusive(row, id, filterValues) {
  return (['', undefined].includes(filterValues[0]) || greaterThanOrEqualTo(row, id, filterValues[0])) && (!isNaN(+filterValues[0]) && !isNaN(+filterValues[1]) && +filterValues[0] > +filterValues[1] || ['', undefined].includes(filterValues[1]) || lessThanOrEqualTo(row, id, filterValues[1]));
};
betweenInclusive.autoRemove = function (val) {
  return !val;
};
var empty = function empty(row, id, _filterValue) {
  return !row.getValue(id).toString().trim();
};
empty.autoRemove = function (val) {
  return !val;
};
var notEmpty = function notEmpty(row, id, _filterValue) {
  return !!row.getValue(id).toString().trim();
};
notEmpty.autoRemove = function (val) {
  return !val;
};
var MRT_FilterFns = Object.assign(Object.assign({}, filterFns), {
  between: between,
  betweenInclusive: betweenInclusive,
  contains: contains,
  empty: empty,
  endsWith: endsWith,
  equals: equals,
  fuzzy: fuzzy$1,
  greaterThan: greaterThan,
  greaterThanOrEqualTo: greaterThanOrEqualTo,
  lessThan: lessThan,
  lessThanOrEqualTo: lessThanOrEqualTo,
  notEmpty: notEmpty,
  notEquals: notEquals,
  startsWith: startsWith
});
var fuzzy = function fuzzy(rowA, rowB, columnId) {
  var dir = 0;
  if (rowA.columnFiltersMeta[columnId]) {
    dir = compareItems(rowA.columnFiltersMeta[columnId], rowB.columnFiltersMeta[columnId]);
  }
  // Provide a fallback for when the item ranks are equal
  return dir === 0 ? sortingFns.alphanumeric(rowA, rowB, columnId) : dir;
};
var MRT_SortingFns = Object.assign(Object.assign({}, sortingFns), {
  fuzzy: fuzzy
});
var rankGlobalFuzzy = function rankGlobalFuzzy(rowA, rowB) {
  return Math.max.apply(Math, _toConsumableArray(Object.values(rowB.columnFiltersMeta).map(function (v) {
    return v.rank;
  }))) - Math.max.apply(Math, _toConsumableArray(Object.values(rowA.columnFiltersMeta).map(function (v) {
    return v.rank;
  })));
};
var getColumnId = function getColumnId(columnDef) {
  var _a, _b, _c, _d;
  return (_d = (_a = columnDef.id) !== null && _a !== void 0 ? _a : (_c = (_b = columnDef.accessorKey) === null || _b === void 0 ? void 0 : _b.toString) === null || _c === void 0 ? void 0 : _c.call(_b)) !== null && _d !== void 0 ? _d : columnDef.header;
};
var getAllLeafColumnDefs = function getAllLeafColumnDefs(columns) {
  var allLeafColumnDefs = [];
  var getLeafColumns = function getLeafColumns(cols) {
    cols.forEach(function (col) {
      if (col.columns) {
        getLeafColumns(col.columns);
      } else {
        allLeafColumnDefs.push(col);
      }
    });
  };
  getLeafColumns(columns);
  return allLeafColumnDefs;
};
var prepareColumns = function prepareColumns(_ref) {
  var aggregationFns = _ref.aggregationFns,
    columnDefs = _ref.columnDefs,
    columnFilterFns = _ref.columnFilterFns,
    defaultDisplayColumn = _ref.defaultDisplayColumn,
    filterFns = _ref.filterFns,
    sortingFns = _ref.sortingFns;
  return columnDefs.map(function (columnDef) {
    var _a, _b;
    //assign columnId
    if (!columnDef.id) columnDef.id = getColumnId(columnDef);
    if (process.env.NODE_ENV !== 'production' && !columnDef.id) {
      console.error('Column definitions must have a valid `accessorKey` or `id` property');
    }
    //assign columnDefType
    if (!columnDef.columnDefType) columnDef.columnDefType = 'data';
    if ((_a = columnDef.columns) === null || _a === void 0 ? void 0 : _a.length) {
      columnDef.columnDefType = 'group';
      //recursively prepare columns if this is a group column
      columnDef.columns = prepareColumns({
        aggregationFns: aggregationFns,
        columnDefs: columnDef.columns,
        columnFilterFns: columnFilterFns,
        defaultDisplayColumn: defaultDisplayColumn,
        filterFns: filterFns,
        sortingFns: sortingFns
      });
    } else if (columnDef.columnDefType === 'data') {
      //assign aggregationFns if multiple aggregationFns are provided
      if (Array.isArray(columnDef.aggregationFn)) {
        var aggFns = columnDef.aggregationFn;
        columnDef.aggregationFn = function (columnId, leafRows, childRows) {
          return aggFns.map(function (fn) {
            var _a;
            return (_a = aggregationFns[fn]) === null || _a === void 0 ? void 0 : _a.call(aggregationFns, columnId, leafRows, childRows);
          });
        };
      }
      //assign filterFns
      if (Object.keys(filterFns).includes(columnFilterFns[columnDef.id])) {
        columnDef.filterFn = (_b = filterFns[columnFilterFns[columnDef.id]]) !== null && _b !== void 0 ? _b : filterFns.fuzzy;
        columnDef._filterFn = columnFilterFns[columnDef.id];
      }
      //assign sortingFns
      if (Object.keys(sortingFns).includes(columnDef.sortingFn)) {
        // @ts-ignore
        columnDef.sortingFn = sortingFns[columnDef.sortingFn];
      }
    } else if (columnDef.columnDefType === 'display') {
      columnDef = Object.assign(Object.assign({}, defaultDisplayColumn), columnDef);
    }
    return columnDef;
  });
};
var reorderColumn = function reorderColumn(draggedColumn, targetColumn, columnOrder) {
  if (draggedColumn.getCanPin()) {
    draggedColumn.pin(targetColumn.getIsPinned());
  }
  var newColumnOrder = _toConsumableArray(columnOrder);
  newColumnOrder.splice(newColumnOrder.indexOf(targetColumn.id), 0, newColumnOrder.splice(newColumnOrder.indexOf(draggedColumn.id), 1)[0]);
  return newColumnOrder;
};
var showExpandColumn = function showExpandColumn(props, grouping) {
  return !!(props.enableExpanding || props.enableGrouping && (grouping === undefined || (grouping === null || grouping === void 0 ? void 0 : grouping.length)) || props.renderDetailPanel);
};
var getLeadingDisplayColumnIds = function getLeadingDisplayColumnIds(props) {
  var _a;
  return [(props.enableRowDragging || props.enableRowOrdering) && 'mrt-row-drag', props.positionActionsColumn === 'first' && (props.enableRowActions || props.enableEditing && ['row', 'modal'].includes((_a = props.editingMode) !== null && _a !== void 0 ? _a : '')) && 'mrt-row-actions', props.positionExpandColumn === 'first' && showExpandColumn(props) && 'mrt-row-expand', props.enableRowSelection && 'mrt-row-select', props.enableRowNumbers && 'mrt-row-numbers'].filter(Boolean);
};
var getTrailingDisplayColumnIds = function getTrailingDisplayColumnIds(props) {
  var _a;
  return [props.positionActionsColumn === 'last' && (props.enableRowActions || props.enableEditing && ['row', 'modal'].includes((_a = props.editingMode) !== null && _a !== void 0 ? _a : '')) && 'mrt-row-actions', props.positionExpandColumn === 'last' && showExpandColumn(props) && 'mrt-row-expand'].filter(Boolean);
};
var getDefaultColumnOrderIds = function getDefaultColumnOrderIds(props) {
  var leadingDisplayCols = getLeadingDisplayColumnIds(props);
  var trailingDisplayCols = getTrailingDisplayColumnIds(props);
  var allLeafColumnDefs = getAllLeafColumnDefs(props.columns).map(function (columnDef) {
    return getColumnId(columnDef);
  }).filter(function (columnId) {
    return !leadingDisplayCols.includes(columnId) && !trailingDisplayCols.includes(columnId);
  });
  return [].concat(_toConsumableArray(leadingDisplayCols), _toConsumableArray(allLeafColumnDefs), _toConsumableArray(trailingDisplayCols));
};
var getDefaultColumnFilterFn = function getDefaultColumnFilterFn(columnDef) {
  if (columnDef.filterVariant === 'multi-select') return 'arrIncludesSome';
  if (columnDef.filterVariant === 'range' || columnDef.filterVariant === 'range-slider') return 'betweenInclusive';
  if (columnDef.filterVariant === 'select' || columnDef.filterVariant === 'checkbox') return 'equals';
  return 'fuzzy';
};
var getIsFirstColumn = function getIsFirstColumn(column, table) {
  return table.getVisibleLeafColumns()[0].id === column.id;
};
var getIsLastColumn = function getIsLastColumn(column, table) {
  var columns = table.getVisibleLeafColumns();
  return columns[columns.length - 1].id === column.id;
};
var getIsLastLeftPinnedColumn = function getIsLastLeftPinnedColumn(table, column) {
  return column.getIsPinned() === 'left' && table.getLeftLeafHeaders().length - 1 === column.getPinnedIndex();
};
var getIsFirstRightPinnedColumn = function getIsFirstRightPinnedColumn(column) {
  return column.getIsPinned() === 'right' && column.getPinnedIndex() === 0;
};
var getTotalRight = function getTotalRight(table, column) {
  return table.getRightLeafHeaders().slice(column.getPinnedIndex() + 1).reduce(function (acc, col) {
    return acc + col.getSize();
  }, 0);
};
var getCommonCellStyles = function getCommonCellStyles(_ref2) {
  var column = _ref2.column,
    header = _ref2.header,
    table = _ref2.table,
    tableCellProps = _ref2.tableCellProps,
    theme = _ref2.theme;
  var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k;
  var widthStyles = {
    minWidth: "max(calc(var(--".concat(header ? 'header' : 'col', "-").concat(parseCSSVarId((_a = header === null || header === void 0 ? void 0 : header.id) !== null && _a !== void 0 ? _a : column.id), "-size) * 1px), ").concat((_b = column.columnDef.minSize) !== null && _b !== void 0 ? _b : 30, "px)"),
    width: "calc(var(--".concat(header ? 'header' : 'col', "-").concat(parseCSSVarId((_c = header === null || header === void 0 ? void 0 : header.id) !== null && _c !== void 0 ? _c : column.id), "-size) * 1px)")
  };
  return Object.assign(Object.assign(Object.assign({
    backgroundColor: column.getIsPinned() && column.columnDef.columnDefType !== 'group' ? alpha(lighten(theme.palette.background.default, 0.04), 0.97) : 'inherit',
    backgroundImage: 'inherit',
    boxShadow: getIsLastLeftPinnedColumn(table, column) ? "-4px 0 8px -6px ".concat(alpha(theme.palette.common.black, 0.2), " inset") : getIsFirstRightPinnedColumn(column) ? "4px 0 8px -6px ".concat(alpha(theme.palette.common.black, 0.2), " inset") : undefined,
    display: table.options.layoutMode === 'grid' ? 'flex' : 'table-cell',
    flex: table.options.layoutMode === 'grid' ? "var(--".concat(header ? 'header' : 'col', "-").concat(parseCSSVarId((_d = header === null || header === void 0 ? void 0 : header.id) !== null && _d !== void 0 ? _d : column.id), "-size) 0 auto") : undefined,
    left: column.getIsPinned() === 'left' ? "".concat(column.getStart('left'), "px") : undefined,
    ml: table.options.enableColumnVirtualization && column.getIsPinned() === 'left' && column.getPinnedIndex() === 0 ? "-".concat(column.getSize() * ((_f = (_e = table.getState().columnPinning.left) === null || _e === void 0 ? void 0 : _e.length) !== null && _f !== void 0 ? _f : 1), "px") : undefined,
    mr: table.options.enableColumnVirtualization && column.getIsPinned() === 'right' && column.getPinnedIndex() === table.getVisibleLeafColumns().length - 1 ? "-".concat(column.getSize() * ((_h = (_g = table.getState().columnPinning.right) === null || _g === void 0 ? void 0 : _g.length) !== null && _h !== void 0 ? _h : 1) * 1.2, "px") : undefined,
    opacity: ((_j = table.getState().draggingColumn) === null || _j === void 0 ? void 0 : _j.id) === column.id || ((_k = table.getState().hoveredColumn) === null || _k === void 0 ? void 0 : _k.id) === column.id ? 0.5 : 1,
    position: column.getIsPinned() && column.columnDef.columnDefType !== 'group' ? 'sticky' : undefined,
    right: column.getIsPinned() === 'right' ? "".concat(getTotalRight(table, column), "px") : undefined,
    transition: table.options.enableColumnVirtualization ? 'none' : "padding 150ms ease-in-out"
  }, !table.options.enableColumnResizing && widthStyles), (tableCellProps === null || tableCellProps === void 0 ? void 0 : tableCellProps.sx) instanceof Function ? tableCellProps.sx(theme) : tableCellProps === null || tableCellProps === void 0 ? void 0 : tableCellProps.sx), table.options.enableColumnResizing && widthStyles);
};
var MRT_DefaultColumn = {
  filterVariant: 'text',
  minSize: 40,
  maxSize: 1000,
  size: 180
};
var MRT_DefaultDisplayColumn = {
  columnDefType: 'display',
  enableClickToCopy: false,
  enableColumnActions: false,
  enableColumnDragging: false,
  enableColumnFilter: false,
  enableColumnOrdering: false,
  enableEditing: false,
  enableGlobalFilter: false,
  enableGrouping: false,
  enableHiding: false,
  enableResizing: false,
  enableSorting: false
};
var parseCSSVarId = function parseCSSVarId(id) {
  return id.replace(/[^a-zA-Z0-9]/g, '_');
};
var MRT_Default_Icons = {
  ArrowDownwardIcon: ArrowDownwardIcon,
  ArrowRightIcon: ArrowRightIcon,
  CancelIcon: CancelIcon,
  ClearAllIcon: ClearAllIcon,
  CloseIcon: CloseIcon,
  DensityLargeIcon: DensityLargeIcon,
  DensityMediumIcon: DensityMediumIcon,
  DensitySmallIcon: DensitySmallIcon,
  DragHandleIcon: DragHandleIcon,
  DynamicFeedIcon: DynamicFeedIcon,
  EditIcon: EditIcon,
  ExpandMoreIcon: ExpandMoreIcon,
  FilterAltIcon: FilterAltIcon,
  FilterListIcon: FilterListIcon,
  FilterListOffIcon: FilterListOffIcon,
  FullscreenExitIcon: FullscreenExitIcon,
  FullscreenIcon: FullscreenIcon,
  KeyboardDoubleArrowDownIcon: KeyboardDoubleArrowDownIcon,
  MoreHorizIcon: MoreHorizIcon,
  MoreVertIcon: MoreVertIcon,
  PushPinIcon: PushPinIcon,
  RestartAltIcon: RestartAltIcon,
  SaveIcon: SaveIcon,
  SearchIcon: SearchIcon,
  SearchOffIcon: SearchOffIcon,
  SortIcon: SortIcon,
  ViewColumnIcon: ViewColumnIcon,
  VisibilityOffIcon: VisibilityOffIcon
};
var MRT_Localization_EN = {
  actions: 'Actions',
  and: 'and',
  cancel: 'Cancel',
  changeFilterMode: 'Change filter mode',
  changeSearchMode: 'Change search mode',
  clearFilter: 'Clear filter',
  clearSearch: 'Clear search',
  clearSort: 'Clear sort',
  clickToCopy: 'Click to copy',
  collapse: 'Collapse',
  collapseAll: 'Collapse all',
  columnActions: 'Column Actions',
  copiedToClipboard: 'Copied to clipboard',
  dropToGroupBy: 'Drop to group by {column}',
  edit: 'Edit',
  expand: 'Expand',
  expandAll: 'Expand all',
  filterArrIncludes: 'Includes',
  filterArrIncludesAll: 'Includes all',
  filterArrIncludesSome: 'Includes',
  filterBetween: 'Between',
  filterBetweenInclusive: 'Between Inclusive',
  filterByColumn: 'Filter by {column}',
  filterContains: 'Contains',
  filterEmpty: 'Empty',
  filterEndsWith: 'Ends With',
  filterEquals: 'Equals',
  filterEqualsString: 'Equals',
  filterFuzzy: 'Fuzzy',
  filterGreaterThan: 'Greater Than',
  filterGreaterThanOrEqualTo: 'Greater Than Or Equal To',
  filterInNumberRange: 'Between',
  filterIncludesString: 'Contains',
  filterIncludesStringSensitive: 'Contains',
  filterLessThan: 'Less Than',
  filterLessThanOrEqualTo: 'Less Than Or Equal To',
  filterMode: 'Filter Mode: {filterType}',
  filterNotEmpty: 'Not Empty',
  filterNotEquals: 'Not Equals',
  filterStartsWith: 'Starts With',
  filterWeakEquals: 'Equals',
  filteringByColumn: 'Filtering by {column} - {filterType} {filterValue}',
  goToFirstPage: 'Go to first page',
  goToLastPage: 'Go to last page',
  goToNextPage: 'Go to next page',
  goToPreviousPage: 'Go to previous page',
  grab: 'Grab',
  groupByColumn: 'Group by {column}',
  groupedBy: 'Grouped by ',
  hideAll: 'Hide all',
  hideColumn: 'Hide {column} column',
  max: 'Max',
  min: 'Min',
  move: 'Move',
  noRecordsToDisplay: 'No records to display',
  noResultsFound: 'No results found',
  of: 'of',
  or: 'or',
  pinToLeft: 'Pin to left',
  pinToRight: 'Pin to right',
  resetColumnSize: 'Reset column size',
  resetOrder: 'Reset order',
  rowActions: 'Row Actions',
  rowNumber: '#',
  rowNumbers: 'Row Numbers',
  rowsPerPage: 'Rows per page',
  save: 'Save',
  search: 'Search',
  selectedCountOfRowCountRowsSelected: '{selectedCount} of {rowCount} row(s) selected',
  select: 'Select',
  showAll: 'Show all',
  showAllColumns: 'Show all columns',
  showHideColumns: 'Show/Hide columns',
  showHideFilters: 'Show/Hide filters',
  showHideSearch: 'Show/Hide search',
  sortByColumnAsc: 'Sort by {column} ascending',
  sortByColumnDesc: 'Sort by {column} descending',
  sortedByColumnAsc: 'Sorted by {column} ascending',
  sortedByColumnDesc: 'Sorted by {column} descending',
  thenBy: ', then by ',
  toggleDensity: 'Toggle density',
  toggleFullScreen: 'Toggle full screen',
  toggleSelectAll: 'Toggle select all',
  toggleSelectRow: 'Toggle select row',
  toggleVisibility: 'Toggle visibility',
  ungroupByColumn: 'Ungroup by {column}',
  unpin: 'Unpin',
  unpinAll: 'Unpin all',
  unsorted: 'Unsorted'
};
var MRT_ExpandAllButton = function MRT_ExpandAllButton(_ref3) {
  var table = _ref3.table;
  var _a, _b;
  var getIsAllRowsExpanded = table.getIsAllRowsExpanded,
    getIsSomeRowsExpanded = table.getIsSomeRowsExpanded,
    getCanSomeRowsExpand = table.getCanSomeRowsExpand,
    getState = table.getState,
    _table$options = table.options,
    KeyboardDoubleArrowDownIcon = _table$options.icons.KeyboardDoubleArrowDownIcon,
    localization = _table$options.localization,
    muiExpandAllButtonProps = _table$options.muiExpandAllButtonProps,
    renderDetailPanel = _table$options.renderDetailPanel,
    toggleAllRowsExpanded = table.toggleAllRowsExpanded;
  var _getState = getState(),
    density = _getState.density,
    isLoading = _getState.isLoading;
  var iconButtonProps = muiExpandAllButtonProps instanceof Function ? muiExpandAllButtonProps({
    table: table
  }) : muiExpandAllButtonProps;
  var isAllRowsExpanded = getIsAllRowsExpanded();
  return jsx(Tooltip, {
    arrow: true,
    enterDelay: 1000,
    enterNextDelay: 1000,
    title: ((_a = iconButtonProps === null || iconButtonProps === void 0 ? void 0 : iconButtonProps.title) !== null && _a !== void 0 ? _a : isAllRowsExpanded) ? localization.collapseAll : localization.expandAll,
    children: jsx("span", {
      children: jsx(IconButton, Object.assign({
        "aria-label": localization.expandAll,
        disabled: isLoading || !renderDetailPanel && !getCanSomeRowsExpand(),
        onClick: function onClick() {
          return toggleAllRowsExpanded(!isAllRowsExpanded);
        }
      }, iconButtonProps, {
        sx: function sx(theme) {
          return Object.assign({
            height: density === 'compact' ? '1.75rem' : '2.25rem',
            width: density === 'compact' ? '1.75rem' : '2.25rem',
            mt: density !== 'compact' ? '-0.25rem' : undefined
          }, (iconButtonProps === null || iconButtonProps === void 0 ? void 0 : iconButtonProps.sx) instanceof Function ? iconButtonProps === null || iconButtonProps === void 0 ? void 0 : iconButtonProps.sx(theme) : iconButtonProps === null || iconButtonProps === void 0 ? void 0 : iconButtonProps.sx);
        },
        title: undefined,
        children: (_b = iconButtonProps === null || iconButtonProps === void 0 ? void 0 : iconButtonProps.children) !== null && _b !== void 0 ? _b : jsx(KeyboardDoubleArrowDownIcon, {
          style: {
            transform: "rotate(".concat(isAllRowsExpanded ? -180 : getIsSomeRowsExpanded() ? -90 : 0, "deg)"),
            transition: 'transform 150ms'
          }
        })
      }))
    })
  });
};
var MRT_ExpandButton = function MRT_ExpandButton(_ref4) {
  var row = _ref4.row,
    table = _ref4.table;
  var _a, _b;
  var getState = table.getState,
    _table$options2 = table.options,
    ExpandMoreIcon = _table$options2.icons.ExpandMoreIcon,
    localization = _table$options2.localization,
    muiExpandButtonProps = _table$options2.muiExpandButtonProps,
    renderDetailPanel = _table$options2.renderDetailPanel;
  var _getState2 = getState(),
    density = _getState2.density;
  var iconButtonProps = muiExpandButtonProps instanceof Function ? muiExpandButtonProps({
    table: table,
    row: row
  }) : muiExpandButtonProps;
  var canExpand = row.getCanExpand();
  var isExpanded = row.getIsExpanded();
  var handleToggleExpand = function handleToggleExpand(event) {
    var _a;
    event.stopPropagation();
    row.toggleExpanded();
    (_a = iconButtonProps === null || iconButtonProps === void 0 ? void 0 : iconButtonProps.onClick) === null || _a === void 0 ? void 0 : _a.call(iconButtonProps, event);
  };
  return jsx(Tooltip, {
    arrow: true,
    disableHoverListener: !canExpand && !renderDetailPanel,
    enterDelay: 1000,
    enterNextDelay: 1000,
    title: ((_a = iconButtonProps === null || iconButtonProps === void 0 ? void 0 : iconButtonProps.title) !== null && _a !== void 0 ? _a : isExpanded) ? localization.collapse : localization.expand,
    children: jsx("span", {
      children: jsx(IconButton, Object.assign({
        "aria-label": localization.expand,
        disabled: !canExpand && !renderDetailPanel
      }, iconButtonProps, {
        onClick: handleToggleExpand,
        sx: function sx(theme) {
          return Object.assign({
            height: density === 'compact' ? '1.75rem' : '2.25rem',
            width: density === 'compact' ? '1.75rem' : '2.25rem'
          }, (iconButtonProps === null || iconButtonProps === void 0 ? void 0 : iconButtonProps.sx) instanceof Function ? iconButtonProps.sx(theme) : iconButtonProps === null || iconButtonProps === void 0 ? void 0 : iconButtonProps.sx);
        },
        title: undefined,
        children: (_b = iconButtonProps === null || iconButtonProps === void 0 ? void 0 : iconButtonProps.children) !== null && _b !== void 0 ? _b : jsx(ExpandMoreIcon, {
          style: {
            transform: "rotate(".concat(!canExpand && !renderDetailPanel ? -90 : isExpanded ? -180 : 0, "deg)"),
            transition: 'transform 150ms'
          }
        })
      }))
    })
  });
};
var mrtFilterOptions = function mrtFilterOptions(localization) {
  return [{
    option: 'fuzzy',
    symbol: '≈',
    label: localization.filterFuzzy,
    divider: false
  }, {
    option: 'contains',
    symbol: '*',
    label: localization.filterContains,
    divider: false
  }, {
    option: 'startsWith',
    symbol: 'a',
    label: localization.filterStartsWith,
    divider: false
  }, {
    option: 'endsWith',
    symbol: 'z',
    label: localization.filterEndsWith,
    divider: true
  }, {
    option: 'equals',
    symbol: '=',
    label: localization.filterEquals,
    divider: false
  }, {
    option: 'notEquals',
    symbol: '≠',
    label: localization.filterNotEquals,
    divider: true
  }, {
    option: 'between',
    symbol: '⇿',
    label: localization.filterBetween,
    divider: false
  }, {
    option: 'betweenInclusive',
    symbol: '⬌',
    label: localization.filterBetweenInclusive,
    divider: true
  }, {
    option: 'greaterThan',
    symbol: '>',
    label: localization.filterGreaterThan,
    divider: false
  }, {
    option: 'greaterThanOrEqualTo',
    symbol: '≥',
    label: localization.filterGreaterThanOrEqualTo,
    divider: false
  }, {
    option: 'lessThan',
    symbol: '<',
    label: localization.filterLessThan,
    divider: false
  }, {
    option: 'lessThanOrEqualTo',
    symbol: '≤',
    label: localization.filterLessThanOrEqualTo,
    divider: true
  }, {
    option: 'empty',
    symbol: '∅',
    label: localization.filterEmpty,
    divider: false
  }, {
    option: 'notEmpty',
    symbol: '!∅',
    label: localization.filterNotEmpty,
    divider: false
  }];
};
var rangeModes = ['between', 'betweenInclusive', 'inNumberRange'];
var emptyModes = ['empty', 'notEmpty'];
var arrModes = ['arrIncludesSome', 'arrIncludesAll', 'arrIncludes'];
var MRT_FilterOptionMenu = function MRT_FilterOptionMenu(_ref5) {
  var anchorEl = _ref5.anchorEl,
    header = _ref5.header,
    onSelect = _ref5.onSelect,
    setAnchorEl = _ref5.setAnchorEl,
    setFilterValue = _ref5.setFilterValue,
    table = _ref5.table;
  var _a, _b, _c, _d;
  var getState = table.getState,
    _table$options3 = table.options,
    columnFilterModeOptions = _table$options3.columnFilterModeOptions,
    globalFilterModeOptions = _table$options3.globalFilterModeOptions,
    localization = _table$options3.localization,
    renderColumnFilterModeMenuItems = _table$options3.renderColumnFilterModeMenuItems,
    renderGlobalFilterModeMenuItems = _table$options3.renderGlobalFilterModeMenuItems,
    setColumnFilterFns = table.setColumnFilterFns,
    setGlobalFilterFn = table.setGlobalFilterFn;
  var _getState3 = getState(),
    globalFilterFn = _getState3.globalFilterFn,
    density = _getState3.density;
  var _ref6 = header !== null && header !== void 0 ? header : {},
    column = _ref6.column;
  var _ref7 = column !== null && column !== void 0 ? column : {},
    columnDef = _ref7.columnDef;
  var currentFilterValue = column === null || column === void 0 ? void 0 : column.getFilterValue();
  var allowedColumnFilterOptions = (_a = columnDef === null || columnDef === void 0 ? void 0 : columnDef.columnFilterModeOptions) !== null && _a !== void 0 ? _a : columnFilterModeOptions;
  if ((columnDef === null || columnDef === void 0 ? void 0 : columnDef.filterVariant) === 'range-slider') {
    allowedColumnFilterOptions = [].concat(rangeModes, _toConsumableArray(allowedColumnFilterOptions !== null && allowedColumnFilterOptions !== void 0 ? allowedColumnFilterOptions : [])).filter(function (option) {
      return rangeModes.includes(option);
    });
  }
  var internalFilterOptions = useMemo(function () {
    return mrtFilterOptions(localization).filter(function (filterOption) {
      return columnDef ? allowedColumnFilterOptions === undefined || (allowedColumnFilterOptions === null || allowedColumnFilterOptions === void 0 ? void 0 : allowedColumnFilterOptions.includes(filterOption.option)) : (!globalFilterModeOptions || globalFilterModeOptions.includes(filterOption.option)) && ['fuzzy', 'contains', 'startsWith'].includes(filterOption.option);
    });
  }, []);
  var handleSelectFilterMode = function handleSelectFilterMode(option) {
    var _a;
    var prevFilterMode = (_a = columnDef === null || columnDef === void 0 ? void 0 : columnDef._filterFn) !== null && _a !== void 0 ? _a : '';
    if (!header || !column) {
      // global filter mode
      setGlobalFilterFn(option);
    } else if (option !== prevFilterMode) {
      // column filter mode
      setColumnFilterFns(function (prev) {
        return Object.assign(Object.assign({}, prev), _defineProperty({}, header.id, option));
      });
      // reset filter value and/or perform new filter render
      if (emptyModes.includes(option)) {
        // will now be empty/notEmpty filter mode
        if (currentFilterValue !== ' ' && !emptyModes.includes(prevFilterMode)) {
          column.setFilterValue(' ');
        } else if (currentFilterValue) {
          column.setFilterValue(currentFilterValue); // perform new filter render
        }
      } else if ((columnDef === null || columnDef === void 0 ? void 0 : columnDef.filterVariant) === 'multi-select' || arrModes.includes(option)) {
        // will now be array filter mode
        if (currentFilterValue instanceof String || (currentFilterValue === null || currentFilterValue === void 0 ? void 0 : currentFilterValue.length)) {
          column.setFilterValue([]);
          setFilterValue === null || setFilterValue === void 0 ? void 0 : setFilterValue([]);
        } else if (currentFilterValue) {
          column.setFilterValue(currentFilterValue); // perform new filter render
        }
      } else if ((columnDef === null || columnDef === void 0 ? void 0 : columnDef.filterVariant) === 'range' || rangeModes.includes(option)) {
        // will now be range filter mode
        if (!Array.isArray(currentFilterValue) || !(currentFilterValue === null || currentFilterValue === void 0 ? void 0 : currentFilterValue.every(function (v) {
          return v === '';
        })) && !rangeModes.includes(prevFilterMode)) {
          column.setFilterValue(['', '']);
          setFilterValue === null || setFilterValue === void 0 ? void 0 : setFilterValue('');
        } else {
          column.setFilterValue(currentFilterValue); // perform new filter render
        }
      } else {
        // will now be single value filter mode
        if (Array.isArray(currentFilterValue)) {
          column.setFilterValue('');
          setFilterValue === null || setFilterValue === void 0 ? void 0 : setFilterValue('');
        } else {
          column.setFilterValue(currentFilterValue); // perform new filter render
        }
      }
    }
    setAnchorEl(null);
    onSelect === null || onSelect === void 0 ? void 0 : onSelect();
  };
  var filterOption = !!header && columnDef ? columnDef._filterFn : globalFilterFn;
  return jsx(Menu, {
    anchorEl: anchorEl,
    anchorOrigin: {
      vertical: 'center',
      horizontal: 'right'
    },
    onClose: function onClose() {
      return setAnchorEl(null);
    },
    open: !!anchorEl,
    MenuListProps: {
      dense: density === 'compact'
    },
    children: (_d = header && column && columnDef ? (_c = (_b = columnDef.renderColumnFilterModeMenuItems) === null || _b === void 0 ? void 0 : _b.call(columnDef, {
      column: column,
      internalFilterOptions: internalFilterOptions,
      onSelectFilterMode: handleSelectFilterMode,
      table: table
    })) !== null && _c !== void 0 ? _c : renderColumnFilterModeMenuItems === null || renderColumnFilterModeMenuItems === void 0 ? void 0 : renderColumnFilterModeMenuItems({
      column: column,
      internalFilterOptions: internalFilterOptions,
      onSelectFilterMode: handleSelectFilterMode,
      table: table
    }) : renderGlobalFilterModeMenuItems === null || renderGlobalFilterModeMenuItems === void 0 ? void 0 : renderGlobalFilterModeMenuItems({
      internalFilterOptions: internalFilterOptions,
      onSelectFilterMode: handleSelectFilterMode,
      table: table
    })) !== null && _d !== void 0 ? _d : internalFilterOptions.map(function (_ref8, index) {
      var option = _ref8.option,
        label = _ref8.label,
        divider = _ref8.divider,
        symbol = _ref8.symbol;
      return jsxs(MenuItem, {
        divider: divider,
        onClick: function onClick() {
          return handleSelectFilterMode(option);
        },
        selected: option === filterOption,
        sx: {
          alignItems: 'center',
          display: 'flex',
          gap: '2ch',
          my: 0,
          py: '6px'
        },
        value: option,
        children: [jsx(Box, {
          sx: {
            fontSize: '1.25rem',
            width: '2ch'
          },
          children: symbol
        }), label]
      }, index);
    })
  });
};
var commonMenuItemStyles = {
  py: '6px',
  my: 0,
  justifyContent: 'space-between',
  alignItems: 'center'
};
var commonListItemStyles = {
  display: 'flex',
  alignItems: 'center'
};
var MRT_ColumnActionMenu = function MRT_ColumnActionMenu(_ref9) {
  var anchorEl = _ref9.anchorEl,
    header = _ref9.header,
    setAnchorEl = _ref9.setAnchorEl,
    table = _ref9.table;
  var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k;
  var getState = table.getState,
    toggleAllColumnsVisible = table.toggleAllColumnsVisible,
    setColumnOrder = table.setColumnOrder,
    _table$options4 = table.options,
    columnFilterModeOptions = _table$options4.columnFilterModeOptions,
    enableColumnFilterModes = _table$options4.enableColumnFilterModes,
    enableColumnFilters = _table$options4.enableColumnFilters,
    enableColumnResizing = _table$options4.enableColumnResizing,
    enableGrouping = _table$options4.enableGrouping,
    enableHiding = _table$options4.enableHiding,
    enablePinning = _table$options4.enablePinning,
    enableSorting = _table$options4.enableSorting,
    enableSortingRemoval = _table$options4.enableSortingRemoval,
    _table$options4$icons = _table$options4.icons,
    ArrowRightIcon = _table$options4$icons.ArrowRightIcon,
    ClearAllIcon = _table$options4$icons.ClearAllIcon,
    ViewColumnIcon = _table$options4$icons.ViewColumnIcon,
    DynamicFeedIcon = _table$options4$icons.DynamicFeedIcon,
    FilterListIcon = _table$options4$icons.FilterListIcon,
    FilterListOffIcon = _table$options4$icons.FilterListOffIcon,
    PushPinIcon = _table$options4$icons.PushPinIcon,
    SortIcon = _table$options4$icons.SortIcon,
    RestartAltIcon = _table$options4$icons.RestartAltIcon,
    VisibilityOffIcon = _table$options4$icons.VisibilityOffIcon,
    localization = _table$options4.localization,
    renderColumnActionsMenuItems = _table$options4.renderColumnActionsMenuItems,
    filterInputRefs = table.refs.filterInputRefs,
    setColumnSizingInfo = table.setColumnSizingInfo,
    setShowColumnFilters = table.setShowColumnFilters;
  var column = header.column;
  var columnDef = column.columnDef;
  var _getState4 = getState(),
    columnSizing = _getState4.columnSizing,
    columnVisibility = _getState4.columnVisibility,
    density = _getState4.density,
    showColumnFilters = _getState4.showColumnFilters;
  var columnFilterValue = column.getFilterValue();
  var _useState = useState(null),
    _useState2 = _slicedToArray(_useState, 2),
    filterMenuAnchorEl = _useState2[0],
    setFilterMenuAnchorEl = _useState2[1];
  var handleClearSort = function handleClearSort() {
    column.clearSorting();
    setAnchorEl(null);
  };
  var handleSortAsc = function handleSortAsc() {
    column.toggleSorting(false);
    setAnchorEl(null);
  };
  var handleSortDesc = function handleSortDesc() {
    column.toggleSorting(true);
    setAnchorEl(null);
  };
  var handleResetColumnSize = function handleResetColumnSize() {
    setColumnSizingInfo(function (old) {
      return Object.assign(Object.assign({}, old), {
        isResizingColumn: false
      });
    });
    column.resetSize();
    setAnchorEl(null);
  };
  var handleHideColumn = function handleHideColumn() {
    column.toggleVisibility(false);
    setAnchorEl(null);
  };
  var handlePinColumn = function handlePinColumn(pinDirection) {
    column.pin(pinDirection);
    setAnchorEl(null);
  };
  var handleGroupByColumn = function handleGroupByColumn() {
    column.toggleGrouping();
    setColumnOrder(function (old) {
      return ['mrt-row-expand'].concat(_toConsumableArray(old));
    });
    setAnchorEl(null);
  };
  var handleClearFilter = function handleClearFilter() {
    column.setFilterValue('');
    setAnchorEl(null);
  };
  var handleFilterByColumn = function handleFilterByColumn() {
    setShowColumnFilters(true);
    queueMicrotask(function () {
      var _a;
      return (_a = filterInputRefs.current["".concat(column.id, "-0")]) === null || _a === void 0 ? void 0 : _a.focus();
    });
    setAnchorEl(null);
  };
  var handleShowAllColumns = function handleShowAllColumns() {
    toggleAllColumnsVisible(true);
    setAnchorEl(null);
  };
  var handleOpenFilterModeMenu = function handleOpenFilterModeMenu(event) {
    event.stopPropagation();
    setFilterMenuAnchorEl(event.currentTarget);
  };
  var isSelectFilter = !!columnDef.filterSelectOptions;
  var allowedColumnFilterOptions = (_a = columnDef === null || columnDef === void 0 ? void 0 : columnDef.columnFilterModeOptions) !== null && _a !== void 0 ? _a : columnFilterModeOptions;
  var showFilterModeSubMenu = enableColumnFilterModes && columnDef.enableColumnFilterModes !== false && !isSelectFilter && (allowedColumnFilterOptions === undefined || !!(allowedColumnFilterOptions === null || allowedColumnFilterOptions === void 0 ? void 0 : allowedColumnFilterOptions.length));
  var internalColumnMenuItems = [].concat(_toConsumableArray(enableSorting && column.getCanSort() ? [enableSortingRemoval !== false && jsx(MenuItem, {
    disabled: !column.getIsSorted(),
    onClick: handleClearSort,
    sx: commonMenuItemStyles,
    children: jsxs(Box, {
      sx: commonListItemStyles,
      children: [jsx(ListItemIcon, {
        children: jsx(ClearAllIcon, {})
      }), localization.clearSort]
    })
  }, 0), jsx(MenuItem, {
    disabled: column.getIsSorted() === 'asc',
    onClick: handleSortAsc,
    sx: commonMenuItemStyles,
    children: jsxs(Box, {
      sx: commonListItemStyles,
      children: [jsx(ListItemIcon, {
        children: jsx(SortIcon, {
          style: {
            transform: 'rotate(180deg) scaleX(-1)'
          }
        })
      }), (_b = localization.sortByColumnAsc) === null || _b === void 0 ? void 0 : _b.replace('{column}', String(columnDef.header))]
    })
  }, 1), jsx(MenuItem, {
    divider: enableColumnFilters || enableGrouping || enableHiding,
    disabled: column.getIsSorted() === 'desc',
    onClick: handleSortDesc,
    sx: commonMenuItemStyles,
    children: jsxs(Box, {
      sx: commonListItemStyles,
      children: [jsx(ListItemIcon, {
        children: jsx(SortIcon, {})
      }), (_c = localization.sortByColumnDesc) === null || _c === void 0 ? void 0 : _c.replace('{column}', String(columnDef.header))]
    })
  }, 2)] : []), _toConsumableArray(enableColumnFilters && column.getCanFilter() ? [jsx(MenuItem, {
    disabled: !columnFilterValue || Array.isArray(columnFilterValue) && !columnFilterValue.filter(function (value) {
      return value;
    }).length,
    onClick: handleClearFilter,
    sx: commonMenuItemStyles,
    children: jsxs(Box, {
      sx: commonListItemStyles,
      children: [jsx(ListItemIcon, {
        children: jsx(FilterListOffIcon, {})
      }), localization.clearFilter]
    })
  }, 3), jsxs(MenuItem, {
    disabled: showColumnFilters && !enableColumnFilterModes,
    divider: enableGrouping || enableHiding,
    onClick: showColumnFilters ? handleOpenFilterModeMenu : handleFilterByColumn,
    sx: commonMenuItemStyles,
    children: [jsxs(Box, {
      sx: commonListItemStyles,
      children: [jsx(ListItemIcon, {
        children: jsx(FilterListIcon, {})
      }), (_d = localization.filterByColumn) === null || _d === void 0 ? void 0 : _d.replace('{column}', String(columnDef.header))]
    }), showFilterModeSubMenu && jsx(IconButton, {
      onClick: handleOpenFilterModeMenu,
      onMouseEnter: handleOpenFilterModeMenu,
      size: "small",
      sx: {
        p: 0
      },
      children: jsx(ArrowRightIcon, {})
    })]
  }, 4), showFilterModeSubMenu && jsx(MRT_FilterOptionMenu, {
    anchorEl: filterMenuAnchorEl,
    header: header,
    onSelect: handleFilterByColumn,
    setAnchorEl: setFilterMenuAnchorEl,
    table: table
  }, 5)] : []), _toConsumableArray(enableGrouping && column.getCanGroup() ? [jsx(MenuItem, {
    divider: enablePinning,
    onClick: handleGroupByColumn,
    sx: commonMenuItemStyles,
    children: jsxs(Box, {
      sx: commonListItemStyles,
      children: [jsx(ListItemIcon, {
        children: jsx(DynamicFeedIcon, {})
      }), (_e = localization[column.getIsGrouped() ? 'ungroupByColumn' : 'groupByColumn']) === null || _e === void 0 ? void 0 : _e.replace('{column}', String(columnDef.header))]
    })
  }, 6)] : []), _toConsumableArray(enablePinning && column.getCanPin() ? [jsx(MenuItem, {
    disabled: column.getIsPinned() === 'left' || !column.getCanPin(),
    onClick: function onClick() {
      return handlePinColumn('left');
    },
    sx: commonMenuItemStyles,
    children: jsxs(Box, {
      sx: commonListItemStyles,
      children: [jsx(ListItemIcon, {
        children: jsx(PushPinIcon, {
          style: {
            transform: 'rotate(90deg)'
          }
        })
      }), localization.pinToLeft]
    })
  }, 7), jsx(MenuItem, {
    disabled: column.getIsPinned() === 'right' || !column.getCanPin(),
    onClick: function onClick() {
      return handlePinColumn('right');
    },
    sx: commonMenuItemStyles,
    children: jsxs(Box, {
      sx: commonListItemStyles,
      children: [jsx(ListItemIcon, {
        children: jsx(PushPinIcon, {
          style: {
            transform: 'rotate(-90deg)'
          }
        })
      }), localization.pinToRight]
    })
  }, 8), jsx(MenuItem, {
    disabled: !column.getIsPinned(),
    divider: enableHiding,
    onClick: function onClick() {
      return handlePinColumn(false);
    },
    sx: commonMenuItemStyles,
    children: jsxs(Box, {
      sx: commonListItemStyles,
      children: [jsx(ListItemIcon, {
        children: jsx(PushPinIcon, {})
      }), localization.unpin]
    })
  }, 9)] : []), _toConsumableArray(enableColumnResizing && column.getCanResize() ? [jsx(MenuItem, {
    disabled: !columnSizing[column.id],
    onClick: handleResetColumnSize,
    sx: commonMenuItemStyles,
    children: jsxs(Box, {
      sx: commonListItemStyles,
      children: [jsx(ListItemIcon, {
        children: jsx(RestartAltIcon, {})
      }), localization.resetColumnSize]
    })
  }, 10)] : []), _toConsumableArray(enableHiding ? [jsx(MenuItem, {
    disabled: !column.getCanHide(),
    onClick: handleHideColumn,
    sx: commonMenuItemStyles,
    children: jsxs(Box, {
      sx: commonListItemStyles,
      children: [jsx(ListItemIcon, {
        children: jsx(VisibilityOffIcon, {})
      }), (_f = localization.hideColumn) === null || _f === void 0 ? void 0 : _f.replace('{column}', String(columnDef.header))]
    })
  }, 11), jsx(MenuItem, {
    disabled: !Object.values(columnVisibility).filter(function (visible) {
      return !visible;
    }).length,
    onClick: handleShowAllColumns,
    sx: commonMenuItemStyles,
    children: jsxs(Box, {
      sx: commonListItemStyles,
      children: [jsx(ListItemIcon, {
        children: jsx(ViewColumnIcon, {})
      }), (_g = localization.showAllColumns) === null || _g === void 0 ? void 0 : _g.replace('{column}', String(columnDef.header))]
    })
  }, 12)] : [])).filter(Boolean);
  return jsx(Menu, {
    anchorEl: anchorEl,
    open: !!anchorEl,
    onClose: function onClose() {
      return setAnchorEl(null);
    },
    MenuListProps: {
      dense: density === 'compact'
    },
    children: (_k = (_j = (_h = columnDef.renderColumnActionsMenuItems) === null || _h === void 0 ? void 0 : _h.call(columnDef, {
      closeMenu: function closeMenu() {
        return setAnchorEl(null);
      },
      column: column,
      internalColumnMenuItems: internalColumnMenuItems,
      table: table
    })) !== null && _j !== void 0 ? _j : renderColumnActionsMenuItems === null || renderColumnActionsMenuItems === void 0 ? void 0 : renderColumnActionsMenuItems({
      closeMenu: function closeMenu() {
        return setAnchorEl(null);
      },
      column: column,
      internalColumnMenuItems: internalColumnMenuItems,
      table: table
    })) !== null && _k !== void 0 ? _k : internalColumnMenuItems
  });
};
var MRT_RowActionMenu = function MRT_RowActionMenu(_ref10) {
  var anchorEl = _ref10.anchorEl,
    handleEdit = _ref10.handleEdit,
    row = _ref10.row,
    setAnchorEl = _ref10.setAnchorEl,
    table = _ref10.table;
  var getState = table.getState,
    _table$options5 = table.options,
    EditIcon = _table$options5.icons.EditIcon,
    enableEditing = _table$options5.enableEditing,
    localization = _table$options5.localization,
    renderRowActionMenuItems = _table$options5.renderRowActionMenuItems;
  var _getState5 = getState(),
    density = _getState5.density;
  return jsxs(Menu, {
    anchorEl: anchorEl,
    open: !!anchorEl,
    onClick: function onClick(event) {
      return event.stopPropagation();
    },
    onClose: function onClose() {
      return setAnchorEl(null);
    },
    MenuListProps: {
      dense: density === 'compact'
    },
    children: [enableEditing instanceof Function ? enableEditing(row) : enableEditing && jsx(MenuItem, {
      onClick: handleEdit,
      sx: commonMenuItemStyles,
      children: jsxs(Box, {
        sx: commonListItemStyles,
        children: [jsx(ListItemIcon, {
          children: jsx(EditIcon, {})
        }), localization.edit]
      })
    }), renderRowActionMenuItems === null || renderRowActionMenuItems === void 0 ? void 0 : renderRowActionMenuItems({
      row: row,
      table: table,
      closeMenu: function closeMenu() {
        return setAnchorEl(null);
      }
    })]
  });
};
var MRT_EditActionButtons = function MRT_EditActionButtons(_ref11) {
  var row = _ref11.row,
    table = _ref11.table,
    _ref11$variant = _ref11.variant,
    variant = _ref11$variant === void 0 ? 'icon' : _ref11$variant;
  var getState = table.getState,
    _table$options6 = table.options,
    _table$options6$icons = _table$options6.icons,
    CancelIcon = _table$options6$icons.CancelIcon,
    SaveIcon = _table$options6$icons.SaveIcon,
    localization = _table$options6.localization,
    onEditingRowSave = _table$options6.onEditingRowSave,
    onEditingRowCancel = _table$options6.onEditingRowCancel,
    editInputRefs = table.refs.editInputRefs,
    setEditingRow = table.setEditingRow;
  var _getState6 = getState(),
    editingRow = _getState6.editingRow;
  var handleCancel = function handleCancel() {
    onEditingRowCancel === null || onEditingRowCancel === void 0 ? void 0 : onEditingRowCancel({
      row: row,
      table: table
    });
    setEditingRow(null);
  };
  var handleSave = function handleSave() {
    var _a, _b;
    //look for auto-filled input values
    (_a = Object.values(editInputRefs === null || editInputRefs === void 0 ? void 0 : editInputRefs.current)) === null || _a === void 0 ? void 0 : _a.forEach(function (input) {
      if (input.value !== undefined && Object.hasOwn(editingRow === null || editingRow === void 0 ? void 0 : editingRow._valuesCache, input.name)) {
        // @ts-ignore
        editingRow._valuesCache[input.name] = input.value;
      }
    });
    onEditingRowSave === null || onEditingRowSave === void 0 ? void 0 : onEditingRowSave({
      exitEditingMode: function exitEditingMode() {
        return setEditingRow(null);
      },
      row: editingRow !== null && editingRow !== void 0 ? editingRow : row,
      table: table,
      values: (_b = editingRow === null || editingRow === void 0 ? void 0 : editingRow._valuesCache) !== null && _b !== void 0 ? _b : Object.assign({}, row.original)
    });
  };
  return jsx(Box, {
    onClick: function onClick(e) {
      return e.stopPropagation();
    },
    sx: {
      display: 'flex',
      gap: '0.75rem'
    },
    children: variant === 'icon' ? jsxs(Fragment, {
      children: [jsx(Tooltip, {
        arrow: true,
        title: localization.cancel,
        children: jsx(IconButton, {
          "aria-label": localization.cancel,
          onClick: handleCancel,
          children: jsx(CancelIcon, {})
        })
      }), jsx(Tooltip, {
        arrow: true,
        title: localization.save,
        children: jsx(IconButton, {
          "aria-label": localization.save,
          color: "info",
          onClick: handleSave,
          children: jsx(SaveIcon, {})
        })
      })]
    }) : jsxs(Fragment, {
      children: [jsx(Button, {
        onClick: handleCancel,
        children: localization.cancel
      }), jsx(Button, {
        onClick: handleSave,
        variant: "contained",
        children: localization.save
      })]
    })
  });
};
var commonIconButtonStyles = {
  height: '2rem',
  ml: '10px',
  opacity: 0.5,
  transition: 'opacity 150ms',
  width: '2rem',
  '&:hover': {
    opacity: 1
  }
};
var MRT_ToggleRowActionMenuButton = function MRT_ToggleRowActionMenuButton(_ref12) {
  var cell = _ref12.cell,
    row = _ref12.row,
    table = _ref12.table;
  var getState = table.getState,
    _table$options7 = table.options,
    editingMode = _table$options7.editingMode,
    enableEditing = _table$options7.enableEditing,
    _table$options7$icons = _table$options7.icons,
    EditIcon = _table$options7$icons.EditIcon,
    MoreHorizIcon = _table$options7$icons.MoreHorizIcon,
    localization = _table$options7.localization,
    renderRowActionMenuItems = _table$options7.renderRowActionMenuItems,
    renderRowActions = _table$options7.renderRowActions,
    setEditingRow = table.setEditingRow;
  var _getState7 = getState(),
    editingRow = _getState7.editingRow;
  var _useState3 = useState(null),
    _useState4 = _slicedToArray(_useState3, 2),
    anchorEl = _useState4[0],
    setAnchorEl = _useState4[1];
  var handleOpenRowActionMenu = function handleOpenRowActionMenu(event) {
    event.stopPropagation();
    event.preventDefault();
    setAnchorEl(event.currentTarget);
  };
  var handleStartEditMode = function handleStartEditMode(event) {
    event.stopPropagation();
    setEditingRow(Object.assign({}, row));
    setAnchorEl(null);
  };
  return jsx(Fragment, {
    children: renderRowActions ? renderRowActions({
      cell: cell,
      row: row,
      table: table
    }) : row.id === (editingRow === null || editingRow === void 0 ? void 0 : editingRow.id) && editingMode === 'row' ? jsx(MRT_EditActionButtons, {
      row: row,
      table: table
    }) : !renderRowActionMenuItems && (enableEditing instanceof Function ? enableEditing(row) : enableEditing) ? jsx(Tooltip, {
      placement: "right",
      arrow: true,
      title: localization.edit,
      children: jsx(IconButton, {
        "aria-label": localization.edit,
        sx: commonIconButtonStyles,
        onClick: handleStartEditMode,
        children: jsx(EditIcon, {})
      })
    }) : renderRowActionMenuItems ? jsxs(Fragment, {
      children: [jsx(Tooltip, {
        arrow: true,
        enterDelay: 1000,
        enterNextDelay: 1000,
        title: localization.rowActions,
        children: jsx(IconButton, {
          "aria-label": localization.rowActions,
          onClick: handleOpenRowActionMenu,
          size: "small",
          sx: commonIconButtonStyles,
          children: jsx(MoreHorizIcon, {})
        })
      }), jsx(MRT_RowActionMenu, {
        anchorEl: anchorEl,
        handleEdit: handleStartEditMode,
        row: row,
        setAnchorEl: setAnchorEl,
        table: table
      })]
    }) : null
  });
};
var MRT_SelectCheckbox = function MRT_SelectCheckbox(_ref13) {
  var row = _ref13.row,
    selectAll = _ref13.selectAll,
    table = _ref13.table;
  var _a;
  var getState = table.getState,
    _table$options8 = table.options,
    localization = _table$options8.localization,
    enableMultiRowSelection = _table$options8.enableMultiRowSelection,
    muiSelectCheckboxProps = _table$options8.muiSelectCheckboxProps,
    muiSelectAllCheckboxProps = _table$options8.muiSelectAllCheckboxProps,
    selectAllMode = _table$options8.selectAllMode;
  var _getState8 = getState(),
    density = _getState8.density,
    isLoading = _getState8.isLoading;
  var checkboxProps = !row ? muiSelectAllCheckboxProps instanceof Function ? muiSelectAllCheckboxProps({
    table: table
  }) : muiSelectAllCheckboxProps : muiSelectCheckboxProps instanceof Function ? muiSelectCheckboxProps({
    row: row,
    table: table
  }) : muiSelectCheckboxProps;
  var allRowsSelected = selectAll ? selectAllMode === 'page' ? table.getIsAllPageRowsSelected() : table.getIsAllRowsSelected() : undefined;
  var commonProps = Object.assign(Object.assign({
    checked: selectAll ? allRowsSelected : row === null || row === void 0 ? void 0 : row.getIsSelected(),
    disabled: isLoading || row && !row.getCanSelect(),
    inputProps: {
      'aria-label': selectAll ? localization.toggleSelectAll : localization.toggleSelectRow
    },
    onChange: row ? row.getToggleSelectedHandler() : selectAllMode === 'all' ? table.getToggleAllRowsSelectedHandler() : table.getToggleAllPageRowsSelectedHandler(),
    size: density === 'compact' ? 'small' : 'medium'
  }, checkboxProps), {
    onClick: function onClick(e) {
      var _a;
      e.stopPropagation();
      (_a = checkboxProps === null || checkboxProps === void 0 ? void 0 : checkboxProps.onClick) === null || _a === void 0 ? void 0 : _a.call(checkboxProps, e);
    },
    sx: function sx(theme) {
      return Object.assign({
        height: density === 'compact' ? '1.75rem' : '2.5rem',
        width: density === 'compact' ? '1.75rem' : '2.5rem',
        m: density !== 'compact' ? '-0.4rem' : undefined
      }, (checkboxProps === null || checkboxProps === void 0 ? void 0 : checkboxProps.sx) instanceof Function ? checkboxProps.sx(theme) : checkboxProps === null || checkboxProps === void 0 ? void 0 : checkboxProps.sx);
    },
    title: undefined
  });
  return jsx(Tooltip, {
    arrow: true,
    enterDelay: 1000,
    enterNextDelay: 1000,
    title: (_a = checkboxProps === null || checkboxProps === void 0 ? void 0 : checkboxProps.title) !== null && _a !== void 0 ? _a : selectAll ? localization.toggleSelectAll : localization.toggleSelectRow,
    children: enableMultiRowSelection === false ? jsx(Radio, Object.assign({}, commonProps)) : jsx(Checkbox, Object.assign({
      indeterminate: selectAll ? table.getIsSomeRowsSelected() && !allRowsSelected : row === null || row === void 0 ? void 0 : row.getIsSomeSelected()
    }, commonProps))
  });
};
var MRT_GlobalFilterTextField = function MRT_GlobalFilterTextField(_ref14) {
  var table = _ref14.table;
  var _a;
  var getState = table.getState,
    setGlobalFilter = table.setGlobalFilter,
    _table$options9 = table.options,
    enableGlobalFilterModes = _table$options9.enableGlobalFilterModes,
    _table$options9$icons = _table$options9.icons,
    SearchIcon = _table$options9$icons.SearchIcon,
    CloseIcon = _table$options9$icons.CloseIcon,
    localization = _table$options9.localization,
    manualFiltering = _table$options9.manualFiltering,
    muiSearchTextFieldProps = _table$options9.muiSearchTextFieldProps,
    searchInputRef = table.refs.searchInputRef;
  var _getState9 = getState(),
    globalFilter = _getState9.globalFilter,
    showGlobalFilter = _getState9.showGlobalFilter;
  var textFieldProps = muiSearchTextFieldProps instanceof Function ? muiSearchTextFieldProps({
    table: table
  }) : muiSearchTextFieldProps;
  var isMounted = useRef(false);
  var _useState5 = useState(null),
    _useState6 = _slicedToArray(_useState5, 2),
    anchorEl = _useState6[0],
    setAnchorEl = _useState6[1];
  var _useState7 = useState(globalFilter !== null && globalFilter !== void 0 ? globalFilter : ''),
    _useState8 = _slicedToArray(_useState7, 2),
    searchValue = _useState8[0],
    setSearchValue = _useState8[1];
  var handleChangeDebounced = useCallback(debounce(function (event) {
    var _a;
    setGlobalFilter((_a = event.target.value) !== null && _a !== void 0 ? _a : undefined);
  }, manualFiltering ? 500 : 250), []);
  var handleChange = function handleChange(event) {
    setSearchValue(event.target.value);
    handleChangeDebounced(event);
  };
  var handleGlobalFilterMenuOpen = function handleGlobalFilterMenuOpen(event) {
    setAnchorEl(event.currentTarget);
  };
  var handleClear = function handleClear() {
    setSearchValue('');
    setGlobalFilter(undefined);
  };
  useEffect(function () {
    if (isMounted.current) {
      if (globalFilter === undefined) {
        handleClear();
      } else {
        setSearchValue(globalFilter);
      }
    }
    isMounted.current = true;
  }, [globalFilter]);
  return jsxs(Collapse, {
    in: showGlobalFilter,
    orientation: "horizontal",
    unmountOnExit: true,
    mountOnEnter: true,
    children: [jsx(TextField, Object.assign({
      placeholder: localization.search,
      onChange: handleChange,
      value: searchValue !== null && searchValue !== void 0 ? searchValue : '',
      variant: "standard",
      InputProps: {
        startAdornment: enableGlobalFilterModes ? jsx(InputAdornment, {
          position: "start",
          children: jsx(Tooltip, {
            arrow: true,
            title: localization.changeSearchMode,
            children: jsx(IconButton, {
              "aria-label": localization.changeSearchMode,
              onClick: handleGlobalFilterMenuOpen,
              size: "small",
              sx: {
                height: '1.75rem',
                width: '1.75rem'
              },
              children: jsx(SearchIcon, {})
            })
          })
        }) : jsx(SearchIcon, {
          style: {
            marginRight: '4px'
          }
        }),
        endAdornment: jsx(InputAdornment, {
          position: "end",
          children: jsx(Tooltip, {
            arrow: true,
            title: (_a = localization.clearSearch) !== null && _a !== void 0 ? _a : '',
            children: jsx("span", {
              children: jsx(IconButton, {
                "aria-label": localization.clearSearch,
                disabled: !(searchValue === null || searchValue === void 0 ? void 0 : searchValue.length),
                onClick: handleClear,
                size: "small",
                children: jsx(CloseIcon, {})
              })
            })
          })
        })
      }
    }, textFieldProps, {
      inputRef: function inputRef(_inputRef) {
        searchInputRef.current = _inputRef;
        if (textFieldProps === null || textFieldProps === void 0 ? void 0 : textFieldProps.inputRef) {
          textFieldProps.inputRef = _inputRef;
        }
      }
    })), jsx(MRT_FilterOptionMenu, {
      anchorEl: anchorEl,
      setAnchorEl: setAnchorEl,
      table: table,
      onSelect: handleClear
    })]
  });
};
var MRT_LinearProgressBar = function MRT_LinearProgressBar(_ref15) {
  var isTopToolbar = _ref15.isTopToolbar,
    table = _ref15.table;
  var muiLinearProgressProps = table.options.muiLinearProgressProps,
    getState = table.getState;
  var _getState10 = getState(),
    isLoading = _getState10.isLoading,
    showProgressBars = _getState10.showProgressBars;
  var linearProgressProps = muiLinearProgressProps instanceof Function ? muiLinearProgressProps({
    isTopToolbar: isTopToolbar,
    table: table
  }) : muiLinearProgressProps;
  return jsx(Collapse, {
    in: isLoading || showProgressBars,
    mountOnEnter: true,
    unmountOnExit: true,
    sx: {
      bottom: isTopToolbar ? 0 : undefined,
      position: 'absolute',
      top: !isTopToolbar ? 0 : undefined,
      width: '100%'
    },
    children: jsx(LinearProgress, Object.assign({
      "aria-label": "Loading",
      "aria-busy": "true",
      sx: {
        position: 'relative'
      }
    }, linearProgressProps))
  });
};
var MRT_TablePagination = function MRT_TablePagination(_ref16) {
  var table = _ref16.table,
    _ref16$position = _ref16.position,
    position = _ref16$position === void 0 ? 'bottom' : _ref16$position;
  var getPrePaginationRowModel = table.getPrePaginationRowModel,
    getState = table.getState,
    setPageIndex = table.setPageIndex,
    setPageSize = table.setPageSize,
    _table$options10 = table.options,
    muiTablePaginationProps = _table$options10.muiTablePaginationProps,
    enableToolbarInternalActions = _table$options10.enableToolbarInternalActions,
    localization = _table$options10.localization,
    rowCount = _table$options10.rowCount;
  var _getState11 = getState(),
    _getState11$paginatio = _getState11.pagination,
    _getState11$paginatio2 = _getState11$paginatio.pageSize,
    pageSize = _getState11$paginatio2 === void 0 ? 10 : _getState11$paginatio2,
    _getState11$paginatio3 = _getState11$paginatio.pageIndex,
    pageIndex = _getState11$paginatio3 === void 0 ? 0 : _getState11$paginatio3,
    showGlobalFilter = _getState11.showGlobalFilter;
  var totalRowCount = rowCount !== null && rowCount !== void 0 ? rowCount : getPrePaginationRowModel().rows.length;
  var showFirstLastPageButtons = totalRowCount / pageSize > 2;
  var tablePaginationProps = muiTablePaginationProps instanceof Function ? muiTablePaginationProps({
    table: table
  }) : muiTablePaginationProps;
  var handleChangeRowsPerPage = function handleChangeRowsPerPage(event) {
    setPageSize(+event.target.value);
  };
  return jsx(TablePagination, Object.assign({
    component: "div",
    count: totalRowCount,
    getItemAriaLabel: function getItemAriaLabel(type) {
      return type === 'first' ? localization.goToFirstPage : type === 'last' ? localization.goToLastPage : type === 'next' ? localization.goToNextPage : localization.goToPreviousPage;
    },
    labelDisplayedRows: function labelDisplayedRows(_ref17) {
      var from = _ref17.from,
        to = _ref17.to,
        count = _ref17.count;
      return "".concat(from, "-").concat(to, " ").concat(localization.of, " ").concat(count);
    },
    labelRowsPerPage: localization.rowsPerPage,
    onPageChange: function onPageChange(_, newPage) {
      return setPageIndex(newPage);
    },
    onRowsPerPageChange: handleChangeRowsPerPage,
    page: Math.max(Math.min(pageIndex, Math.ceil(totalRowCount / pageSize) - 1), 0),
    rowsPerPage: pageSize,
    rowsPerPageOptions: [5, 10, 15, 20, 25, 30, 50, 100],
    showFirstButton: showFirstLastPageButtons,
    showLastButton: showFirstLastPageButtons
  }, tablePaginationProps, {
    SelectProps: Object.assign({
      sx: {
        m: '0 1rem 0 1ch'
      },
      MenuProps: {
        MenuListProps: {
          disablePadding: true
        },
        sx: {
          m: 0
        }
      }
    }, tablePaginationProps === null || tablePaginationProps === void 0 ? void 0 : tablePaginationProps.SelectProps),
    sx: function sx(theme) {
      return Object.assign({
        '& .MuiTablePagination-toolbar': {
          display: 'flex',
          alignItems: 'center'
        },
        '& .MuiTablePagination-selectLabel': {
          m: '0 -1px'
        },
        '&. MuiInputBase-root': {
          m: '0 1px'
        },
        '& . MuiTablePagination-select': {
          m: '0 1px'
        },
        '& .MuiTablePagination-displayedRows': {
          m: '0 1px'
        },
        '& .MuiTablePagination-actions': {
          m: '0 1px'
        },
        mt: position === 'top' && enableToolbarInternalActions && !showGlobalFilter ? '3.5rem' : undefined,
        position: 'relative',
        zIndex: 2
      }, (tablePaginationProps === null || tablePaginationProps === void 0 ? void 0 : tablePaginationProps.sx) instanceof Function ? tablePaginationProps.sx(theme) : tablePaginationProps === null || tablePaginationProps === void 0 ? void 0 : tablePaginationProps.sx);
    }
  }));
};
var MRT_ToolbarAlertBanner = function MRT_ToolbarAlertBanner(_ref18) {
  var stackAlertBanner = _ref18.stackAlertBanner,
    table = _ref18.table;
  var _a, _b;
  var getPrePaginationRowModel = table.getPrePaginationRowModel,
    getSelectedRowModel = table.getSelectedRowModel,
    getState = table.getState,
    _table$options11 = table.options,
    localization = _table$options11.localization,
    muiToolbarAlertBannerProps = _table$options11.muiToolbarAlertBannerProps,
    muiToolbarAlertBannerChipProps = _table$options11.muiToolbarAlertBannerChipProps,
    positionToolbarAlertBanner = _table$options11.positionToolbarAlertBanner,
    rowCount = _table$options11.rowCount;
  var _getState12 = getState(),
    grouping = _getState12.grouping,
    showAlertBanner = _getState12.showAlertBanner;
  var alertProps = muiToolbarAlertBannerProps instanceof Function ? muiToolbarAlertBannerProps({
    table: table
  }) : muiToolbarAlertBannerProps;
  var chipProps = muiToolbarAlertBannerChipProps instanceof Function ? muiToolbarAlertBannerChipProps({
    table: table
  }) : muiToolbarAlertBannerChipProps;
  var selectMessage = getSelectedRowModel().rows.length > 0 ? (_b = (_a = localization.selectedCountOfRowCountRowsSelected) === null || _a === void 0 ? void 0 : _a.replace('{selectedCount}', getSelectedRowModel().rows.length.toString())) === null || _b === void 0 ? void 0 : _b.replace('{rowCount}', (rowCount !== null && rowCount !== void 0 ? rowCount : getPrePaginationRowModel().rows.length).toString()) : null;
  var groupedByMessage = grouping.length > 0 ? jsxs("span", {
    children: [localization.groupedBy, ' ', grouping.map(function (columnId, index) {
      return jsxs(Fragment$1, {
        children: [index > 0 ? localization.thenBy : '', jsx(Chip, Object.assign({
          label: table.getColumn(columnId).columnDef.header,
          onDelete: function onDelete() {
            return table.getColumn(columnId).toggleGrouping();
          }
        }, chipProps))]
      }, "".concat(index, "-").concat(columnId));
    })]
  }) : null;
  return jsx(Collapse, {
    in: showAlertBanner || !!selectMessage || !!groupedByMessage,
    timeout: stackAlertBanner ? 200 : 0,
    children: jsxs(Alert, Object.assign({
      color: "info",
      icon: false
    }, alertProps, {
      sx: function sx(theme) {
        return Object.assign({
          borderRadius: 0,
          fontSize: '1rem',
          left: 0,
          p: 0,
          position: 'relative',
          mb: stackAlertBanner ? 0 : positionToolbarAlertBanner === 'bottom' ? '-1rem' : undefined,
          right: 0,
          top: 0,
          width: '100%',
          zIndex: 2
        }, (alertProps === null || alertProps === void 0 ? void 0 : alertProps.sx) instanceof Function ? alertProps.sx(theme) : alertProps === null || alertProps === void 0 ? void 0 : alertProps.sx);
      },
      children: [(alertProps === null || alertProps === void 0 ? void 0 : alertProps.title) && jsx(AlertTitle, {
        children: alertProps.title
      }), jsxs(Box, {
        sx: {
          p: '0.5rem 1rem'
        },
        children: [alertProps === null || alertProps === void 0 ? void 0 : alertProps.children, (alertProps === null || alertProps === void 0 ? void 0 : alertProps.children) && (selectMessage || groupedByMessage) && jsx("br", {}), selectMessage, selectMessage && groupedByMessage && jsx("br", {}), groupedByMessage]
      })]
    }))
  });
};
var MRT_FullScreenToggleButton = function MRT_FullScreenToggleButton(_a) {
  var _b;
  var table = _a.table,
    rest = __rest(_a, ["table"]);
  var getState = table.getState,
    _table$options12 = table.options,
    _table$options12$icon = _table$options12.icons,
    FullscreenExitIcon = _table$options12$icon.FullscreenExitIcon,
    FullscreenIcon = _table$options12$icon.FullscreenIcon,
    localization = _table$options12.localization,
    setIsFullScreen = table.setIsFullScreen;
  var _getState13 = getState(),
    isFullScreen = _getState13.isFullScreen;
  var handleToggleFullScreen = function handleToggleFullScreen() {
    setIsFullScreen(!isFullScreen);
  };
  return jsx(Tooltip, {
    arrow: true,
    title: (_b = rest === null || rest === void 0 ? void 0 : rest.title) !== null && _b !== void 0 ? _b : localization.toggleFullScreen,
    children: jsx(IconButton, Object.assign({
      "aria-label": localization.showHideFilters,
      onClick: handleToggleFullScreen
    }, rest, {
      title: undefined,
      children: isFullScreen ? jsx(FullscreenExitIcon, {}) : jsx(FullscreenIcon, {})
    }))
  });
};
var MRT_ColumnPinningButtons = function MRT_ColumnPinningButtons(_ref19) {
  var column = _ref19.column,
    table = _ref19.table;
  var _table$options13 = table.options,
    PushPinIcon = _table$options13.icons.PushPinIcon,
    localization = _table$options13.localization;
  var handlePinColumn = function handlePinColumn(pinDirection) {
    column.pin(pinDirection);
  };
  return jsx(Box, {
    sx: {
      minWidth: '70px',
      textAlign: 'center'
    },
    children: column.getIsPinned() ? jsx(Tooltip, {
      arrow: true,
      title: localization.unpin,
      children: jsx(IconButton, {
        onClick: function onClick() {
          return handlePinColumn(false);
        },
        size: "small",
        children: jsx(PushPinIcon, {})
      })
    }) : jsxs(Fragment, {
      children: [jsx(Tooltip, {
        arrow: true,
        title: localization.pinToLeft,
        children: jsx(IconButton, {
          onClick: function onClick() {
            return handlePinColumn('left');
          },
          size: "small",
          children: jsx(PushPinIcon, {
            style: {
              transform: 'rotate(90deg)'
            }
          })
        })
      }), jsx(Tooltip, {
        arrow: true,
        title: localization.pinToRight,
        children: jsx(IconButton, {
          onClick: function onClick() {
            return handlePinColumn('right');
          },
          size: "small",
          children: jsx(PushPinIcon, {
            style: {
              transform: 'rotate(-90deg)'
            }
          })
        })
      })]
    })
  });
};
var MRT_GrabHandleButton = function MRT_GrabHandleButton(_ref20) {
  var iconButtonProps = _ref20.iconButtonProps,
    onDragEnd = _ref20.onDragEnd,
    onDragStart = _ref20.onDragStart,
    table = _ref20.table;
  var _a;
  var _table$options14 = table.options,
    DragHandleIcon = _table$options14.icons.DragHandleIcon,
    localization = _table$options14.localization;
  return jsx(Tooltip, {
    arrow: true,
    enterDelay: 1000,
    enterNextDelay: 1000,
    placement: "top",
    title: (_a = iconButtonProps === null || iconButtonProps === void 0 ? void 0 : iconButtonProps.title) !== null && _a !== void 0 ? _a : localization.move,
    children: jsx(IconButton, Object.assign({
      disableRipple: true,
      draggable: "true",
      size: "small"
    }, iconButtonProps, {
      onClick: function onClick(e) {
        var _a;
        e.stopPropagation();
        (_a = iconButtonProps === null || iconButtonProps === void 0 ? void 0 : iconButtonProps.onClick) === null || _a === void 0 ? void 0 : _a.call(iconButtonProps, e);
      },
      onDragStart: onDragStart,
      onDragEnd: onDragEnd,
      sx: function sx(theme) {
        return Object.assign({
          cursor: 'grab',
          m: '0 -0.1rem',
          opacity: 0.5,
          p: '2px',
          transition: 'all 150ms ease-in-out',
          '&:hover': {
            backgroundColor: 'transparent',
            opacity: 1
          },
          '&:active': {
            cursor: 'grabbing'
          }
        }, (iconButtonProps === null || iconButtonProps === void 0 ? void 0 : iconButtonProps.sx) instanceof Function ? iconButtonProps === null || iconButtonProps === void 0 ? void 0 : iconButtonProps.sx(theme) : iconButtonProps === null || iconButtonProps === void 0 ? void 0 : iconButtonProps.sx);
      },
      title: undefined,
      children: jsx(DragHandleIcon, {})
    }))
  });
};
var MRT_ShowHideColumnsMenuItems = function MRT_ShowHideColumnsMenuItems(_ref21) {
  var allColumns = _ref21.allColumns,
    hoveredColumn = _ref21.hoveredColumn,
    setHoveredColumn = _ref21.setHoveredColumn,
    column = _ref21.column,
    table = _ref21.table;
  var _a;
  var getState = table.getState,
    _table$options15 = table.options,
    enableColumnOrdering = _table$options15.enableColumnOrdering,
    enableHiding = _table$options15.enableHiding,
    enablePinning = _table$options15.enablePinning,
    localization = _table$options15.localization,
    setColumnOrder = table.setColumnOrder;
  var _getState14 = getState(),
    columnOrder = _getState14.columnOrder;
  var columnDef = column.columnDef;
  var columnDefType = columnDef.columnDefType;
  var switchChecked = columnDefType !== 'group' && column.getIsVisible() || columnDefType === 'group' && column.getLeafColumns().some(function (col) {
    return col.getIsVisible();
  });
  var handleToggleColumnHidden = function handleToggleColumnHidden(column) {
    var _a, _b;
    if (columnDefType === 'group') {
      (_b = (_a = column === null || column === void 0 ? void 0 : column.columns) === null || _a === void 0 ? void 0 : _a.forEach) === null || _b === void 0 ? void 0 : _b.call(_a, function (childColumn) {
        childColumn.toggleVisibility(!switchChecked);
      });
    } else {
      column.toggleVisibility();
    }
  };
  var menuItemRef = useRef(null);
  var _useState9 = useState(false),
    _useState10 = _slicedToArray(_useState9, 2),
    isDragging = _useState10[0],
    setIsDragging = _useState10[1];
  var handleDragStart = function handleDragStart(e) {
    setIsDragging(true);
    e.dataTransfer.setDragImage(menuItemRef.current, 0, 0);
  };
  var handleDragEnd = function handleDragEnd(_e) {
    setIsDragging(false);
    setHoveredColumn(null);
    if (hoveredColumn) {
      setColumnOrder(reorderColumn(column, hoveredColumn, columnOrder));
    }
  };
  var handleDragEnter = function handleDragEnter(_e) {
    if (!isDragging && columnDef.enableColumnOrdering !== false) {
      setHoveredColumn(column);
    }
  };
  return jsxs(Fragment, {
    children: [jsx(MenuItem, {
      disableRipple: true,
      ref: menuItemRef,
      onDragEnter: handleDragEnter,
      sx: function sx(theme) {
        return {
          alignItems: 'center',
          justifyContent: 'flex-start',
          my: 0,
          opacity: isDragging ? 0.5 : 1,
          outlineOffset: '-2px',
          outline: isDragging ? "2px dashed ".concat(theme.palette.divider) : (hoveredColumn === null || hoveredColumn === void 0 ? void 0 : hoveredColumn.id) === column.id ? "2px dashed ".concat(theme.palette.primary.main) : 'none',
          pl: "".concat((column.depth + 0.5) * 2, "rem"),
          py: '6px'
        };
      },
      children: jsxs(Box, {
        sx: {
          display: 'flex',
          flexWrap: 'nowrap',
          gap: '8px'
        },
        children: [columnDefType !== 'group' && enableColumnOrdering && !allColumns.some(function (col) {
          return col.columnDef.columnDefType === 'group';
        }) && (columnDef.enableColumnOrdering !== false ? jsx(MRT_GrabHandleButton, {
          onDragEnd: handleDragEnd,
          onDragStart: handleDragStart,
          table: table
        }) : jsx(Box, {
          sx: {
            width: '28px'
          }
        })), enablePinning && (column.getCanPin() ? jsx(MRT_ColumnPinningButtons, {
          column: column,
          table: table
        }) : jsx(Box, {
          sx: {
            width: '70px'
          }
        })), enableHiding ? jsx(FormControlLabel, {
          componentsProps: {
            typography: {
              sx: {
                mb: 0,
                opacity: columnDefType !== 'display' ? 1 : 0.5
              }
            }
          },
          checked: switchChecked,
          control: jsx(Tooltip, {
            arrow: true,
            enterDelay: 1000,
            enterNextDelay: 1000,
            title: localization.toggleVisibility,
            children: jsx(Switch, {})
          }),
          disabled: !column.getCanHide(),
          label: columnDef.header,
          onChange: function onChange() {
            return handleToggleColumnHidden(column);
          }
        }) : jsx(Typography, {
          sx: {
            alignSelf: 'center'
          },
          children: columnDef.header
        })]
      })
    }), (_a = column.columns) === null || _a === void 0 ? void 0 : _a.map(function (c, i) {
      return jsx(MRT_ShowHideColumnsMenuItems, {
        allColumns: allColumns,
        column: c,
        hoveredColumn: hoveredColumn,
        setHoveredColumn: setHoveredColumn,
        table: table
      }, "".concat(i, "-").concat(c.id));
    })]
  });
};
var MRT_ShowHideColumnsMenu = function MRT_ShowHideColumnsMenu(_ref22) {
  var anchorEl = _ref22.anchorEl,
    setAnchorEl = _ref22.setAnchorEl,
    table = _ref22.table;
  var getAllColumns = table.getAllColumns,
    getAllLeafColumns = table.getAllLeafColumns,
    getCenterLeafColumns = table.getCenterLeafColumns,
    getIsAllColumnsVisible = table.getIsAllColumnsVisible,
    getIsSomeColumnsPinned = table.getIsSomeColumnsPinned,
    getIsSomeColumnsVisible = table.getIsSomeColumnsVisible,
    getLeftLeafColumns = table.getLeftLeafColumns,
    getRightLeafColumns = table.getRightLeafColumns,
    getState = table.getState,
    toggleAllColumnsVisible = table.toggleAllColumnsVisible,
    _table$options16 = table.options,
    enableColumnOrdering = _table$options16.enableColumnOrdering,
    enableHiding = _table$options16.enableHiding,
    enablePinning = _table$options16.enablePinning,
    localization = _table$options16.localization;
  var _getState15 = getState(),
    density = _getState15.density,
    columnOrder = _getState15.columnOrder,
    columnPinning = _getState15.columnPinning;
  var hideAllColumns = function hideAllColumns() {
    getAllLeafColumns().filter(function (col) {
      return col.columnDef.enableHiding !== false;
    }).forEach(function (col) {
      return col.toggleVisibility(false);
    });
  };
  var allColumns = useMemo(function () {
    var columns = getAllColumns();
    if (columnOrder.length > 0 && !columns.some(function (col) {
      return col.columnDef.columnDefType === 'group';
    })) {
      return [].concat(_toConsumableArray(getLeftLeafColumns()), _toConsumableArray(Array.from(new Set(columnOrder)).map(function (colId) {
        return getCenterLeafColumns().find(function (col) {
          return (col === null || col === void 0 ? void 0 : col.id) === colId;
        });
      })), _toConsumableArray(getRightLeafColumns())).filter(Boolean);
    }
    return columns;
  }, [columnOrder, columnPinning, getAllColumns(), getCenterLeafColumns(), getLeftLeafColumns(), getRightLeafColumns()]);
  var _useState11 = useState(null),
    _useState12 = _slicedToArray(_useState11, 2),
    hoveredColumn = _useState12[0],
    setHoveredColumn = _useState12[1];
  return jsxs(Menu, {
    anchorEl: anchorEl,
    open: !!anchorEl,
    onClose: function onClose() {
      return setAnchorEl(null);
    },
    MenuListProps: {
      dense: density === 'compact'
    },
    children: [jsxs(Box, {
      sx: {
        display: 'flex',
        justifyContent: 'space-between',
        p: '0.5rem',
        pt: 0
      },
      children: [enableHiding && jsx(Button, {
        disabled: !getIsSomeColumnsVisible(),
        onClick: hideAllColumns,
        children: localization.hideAll
      }), enableColumnOrdering && jsx(Button, {
        onClick: function onClick() {
          return table.setColumnOrder(getDefaultColumnOrderIds(table.options));
        },
        children: localization.resetOrder
      }), enablePinning && jsx(Button, {
        disabled: !getIsSomeColumnsPinned(),
        onClick: function onClick() {
          return table.resetColumnPinning(true);
        },
        children: localization.unpinAll
      }), enableHiding && jsx(Button, {
        disabled: getIsAllColumnsVisible(),
        onClick: function onClick() {
          return toggleAllColumnsVisible(true);
        },
        children: localization.showAll
      })]
    }), jsx(Divider, {}), allColumns.map(function (column, index) {
      return jsx(MRT_ShowHideColumnsMenuItems, {
        allColumns: allColumns,
        column: column,
        hoveredColumn: hoveredColumn,
        setHoveredColumn: setHoveredColumn,
        table: table
      }, "".concat(index, "-").concat(column.id));
    })]
  });
};
var MRT_ShowHideColumnsButton = function MRT_ShowHideColumnsButton(_a) {
  var _b;
  var table = _a.table,
    rest = __rest(_a, ["table"]);
  var _table$options17 = table.options,
    ViewColumnIcon = _table$options17.icons.ViewColumnIcon,
    localization = _table$options17.localization;
  var _useState13 = useState(null),
    _useState14 = _slicedToArray(_useState13, 2),
    anchorEl = _useState14[0],
    setAnchorEl = _useState14[1];
  var handleClick = function handleClick(event) {
    setAnchorEl(event.currentTarget);
  };
  return jsxs(Fragment, {
    children: [jsx(Tooltip, {
      arrow: true,
      title: (_b = rest === null || rest === void 0 ? void 0 : rest.title) !== null && _b !== void 0 ? _b : localization.showHideColumns,
      children: jsx(IconButton, Object.assign({
        "aria-label": localization.showHideColumns,
        onClick: handleClick
      }, rest, {
        title: undefined,
        children: jsx(ViewColumnIcon, {})
      }))
    }), anchorEl && jsx(MRT_ShowHideColumnsMenu, {
      anchorEl: anchorEl,
      setAnchorEl: setAnchorEl,
      table: table
    })]
  });
};
var MRT_ToggleDensePaddingButton = function MRT_ToggleDensePaddingButton(_a) {
  var _b;
  var table = _a.table,
    rest = __rest(_a, ["table"]);
  var getState = table.getState,
    _table$options18 = table.options,
    _table$options18$icon = _table$options18.icons,
    DensityLargeIcon = _table$options18$icon.DensityLargeIcon,
    DensityMediumIcon = _table$options18$icon.DensityMediumIcon,
    DensitySmallIcon = _table$options18$icon.DensitySmallIcon,
    localization = _table$options18.localization,
    setDensity = table.setDensity;
  var _getState16 = getState(),
    density = _getState16.density;
  var handleToggleDensePadding = function handleToggleDensePadding() {
    var nextDensity = density === 'comfortable' ? 'compact' : density === 'compact' ? 'spacious' : 'comfortable';
    setDensity(nextDensity);
  };
  return jsx(Tooltip, {
    arrow: true,
    title: (_b = rest === null || rest === void 0 ? void 0 : rest.title) !== null && _b !== void 0 ? _b : localization.toggleDensity,
    children: jsx(IconButton, Object.assign({
      "aria-label": localization.toggleDensity,
      onClick: handleToggleDensePadding
    }, rest, {
      title: undefined,
      children: density === 'compact' ? jsx(DensitySmallIcon, {}) : density === 'comfortable' ? jsx(DensityMediumIcon, {}) : jsx(DensityLargeIcon, {})
    }))
  });
};
var MRT_ToggleFiltersButton = function MRT_ToggleFiltersButton(_a) {
  var _b;
  var table = _a.table,
    rest = __rest(_a, ["table"]);
  var getState = table.getState,
    _table$options19 = table.options,
    _table$options19$icon = _table$options19.icons,
    FilterListIcon = _table$options19$icon.FilterListIcon,
    FilterListOffIcon = _table$options19$icon.FilterListOffIcon,
    localization = _table$options19.localization,
    setShowColumnFilters = table.setShowColumnFilters;
  var _getState17 = getState(),
    showColumnFilters = _getState17.showColumnFilters;
  var handleToggleShowFilters = function handleToggleShowFilters() {
    setShowColumnFilters(!showColumnFilters);
  };
  return jsx(Tooltip, {
    arrow: true,
    title: (_b = rest === null || rest === void 0 ? void 0 : rest.title) !== null && _b !== void 0 ? _b : localization.showHideFilters,
    children: jsx(IconButton, Object.assign({
      "aria-label": localization.showHideFilters,
      onClick: handleToggleShowFilters
    }, rest, {
      title: undefined,
      children: showColumnFilters ? jsx(FilterListOffIcon, {}) : jsx(FilterListIcon, {})
    }))
  });
};
var MRT_ToggleGlobalFilterButton = function MRT_ToggleGlobalFilterButton(_a) {
  var _b, _c;
  var table = _a.table,
    rest = __rest(_a, ["table"]);
  var getState = table.getState,
    _table$options20 = table.options,
    _table$options20$icon = _table$options20.icons,
    SearchIcon = _table$options20$icon.SearchIcon,
    SearchOffIcon = _table$options20$icon.SearchOffIcon,
    localization = _table$options20.localization,
    searchInputRef = table.refs.searchInputRef,
    setShowGlobalFilter = table.setShowGlobalFilter;
  var _getState18 = getState(),
    globalFilter = _getState18.globalFilter,
    showGlobalFilter = _getState18.showGlobalFilter;
  var handleToggleSearch = function handleToggleSearch() {
    setShowGlobalFilter(!showGlobalFilter);
    queueMicrotask(function () {
      var _a;
      return (_a = searchInputRef.current) === null || _a === void 0 ? void 0 : _a.focus();
    });
  };
  return jsx(Tooltip, {
    arrow: true,
    title: (_b = rest === null || rest === void 0 ? void 0 : rest.title) !== null && _b !== void 0 ? _b : localization.showHideSearch,
    children: jsx(IconButton, Object.assign({
      "aria-label": (_c = rest === null || rest === void 0 ? void 0 : rest.title) !== null && _c !== void 0 ? _c : localization.showHideSearch,
      disabled: !!globalFilter,
      onClick: handleToggleSearch
    }, rest, {
      title: undefined,
      children: showGlobalFilter ? jsx(SearchOffIcon, {}) : jsx(SearchIcon, {})
    }))
  });
};
var MRT_ToolbarInternalButtons = function MRT_ToolbarInternalButtons(_ref23) {
  var table = _ref23.table;
  var _a;
  var _table$options21 = table.options,
    enableColumnFilters = _table$options21.enableColumnFilters,
    enableColumnOrdering = _table$options21.enableColumnOrdering,
    enableDensityToggle = _table$options21.enableDensityToggle,
    enableFilters = _table$options21.enableFilters,
    enableFullScreenToggle = _table$options21.enableFullScreenToggle,
    enableGlobalFilter = _table$options21.enableGlobalFilter,
    enableHiding = _table$options21.enableHiding,
    enablePinning = _table$options21.enablePinning,
    initialState = _table$options21.initialState,
    renderToolbarInternalActions = _table$options21.renderToolbarInternalActions;
  return jsx(Box, {
    sx: {
      alignItems: 'center',
      display: 'flex',
      zIndex: 3
    },
    children: (_a = renderToolbarInternalActions === null || renderToolbarInternalActions === void 0 ? void 0 : renderToolbarInternalActions({
      table: table
    })) !== null && _a !== void 0 ? _a : jsxs(Fragment, {
      children: [enableFilters && enableGlobalFilter && !(initialState === null || initialState === void 0 ? void 0 : initialState.showGlobalFilter) && jsx(MRT_ToggleGlobalFilterButton, {
        table: table
      }), enableFilters && enableColumnFilters && jsx(MRT_ToggleFiltersButton, {
        table: table
      }), (enableHiding || enableColumnOrdering || enablePinning) && jsx(MRT_ShowHideColumnsButton, {
        table: table
      }), enableDensityToggle && jsx(MRT_ToggleDensePaddingButton, {
        table: table
      }), enableFullScreenToggle && jsx(MRT_FullScreenToggleButton, {
        table: table
      })]
    })
  });
};
var MRT_ToolbarDropZone = function MRT_ToolbarDropZone(_ref24) {
  var table = _ref24.table;
  var _a, _b;
  var getState = table.getState,
    _table$options22 = table.options,
    enableGrouping = _table$options22.enableGrouping,
    localization = _table$options22.localization,
    setHoveredColumn = table.setHoveredColumn,
    setShowToolbarDropZone = table.setShowToolbarDropZone;
  var _getState19 = getState(),
    draggingColumn = _getState19.draggingColumn,
    hoveredColumn = _getState19.hoveredColumn,
    grouping = _getState19.grouping,
    showToolbarDropZone = _getState19.showToolbarDropZone;
  var handleDragEnter = function handleDragEnter(_event) {
    setHoveredColumn({
      id: 'drop-zone'
    });
  };
  useEffect(function () {
    var _a;
    if (((_a = table.options.state) === null || _a === void 0 ? void 0 : _a.showToolbarDropZone) !== undefined) {
      setShowToolbarDropZone(!!enableGrouping && !!draggingColumn && draggingColumn.columnDef.enableGrouping !== false && !grouping.includes(draggingColumn.id));
    }
  }, [enableGrouping, draggingColumn, grouping]);
  return jsx(Fade, {
    in: showToolbarDropZone,
    children: jsx(Box, {
      className: "Mui-ToolbarDropZone",
      sx: function sx(theme) {
        return {
          alignItems: 'center',
          backgroundColor: alpha(theme.palette.info.main, (hoveredColumn === null || hoveredColumn === void 0 ? void 0 : hoveredColumn.id) === 'drop-zone' ? 0.2 : 0.1),
          backdropFilter: 'blur(4px)',
          boxSizing: 'border-box',
          border: "dashed ".concat(theme.palette.info.main, " 2px"),
          display: 'flex',
          justifyContent: 'center',
          height: '100%',
          position: 'absolute',
          width: '100%',
          zIndex: 4
        };
      },
      onDragEnter: handleDragEnter,
      children: jsx(Typography, {
        fontStyle: "italic",
        children: localization.dropToGroupBy.replace('{column}', (_b = (_a = draggingColumn === null || draggingColumn === void 0 ? void 0 : draggingColumn.columnDef) === null || _a === void 0 ? void 0 : _a.header) !== null && _b !== void 0 ? _b : '')
      })
    })
  });
};
var commonToolbarStyles = function commonToolbarStyles(_ref25) {
  var theme = _ref25.theme;
  return {
    alignItems: 'flex-start',
    backgroundColor: lighten(theme.palette.background.default, 0.04),
    backgroundImage: 'none',
    display: 'grid',
    flexWrap: 'wrap-reverse',
    minHeight: '3.5rem',
    overflow: 'hidden',
    p: '0 !important',
    transition: 'all 150ms ease-in-out',
    zIndex: 1
  };
};
var MRT_TopToolbar = function MRT_TopToolbar(_ref26) {
  var table = _ref26.table;
  var _a;
  var getState = table.getState,
    _table$options23 = table.options,
    enableGlobalFilter = _table$options23.enableGlobalFilter,
    enablePagination = _table$options23.enablePagination,
    enableToolbarInternalActions = _table$options23.enableToolbarInternalActions,
    muiTopToolbarProps = _table$options23.muiTopToolbarProps,
    positionGlobalFilter = _table$options23.positionGlobalFilter,
    positionPagination = _table$options23.positionPagination,
    positionToolbarAlertBanner = _table$options23.positionToolbarAlertBanner,
    positionToolbarDropZone = _table$options23.positionToolbarDropZone,
    renderTopToolbarCustomActions = _table$options23.renderTopToolbarCustomActions,
    topToolbarRef = table.refs.topToolbarRef;
  var _getState20 = getState(),
    isFullScreen = _getState20.isFullScreen,
    showGlobalFilter = _getState20.showGlobalFilter;
  var isMobile = useMediaQuery('(max-width:720px)');
  var toolbarProps = muiTopToolbarProps instanceof Function ? muiTopToolbarProps({
    table: table
  }) : muiTopToolbarProps;
  var stackAlertBanner = isMobile || !!renderTopToolbarCustomActions || showGlobalFilter;
  return jsxs(Toolbar, Object.assign({
    variant: "dense"
  }, toolbarProps, {
    ref: function ref(_ref27) {
      topToolbarRef.current = _ref27;
      if (toolbarProps === null || toolbarProps === void 0 ? void 0 : toolbarProps.ref) {
        // @ts-ignore
        toolbarProps.ref.current = _ref27;
      }
    },
    sx: function sx(theme) {
      return Object.assign(Object.assign({
        position: isFullScreen ? 'sticky' : undefined,
        top: isFullScreen ? '0' : undefined
      }, commonToolbarStyles({
        theme: theme
      })), (toolbarProps === null || toolbarProps === void 0 ? void 0 : toolbarProps.sx) instanceof Function ? toolbarProps.sx(theme) : toolbarProps === null || toolbarProps === void 0 ? void 0 : toolbarProps.sx);
    },
    children: [positionToolbarAlertBanner === 'top' && jsx(MRT_ToolbarAlertBanner, {
      stackAlertBanner: stackAlertBanner,
      table: table
    }), ['both', 'top'].includes(positionToolbarDropZone !== null && positionToolbarDropZone !== void 0 ? positionToolbarDropZone : '') && jsx(MRT_ToolbarDropZone, {
      table: table
    }), jsxs(Box, {
      sx: {
        alignItems: 'flex-start',
        boxSizing: 'border-box',
        display: 'flex',
        justifyContent: 'space-between',
        p: '0.5rem',
        position: stackAlertBanner ? 'relative' : 'absolute',
        right: 0,
        top: 0,
        width: '100%'
      },
      children: [enableGlobalFilter && positionGlobalFilter === 'left' && jsx(MRT_GlobalFilterTextField, {
        table: table
      }), (_a = renderTopToolbarCustomActions === null || renderTopToolbarCustomActions === void 0 ? void 0 : renderTopToolbarCustomActions({
        table: table
      })) !== null && _a !== void 0 ? _a : jsx("span", {}), enableToolbarInternalActions ? jsxs(Box, {
        sx: {
          display: 'flex',
          flexWrap: 'wrap-reverse',
          justifyContent: 'flex-end'
        },
        children: [enableGlobalFilter && positionGlobalFilter === 'right' && jsx(MRT_GlobalFilterTextField, {
          table: table
        }), jsx(MRT_ToolbarInternalButtons, {
          table: table
        })]
      }) : enableGlobalFilter && positionGlobalFilter === 'right' && jsx(MRT_GlobalFilterTextField, {
        table: table
      })]
    }), enablePagination && ['top', 'both'].includes(positionPagination !== null && positionPagination !== void 0 ? positionPagination : '') && jsx(MRT_TablePagination, {
      table: table,
      position: "top"
    }), jsx(MRT_LinearProgressBar, {
      isTopToolbar: true,
      table: table
    })]
  }));
};
var MRT_BottomToolbar = function MRT_BottomToolbar(_ref28) {
  var table = _ref28.table;
  var getState = table.getState,
    _table$options24 = table.options,
    enablePagination = _table$options24.enablePagination,
    muiBottomToolbarProps = _table$options24.muiBottomToolbarProps,
    positionPagination = _table$options24.positionPagination,
    positionToolbarAlertBanner = _table$options24.positionToolbarAlertBanner,
    positionToolbarDropZone = _table$options24.positionToolbarDropZone,
    renderBottomToolbarCustomActions = _table$options24.renderBottomToolbarCustomActions,
    bottomToolbarRef = table.refs.bottomToolbarRef;
  var _getState21 = getState(),
    isFullScreen = _getState21.isFullScreen;
  var isMobile = useMediaQuery('(max-width:720px)');
  var toolbarProps = muiBottomToolbarProps instanceof Function ? muiBottomToolbarProps({
    table: table
  }) : muiBottomToolbarProps;
  var stackAlertBanner = isMobile || !!renderBottomToolbarCustomActions;
  return jsxs(Toolbar, Object.assign({
    variant: "dense"
  }, toolbarProps, {
    ref: function ref(node) {
      if (node) {
        bottomToolbarRef.current = node;
        if (toolbarProps === null || toolbarProps === void 0 ? void 0 : toolbarProps.ref) {
          // @ts-ignore
          toolbarProps.ref.current = node;
        }
      }
    },
    sx: function sx(theme) {
      return Object.assign(Object.assign(Object.assign({}, commonToolbarStyles({
        theme: theme
      })), {
        bottom: isFullScreen ? '0' : undefined,
        boxShadow: "0 1px 2px -1px ".concat(alpha(theme.palette.common.black, 0.1), " inset"),
        left: 0,
        position: isFullScreen ? 'fixed' : 'relative',
        right: 0
      }), (toolbarProps === null || toolbarProps === void 0 ? void 0 : toolbarProps.sx) instanceof Function ? toolbarProps.sx(theme) : toolbarProps === null || toolbarProps === void 0 ? void 0 : toolbarProps.sx);
    },
    children: [jsx(MRT_LinearProgressBar, {
      isTopToolbar: false,
      table: table
    }), positionToolbarAlertBanner === 'bottom' && jsx(MRT_ToolbarAlertBanner, {
      stackAlertBanner: stackAlertBanner,
      table: table
    }), ['both', 'bottom'].includes(positionToolbarDropZone !== null && positionToolbarDropZone !== void 0 ? positionToolbarDropZone : '') && jsx(MRT_ToolbarDropZone, {
      table: table
    }), jsxs(Box, {
      sx: {
        alignItems: 'center',
        boxSizing: 'border-box',
        display: 'flex',
        justifyContent: 'space-between',
        p: '0.5rem',
        width: '100%'
      },
      children: [renderBottomToolbarCustomActions ? renderBottomToolbarCustomActions({
        table: table
      }) : jsx("span", {}), jsx(Box, {
        sx: {
          display: 'flex',
          justifyContent: 'flex-end',
          position: stackAlertBanner ? 'relative' : 'absolute',
          right: 0,
          top: 0
        },
        children: enablePagination && ['bottom', 'both'].includes(positionPagination !== null && positionPagination !== void 0 ? positionPagination : '') && jsx(MRT_TablePagination, {
          table: table,
          position: "bottom"
        })
      })]
    })]
  }));
};
var MRT_TableHeadCellColumnActionsButton = function MRT_TableHeadCellColumnActionsButton(_ref29) {
  var header = _ref29.header,
    table = _ref29.table;
  var _a;
  var _table$options25 = table.options,
    MoreVertIcon = _table$options25.icons.MoreVertIcon,
    localization = _table$options25.localization,
    muiTableHeadCellColumnActionsButtonProps = _table$options25.muiTableHeadCellColumnActionsButtonProps;
  var column = header.column;
  var columnDef = column.columnDef;
  var _useState15 = useState(null),
    _useState16 = _slicedToArray(_useState15, 2),
    anchorEl = _useState16[0],
    setAnchorEl = _useState16[1];
  var handleClick = function handleClick(event) {
    event.stopPropagation();
    event.preventDefault();
    setAnchorEl(event.currentTarget);
  };
  var mTableHeadCellColumnActionsButtonProps = muiTableHeadCellColumnActionsButtonProps instanceof Function ? muiTableHeadCellColumnActionsButtonProps({
    column: column,
    table: table
  }) : muiTableHeadCellColumnActionsButtonProps;
  var mcTableHeadCellColumnActionsButtonProps = columnDef.muiTableHeadCellColumnActionsButtonProps instanceof Function ? columnDef.muiTableHeadCellColumnActionsButtonProps({
    column: column,
    table: table
  }) : columnDef.muiTableHeadCellColumnActionsButtonProps;
  var iconButtonProps = Object.assign(Object.assign({}, mTableHeadCellColumnActionsButtonProps), mcTableHeadCellColumnActionsButtonProps);
  return jsxs(Fragment, {
    children: [jsx(Tooltip, {
      arrow: true,
      enterDelay: 1000,
      enterNextDelay: 1000,
      placement: "top",
      title: (_a = iconButtonProps === null || iconButtonProps === void 0 ? void 0 : iconButtonProps.title) !== null && _a !== void 0 ? _a : localization.columnActions,
      children: jsx(IconButton, Object.assign({
        "aria-label": localization.columnActions,
        onClick: handleClick,
        size: "small"
      }, iconButtonProps, {
        sx: function sx(theme) {
          return Object.assign({
            height: '2rem',
            m: '-8px -4px',
            opacity: 0.5,
            transform: 'scale(0.85) translateX(-4px)',
            transition: 'opacity 150ms',
            width: '2rem',
            '&:hover': {
              opacity: 1
            }
          }, (iconButtonProps === null || iconButtonProps === void 0 ? void 0 : iconButtonProps.sx) instanceof Function ? iconButtonProps.sx(theme) : iconButtonProps === null || iconButtonProps === void 0 ? void 0 : iconButtonProps.sx);
        },
        title: undefined,
        children: jsx(MoreVertIcon, {})
      }))
    }), anchorEl && jsx(MRT_ColumnActionMenu, {
      anchorEl: anchorEl,
      header: header,
      setAnchorEl: setAnchorEl,
      table: table
    })]
  });
};
var MRT_FilterTextField = function MRT_FilterTextField(_ref30) {
  var header = _ref30.header,
    rangeFilterIndex = _ref30.rangeFilterIndex,
    table = _ref30.table;
  var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k;
  var _table$options26 = table.options,
    enableColumnFilterModes = _table$options26.enableColumnFilterModes,
    columnFilterModeOptions = _table$options26.columnFilterModeOptions,
    _table$options26$icon = _table$options26.icons,
    FilterListIcon = _table$options26$icon.FilterListIcon,
    CloseIcon = _table$options26$icon.CloseIcon,
    localization = _table$options26.localization,
    manualFiltering = _table$options26.manualFiltering,
    muiTableHeadCellFilterTextFieldProps = _table$options26.muiTableHeadCellFilterTextFieldProps,
    filterInputRefs = table.refs.filterInputRefs,
    setColumnFilterFns = table.setColumnFilterFns;
  var column = header.column;
  var columnDef = column.columnDef;
  var mTableHeadCellFilterTextFieldProps = muiTableHeadCellFilterTextFieldProps instanceof Function ? muiTableHeadCellFilterTextFieldProps({
    column: column,
    table: table,
    rangeFilterIndex: rangeFilterIndex
  }) : muiTableHeadCellFilterTextFieldProps;
  var mcTableHeadCellFilterTextFieldProps = columnDef.muiTableHeadCellFilterTextFieldProps instanceof Function ? columnDef.muiTableHeadCellFilterTextFieldProps({
    column: column,
    table: table,
    rangeFilterIndex: rangeFilterIndex
  }) : columnDef.muiTableHeadCellFilterTextFieldProps;
  var textFieldProps = Object.assign(Object.assign({}, mTableHeadCellFilterTextFieldProps), mcTableHeadCellFilterTextFieldProps);
  var isRangeFilter = columnDef.filterVariant === 'range' || rangeFilterIndex !== undefined;
  var isSelectFilter = columnDef.filterVariant === 'select';
  var isMultiSelectFilter = columnDef.filterVariant === 'multi-select';
  var isTextboxFilter = columnDef.filterVariant === 'text' || !isSelectFilter && !isMultiSelectFilter;
  var currentFilterOption = columnDef._filterFn;
  var filterChipLabel = ['empty', 'notEmpty'].includes(currentFilterOption) ?
  //@ts-ignore
  localization["filter".concat(((_b = (_a = currentFilterOption === null || currentFilterOption === void 0 ? void 0 : currentFilterOption.charAt) === null || _a === void 0 ? void 0 : _a.call(currentFilterOption, 0)) === null || _b === void 0 ? void 0 : _b.toUpperCase()) + (currentFilterOption === null || currentFilterOption === void 0 ? void 0 : currentFilterOption.slice(1)))] : '';
  var filterPlaceholder = !isRangeFilter ? (_c = textFieldProps === null || textFieldProps === void 0 ? void 0 : textFieldProps.placeholder) !== null && _c !== void 0 ? _c : (_d = localization.filterByColumn) === null || _d === void 0 ? void 0 : _d.replace('{column}', String(columnDef.header)) : rangeFilterIndex === 0 ? localization.min : rangeFilterIndex === 1 ? localization.max : '';
  var allowedColumnFilterOptions = (_e = columnDef === null || columnDef === void 0 ? void 0 : columnDef.columnFilterModeOptions) !== null && _e !== void 0 ? _e : columnFilterModeOptions;
  var showChangeModeButton = enableColumnFilterModes && columnDef.enableColumnFilterModes !== false && !rangeFilterIndex && (allowedColumnFilterOptions === undefined || !!(allowedColumnFilterOptions === null || allowedColumnFilterOptions === void 0 ? void 0 : allowedColumnFilterOptions.length));
  var facetedUniqueValues = column.getFacetedUniqueValues();
  var filterSelectOptions = useMemo(function () {
    var _a;
    return (_a = columnDef.filterSelectOptions) !== null && _a !== void 0 ? _a : (isSelectFilter || isMultiSelectFilter) && facetedUniqueValues ? Array.from(facetedUniqueValues.keys()).sort(function (a, b) {
      return a.localeCompare(b);
    }) : undefined;
  }, [columnDef.filterSelectOptions, facetedUniqueValues, isMultiSelectFilter, isSelectFilter]);
  var _useState17 = useState(null),
    _useState18 = _slicedToArray(_useState17, 2),
    anchorEl = _useState18[0],
    setAnchorEl = _useState18[1];
  var _useState19 = useState(function () {
      var _a, _b;
      return isMultiSelectFilter ? column.getFilterValue() || [] : isRangeFilter ? ((_a = column.getFilterValue()) === null || _a === void 0 ? void 0 : _a[rangeFilterIndex]) || [] : (_b = column.getFilterValue()) !== null && _b !== void 0 ? _b : '';
    }),
    _useState20 = _slicedToArray(_useState19, 2),
    filterValue = _useState20[0],
    setFilterValue = _useState20[1];
  var handleChangeDebounced = useCallback(debounce(function (event) {
    var value = textFieldProps.type === 'date' ? event.target.valueAsDate : textFieldProps.type === 'number' ? event.target.valueAsNumber : event.target.value;
    if (isRangeFilter) {
      column.setFilterValue(function (old) {
        var newFilterValues = old !== null && old !== void 0 ? old : ['', ''];
        newFilterValues[rangeFilterIndex] = value;
        return newFilterValues;
      });
    } else {
      column.setFilterValue(value !== null && value !== void 0 ? value : undefined);
    }
  }, isTextboxFilter ? manualFiltering ? 400 : 200 : 1), []);
  var handleChange = function handleChange(event) {
    setFilterValue(event.target.value);
    handleChangeDebounced(event);
  };
  var handleClear = function handleClear() {
    if (isMultiSelectFilter) {
      setFilterValue([]);
      column.setFilterValue([]);
    } else if (isRangeFilter) {
      setFilterValue('');
      column.setFilterValue(function (old) {
        var newFilterValues = Array.isArray(old) && old || ['', ''];
        newFilterValues[rangeFilterIndex] = undefined;
        return newFilterValues;
      });
    } else {
      setFilterValue('');
      column.setFilterValue(undefined);
    }
  };
  var handleClearEmptyFilterChip = function handleClearEmptyFilterChip() {
    setFilterValue('');
    column.setFilterValue(undefined);
    setColumnFilterFns(function (prev) {
      var _a;
      return Object.assign(Object.assign({}, prev), _defineProperty({}, header.id, (_a = allowedColumnFilterOptions === null || allowedColumnFilterOptions === void 0 ? void 0 : allowedColumnFilterOptions[0]) !== null && _a !== void 0 ? _a : 'fuzzy'));
    });
  };
  var handleFilterMenuOpen = function handleFilterMenuOpen(event) {
    setAnchorEl(event.currentTarget);
  };
  var isMounted = useRef(false);
  useEffect(function () {
    if (isMounted.current) {
      var _filterValue2 = column.getFilterValue();
      if (_filterValue2 === undefined) {
        handleClear();
      } else if (isRangeFilter && rangeFilterIndex !== undefined) {
        setFilterValue(_filterValue2[rangeFilterIndex]);
      } else {
        setFilterValue(_filterValue2);
      }
    }
    isMounted.current = true;
  }, [column.getFilterValue()]);
  if (columnDef.Filter) {
    return jsx(Fragment, {
      children: (_f = columnDef.Filter) === null || _f === void 0 ? void 0 : _f.call(columnDef, {
        column: column,
        header: header,
        rangeFilterIndex: rangeFilterIndex,
        table: table
      })
    });
  }
  return jsxs(Fragment, {
    children: [jsxs(TextField, Object.assign({
      fullWidth: true,
      inputProps: {
        disabled: !!filterChipLabel,
        sx: {
          textOverflow: 'ellipsis',
          width: filterChipLabel ? 0 : undefined
        },
        title: filterPlaceholder
      },
      helperText: showChangeModeButton ? jsx("label", {
        children: localization.filterMode.replace('{filterType}',
        // @ts-ignore
        localization["filter".concat(((_g = currentFilterOption === null || currentFilterOption === void 0 ? void 0 : currentFilterOption.charAt(0)) === null || _g === void 0 ? void 0 : _g.toUpperCase()) + (currentFilterOption === null || currentFilterOption === void 0 ? void 0 : currentFilterOption.slice(1)))])
      }) : null,
      FormHelperTextProps: {
        sx: {
          fontSize: '0.75rem',
          lineHeight: '0.8rem',
          whiteSpace: 'nowrap'
        }
      },
      margin: "none",
      placeholder: filterChipLabel || isSelectFilter || isMultiSelectFilter ? undefined : filterPlaceholder,
      onChange: handleChange,
      onClick: function onClick(e) {
        return e.stopPropagation();
      },
      select: isSelectFilter || isMultiSelectFilter,
      value: filterValue !== null && filterValue !== void 0 ? filterValue : '',
      variant: "standard",
      InputProps: {
        startAdornment: showChangeModeButton ? jsxs(InputAdornment, {
          position: "start",
          children: [jsx(Tooltip, {
            arrow: true,
            title: localization.changeFilterMode,
            children: jsx("span", {
              children: jsx(IconButton, {
                "aria-label": localization.changeFilterMode,
                onClick: handleFilterMenuOpen,
                size: "small",
                sx: {
                  height: '1.75rem',
                  width: '1.75rem'
                },
                children: jsx(FilterListIcon, {})
              })
            })
          }), filterChipLabel && jsx(Chip, {
            onDelete: handleClearEmptyFilterChip,
            label: filterChipLabel
          })]
        }) : null,
        endAdornment: !filterChipLabel && jsx(InputAdornment, {
          position: "end",
          children: jsx(Tooltip, {
            arrow: true,
            placement: "right",
            title: (_h = localization.clearFilter) !== null && _h !== void 0 ? _h : '',
            children: jsx("span", {
              children: jsx(IconButton, {
                "aria-label": localization.clearFilter,
                disabled: !((_j = filterValue === null || filterValue === void 0 ? void 0 : filterValue.toString()) === null || _j === void 0 ? void 0 : _j.length),
                onClick: handleClear,
                size: "small",
                sx: {
                  height: '1.75rem',
                  width: '1.75rem'
                },
                children: jsx(CloseIcon, {})
              })
            })
          })
        })
      },
      SelectProps: {
        displayEmpty: true,
        multiple: isMultiSelectFilter,
        renderValue: isMultiSelectFilter ? function (selected) {
          return !(selected === null || selected === void 0 ? void 0 : selected.length) ? jsx(Box, {
            sx: {
              opacity: 0.5
            },
            children: filterPlaceholder
          }) : jsx(Box, {
            sx: {
              display: 'flex',
              flexWrap: 'wrap',
              gap: '2px'
            },
            children: selected === null || selected === void 0 ? void 0 : selected.map(function (value) {
              var selectedValue = filterSelectOptions === null || filterSelectOptions === void 0 ? void 0 : filterSelectOptions.find(function (option) {
                return option instanceof Object ? option.value === value : option === value;
              });
              return jsx(Chip, {
                label: selectedValue instanceof Object ? selectedValue.text : selectedValue
              }, value);
            })
          });
        } : undefined
      }
    }, textFieldProps, {
      inputRef: function inputRef(_inputRef2) {
        filterInputRefs.current["".concat(column.id, "-").concat(rangeFilterIndex !== null && rangeFilterIndex !== void 0 ? rangeFilterIndex : 0)] = _inputRef2;
        if (textFieldProps.inputRef) {
          textFieldProps.inputRef = _inputRef2;
        }
      },
      sx: function sx(theme) {
        return Object.assign({
          p: 0,
          minWidth: isRangeFilter ? '100px' : !filterChipLabel ? '120px' : 'auto',
          width: 'calc(100% + 4px)',
          mx: '-2px',
          '& .MuiSelect-icon': {
            mr: '1.5rem'
          }
        }, (textFieldProps === null || textFieldProps === void 0 ? void 0 : textFieldProps.sx) instanceof Function ? textFieldProps.sx(theme) : textFieldProps === null || textFieldProps === void 0 ? void 0 : textFieldProps.sx);
      },
      children: [(isSelectFilter || isMultiSelectFilter) && jsx(MenuItem, {
        divider: true,
        disabled: true,
        hidden: true,
        value: "",
        children: jsx(Box, {
          sx: {
            opacity: 0.5
          },
          children: filterPlaceholder
        })
      }), (_k = textFieldProps.children) !== null && _k !== void 0 ? _k : filterSelectOptions === null || filterSelectOptions === void 0 ? void 0 : filterSelectOptions.map(function (option) {
        var _a;
        if (!option) return '';
        var value;
        var text;
        if (typeof option !== 'object') {
          value = option;
          text = option;
        } else {
          value = option.value;
          text = option.text;
        }
        return jsxs(MenuItem, {
          sx: {
            display: 'flex',
            m: 0,
            alignItems: 'center',
            gap: '0.5rem'
          },
          value: value,
          children: [isMultiSelectFilter && jsx(Checkbox, {
            checked: ((_a = column.getFilterValue()) !== null && _a !== void 0 ? _a : []).includes(value),
            sx: {
              mr: '0.5rem'
            }
          }), text, ' ', !columnDef.filterSelectOptions && "(".concat(facetedUniqueValues.get(value), ")")]
        }, value);
      })]
    })), jsx(MRT_FilterOptionMenu, {
      anchorEl: anchorEl,
      header: header,
      setAnchorEl: setAnchorEl,
      table: table,
      setFilterValue: setFilterValue
    })]
  });
};
var MRT_FilterRangeFields = function MRT_FilterRangeFields(_ref31) {
  var header = _ref31.header,
    table = _ref31.table;
  return jsxs(Box, {
    sx: {
      display: 'grid',
      gridTemplateColumns: '1fr 1fr',
      gap: '1rem'
    },
    children: [jsx(MRT_FilterTextField, {
      header: header,
      rangeFilterIndex: 0,
      table: table
    }), jsx(MRT_FilterTextField, {
      header: header,
      rangeFilterIndex: 1,
      table: table
    })]
  });
};
var MRT_FilterCheckbox = function MRT_FilterCheckbox(_ref32) {
  var column = _ref32.column,
    table = _ref32.table;
  var _a, _b, _c;
  var getState = table.getState,
    _table$options27 = table.options,
    localization = _table$options27.localization,
    muiTableHeadCellFilterCheckboxProps = _table$options27.muiTableHeadCellFilterCheckboxProps;
  var _getState22 = getState(),
    density = _getState22.density;
  var columnDef = column.columnDef;
  var mTableHeadCellFilterCheckboxProps = muiTableHeadCellFilterCheckboxProps instanceof Function ? muiTableHeadCellFilterCheckboxProps({
    column: column,
    table: table
  }) : muiTableHeadCellFilterCheckboxProps;
  var mcTableHeadCellFilterCheckboxProps = columnDef.muiTableHeadCellFilterCheckboxProps instanceof Function ? columnDef.muiTableHeadCellFilterCheckboxProps({
    column: column,
    table: table
  }) : columnDef.muiTableHeadCellFilterCheckboxProps;
  var checkboxProps = Object.assign(Object.assign({}, mTableHeadCellFilterCheckboxProps), mcTableHeadCellFilterCheckboxProps);
  var filterLabel = (_a = localization.filterByColumn) === null || _a === void 0 ? void 0 : _a.replace('{column}', columnDef.header);
  return jsx(Tooltip, {
    arrow: true,
    enterDelay: 1000,
    enterNextDelay: 1000,
    title: (_b = checkboxProps === null || checkboxProps === void 0 ? void 0 : checkboxProps.title) !== null && _b !== void 0 ? _b : filterLabel,
    children: jsx(FormControlLabel, {
      control: jsx(Checkbox, Object.assign({
        checked: column.getFilterValue() === 'true',
        indeterminate: column.getFilterValue() === undefined,
        color: column.getFilterValue() === undefined ? 'default' : 'primary',
        size: density === 'compact' ? 'small' : 'medium'
      }, checkboxProps, {
        onClick: function onClick(e) {
          var _a;
          e.stopPropagation();
          (_a = checkboxProps === null || checkboxProps === void 0 ? void 0 : checkboxProps.onClick) === null || _a === void 0 ? void 0 : _a.call(checkboxProps, e);
        },
        onChange: function onChange(e, checked) {
          var _a;
          column.setFilterValue(column.getFilterValue() === undefined ? 'true' : column.getFilterValue() === 'true' ? 'false' : undefined);
          (_a = checkboxProps === null || checkboxProps === void 0 ? void 0 : checkboxProps.onChange) === null || _a === void 0 ? void 0 : _a.call(checkboxProps, e, checked);
        },
        sx: function sx(theme) {
          return Object.assign({
            height: '2.5rem',
            width: '2.5rem'
          }, (checkboxProps === null || checkboxProps === void 0 ? void 0 : checkboxProps.sx) instanceof Function ? checkboxProps.sx(theme) : checkboxProps === null || checkboxProps === void 0 ? void 0 : checkboxProps.sx);
        }
      })),
      disableTypography: true,
      label: (_c = checkboxProps.title) !== null && _c !== void 0 ? _c : filterLabel,
      sx: {
        color: 'text.secondary',
        mt: '-4px',
        fontWeight: 'normal'
      },
      title: undefined
    })
  });
};
var MRT_FilterRangeSlider = function MRT_FilterRangeSlider(_ref33) {
  var header = _ref33.header,
    table = _ref33.table;
  var _a, _b;
  var _table$options28 = table.options,
    localization = _table$options28.localization,
    muiTableHeadCellFilterSliderProps = _table$options28.muiTableHeadCellFilterSliderProps,
    enableColumnFilterModes = _table$options28.enableColumnFilterModes,
    filterInputRefs = table.refs.filterInputRefs;
  var column = header.column;
  var columnDef = column.columnDef;
  var currentFilterOption = columnDef._filterFn;
  var showChangeModeButton = enableColumnFilterModes && columnDef.enableColumnFilterModes !== false;
  var mTableHeadCellFilterTextFieldProps = muiTableHeadCellFilterSliderProps instanceof Function ? muiTableHeadCellFilterSliderProps({
    column: column,
    table: table
  }) : muiTableHeadCellFilterSliderProps;
  var mcTableHeadCellFilterTextFieldProps = columnDef.muiTableHeadCellFilterSliderProps instanceof Function ? columnDef.muiTableHeadCellFilterSliderProps({
    column: column,
    table: table
  }) : columnDef.muiTableHeadCellFilterSliderProps;
  var sliderProps = Object.assign(Object.assign({}, mTableHeadCellFilterTextFieldProps), mcTableHeadCellFilterTextFieldProps);
  var _ref34 = sliderProps.min !== undefined && sliderProps.max !== undefined ? [sliderProps.min, sliderProps.max] : (_a = column.getFacetedMinMaxValues()) !== null && _a !== void 0 ? _a : [0, 1],
    _ref35 = _slicedToArray(_ref34, 2),
    min = _ref35[0],
    max = _ref35[1]; //fix potential TanStack Table bugs where min or max is an array
  if (Array.isArray(min)) min = min[0];
  if (Array.isArray(max)) max = max[0];
  if (min === null) min = 0;
  if (max === null) max = 1;
  var _useState21 = useState([min, max]),
    _useState22 = _slicedToArray(_useState21, 2),
    filterValues = _useState22[0],
    setFilterValues = _useState22[1];
  var columnFilterValue = column.getFilterValue();
  var isMounted = useRef(false);
  useEffect(function () {
    if (isMounted.current) {
      if (columnFilterValue === undefined) {
        setFilterValues([min, max]);
      } else if (Array.isArray(columnFilterValue)) {
        setFilterValues(columnFilterValue);
      }
    }
    isMounted.current = true;
  }, [columnFilterValue, min, max]);
  return jsxs(Stack, {
    children: [jsx(Slider, Object.assign({
      disableSwap: true,
      min: min,
      max: max,
      onChange: function onChange(_event, values) {
        setFilterValues(values);
      },
      onChangeCommitted: function onChangeCommitted(_event, value) {
        if (Array.isArray(value)) {
          if (value[0] <= min && value[1] >= max) {
            //if the user has selected the entire range, remove the filter
            column.setFilterValue(undefined);
          } else {
            column.setFilterValue(value);
          }
        }
      },
      value: filterValues,
      valueLabelDisplay: "auto"
    }, sliderProps, {
      slotProps: {
        input: {
          ref: function ref(node) {
            var _a, _b;
            if (node) {
              filterInputRefs.current["".concat(column.id, "-0")] = node;
              // @ts-ignore
              if ((_b = (_a = sliderProps === null || sliderProps === void 0 ? void 0 : sliderProps.slotProps) === null || _a === void 0 ? void 0 : _a.input) === null || _b === void 0 ? void 0 : _b.ref) {
                //@ts-ignore
                sliderProps.slotProps.input.ref = node;
              }
            }
          }
        }
      },
      sx: function sx(theme) {
        return Object.assign({
          m: 'auto',
          mt: !showChangeModeButton ? '10px' : '6px',
          px: '4px',
          width: 'calc(100% - 8px)'
        }, (sliderProps === null || sliderProps === void 0 ? void 0 : sliderProps.sx) instanceof Function ? sliderProps.sx(theme) : sliderProps === null || sliderProps === void 0 ? void 0 : sliderProps.sx);
      }
    })), showChangeModeButton ? jsx(FormHelperText, {
      sx: {
        m: '-3px -6px',
        fontSize: '0.75rem',
        lineHeight: '0.8rem',
        whiteSpace: 'nowrap'
      },
      children: localization.filterMode.replace('{filterType}',
      // @ts-ignore
      localization["filter".concat(((_b = currentFilterOption === null || currentFilterOption === void 0 ? void 0 : currentFilterOption.charAt(0)) === null || _b === void 0 ? void 0 : _b.toUpperCase()) + (currentFilterOption === null || currentFilterOption === void 0 ? void 0 : currentFilterOption.slice(1)))])
    }) : null]
  });
};
var MRT_TableHeadCellFilterContainer = function MRT_TableHeadCellFilterContainer(_ref36) {
  var header = _ref36.header,
    table = _ref36.table;
  var getState = table.getState;
  var _getState23 = getState(),
    showColumnFilters = _getState23.showColumnFilters;
  var column = header.column;
  var columnDef = column.columnDef;
  return jsx(Collapse, {
    in: showColumnFilters,
    mountOnEnter: true,
    unmountOnExit: true,
    children: columnDef.filterVariant === 'checkbox' ? jsx(MRT_FilterCheckbox, {
      column: column,
      table: table
    }) : columnDef.filterVariant === 'range-slider' ? jsx(MRT_FilterRangeSlider, {
      header: header,
      table: table
    }) : columnDef.filterVariant === 'range' || ['between', 'betweenInclusive', 'inNumberRange'].includes(columnDef._filterFn) ? jsx(MRT_FilterRangeFields, {
      header: header,
      table: table
    }) : jsx(MRT_FilterTextField, {
      header: header,
      table: table
    })
  });
};
var MRT_TableHeadCellFilterLabel = function MRT_TableHeadCellFilterLabel(_ref37) {
  var header = _ref37.header,
    table = _ref37.table;
  var _a, _b, _c, _d;
  var _table$options29 = table.options,
    FilterAltIcon = _table$options29.icons.FilterAltIcon,
    localization = _table$options29.localization,
    filterInputRefs = table.refs.filterInputRefs,
    setShowColumnFilters = table.setShowColumnFilters;
  var column = header.column;
  var columnDef = column.columnDef;
  var isRangeFilter = ['range', 'ranger-slider'].includes((_a = columnDef.filterVariant) !== null && _a !== void 0 ? _a : '') || ['between', 'betweenInclusive', 'inNumberRange'].includes(columnDef._filterFn);
  var currentFilterOption = columnDef._filterFn;
  var filterTooltip = localization.filteringByColumn.replace('{column}', String(columnDef.header)).replace('{filterType}',
  // @ts-ignore
  localization["filter".concat(((_b = currentFilterOption === null || currentFilterOption === void 0 ? void 0 : currentFilterOption.charAt(0)) === null || _b === void 0 ? void 0 : _b.toUpperCase()) + (currentFilterOption === null || currentFilterOption === void 0 ? void 0 : currentFilterOption.slice(1)))]).replace('{filterValue}', "\"".concat(Array.isArray(column.getFilterValue()) ? column.getFilterValue().join("\" ".concat(isRangeFilter ? localization.and : localization.or, " \"")) : column.getFilterValue(), "\"")).replace('" "', '');
  return jsx(Grow, {
    unmountOnExit: true,
    in: !!column.getFilterValue() && !isRangeFilter || isRangeFilter && (
    // @ts-ignore
    !!((_c = column.getFilterValue()) === null || _c === void 0 ? void 0 : _c[0]) || !!((_d = column.getFilterValue()) === null || _d === void 0 ? void 0 : _d[1])),
    children: jsx(Box, {
      component: "span",
      sx: {
        flex: '0 0'
      },
      children: jsx(Tooltip, {
        arrow: true,
        placement: "top",
        title: filterTooltip,
        children: jsx(IconButton, {
          disableRipple: true,
          onClick: function onClick(event) {
            setShowColumnFilters(true);
            queueMicrotask(function () {
              var _a, _b;
              (_a = filterInputRefs.current["".concat(column.id, "-0")]) === null || _a === void 0 ? void 0 : _a.focus();
              (_b = filterInputRefs.current["".concat(column.id, "-0")]) === null || _b === void 0 ? void 0 : _b.select();
            });
            event.stopPropagation();
          },
          size: "small",
          sx: {
            height: '12px',
            m: 0,
            opacity: 0.8,
            p: '2px',
            transform: 'scale(0.66)',
            width: '12px'
          },
          children: jsx(FilterAltIcon, {})
        })
      })
    })
  });
};
var MRT_TableHeadCellGrabHandle = function MRT_TableHeadCellGrabHandle(_ref38) {
  var column = _ref38.column,
    table = _ref38.table,
    tableHeadCellRef = _ref38.tableHeadCellRef;
  var getState = table.getState,
    _table$options30 = table.options,
    enableColumnOrdering = _table$options30.enableColumnOrdering,
    muiTableHeadCellDragHandleProps = _table$options30.muiTableHeadCellDragHandleProps,
    setColumnOrder = table.setColumnOrder,
    setDraggingColumn = table.setDraggingColumn,
    setHoveredColumn = table.setHoveredColumn;
  var columnDef = column.columnDef;
  var _getState24 = getState(),
    hoveredColumn = _getState24.hoveredColumn,
    draggingColumn = _getState24.draggingColumn,
    columnOrder = _getState24.columnOrder;
  var mIconButtonProps = muiTableHeadCellDragHandleProps instanceof Function ? muiTableHeadCellDragHandleProps({
    column: column,
    table: table
  }) : muiTableHeadCellDragHandleProps;
  var mcIconButtonProps = columnDef.muiTableHeadCellDragHandleProps instanceof Function ? columnDef.muiTableHeadCellDragHandleProps({
    column: column,
    table: table
  }) : columnDef.muiTableHeadCellDragHandleProps;
  var iconButtonProps = Object.assign(Object.assign({}, mIconButtonProps), mcIconButtonProps);
  var handleDragStart = function handleDragStart(event) {
    var _a;
    (_a = iconButtonProps === null || iconButtonProps === void 0 ? void 0 : iconButtonProps.onDragStart) === null || _a === void 0 ? void 0 : _a.call(iconButtonProps, event);
    setDraggingColumn(column);
    event.dataTransfer.setDragImage(tableHeadCellRef.current, 0, 0);
  };
  var handleDragEnd = function handleDragEnd(event) {
    var _a;
    (_a = iconButtonProps === null || iconButtonProps === void 0 ? void 0 : iconButtonProps.onDragEnd) === null || _a === void 0 ? void 0 : _a.call(iconButtonProps, event);
    if ((hoveredColumn === null || hoveredColumn === void 0 ? void 0 : hoveredColumn.id) === 'drop-zone') {
      column.toggleGrouping();
    } else if (enableColumnOrdering && hoveredColumn && (hoveredColumn === null || hoveredColumn === void 0 ? void 0 : hoveredColumn.id) !== (draggingColumn === null || draggingColumn === void 0 ? void 0 : draggingColumn.id)) {
      setColumnOrder(reorderColumn(column, hoveredColumn, columnOrder));
    }
    setDraggingColumn(null);
    setHoveredColumn(null);
  };
  return jsx(MRT_GrabHandleButton, {
    iconButtonProps: iconButtonProps,
    onDragStart: handleDragStart,
    onDragEnd: handleDragEnd,
    table: table
  });
};
var MRT_TableHeadCellResizeHandle = function MRT_TableHeadCellResizeHandle(_ref39) {
  var header = _ref39.header,
    table = _ref39.table;
  var _a;
  var getState = table.getState,
    columnResizeMode = table.options.columnResizeMode,
    setColumnSizingInfo = table.setColumnSizingInfo;
  var _getState25 = getState(),
    density = _getState25.density;
  var column = header.column;
  return jsx(Box, {
    className: "Mui-TableHeadCell-ResizeHandle-Wrapper",
    onDoubleClick: function onDoubleClick() {
      setColumnSizingInfo(function (old) {
        return Object.assign(Object.assign({}, old), {
          isResizingColumn: false
        });
      });
      column.resetSize();
    },
    onMouseDown: header.getResizeHandler(),
    onTouchStart: header.getResizeHandler(),
    sx: function sx(theme) {
      return {
        cursor: 'col-resize',
        mr: density === 'compact' ? '-0.75rem' : '-1rem',
        position: 'absolute',
        right: '4px',
        px: '4px',
        '&:active > hr': {
          backgroundColor: theme.palette.info.main,
          opacity: 1
        }
      };
    },
    style: {
      transform: column.getIsResizing() && columnResizeMode === 'onEnd' ? "translateX(".concat((_a = getState().columnSizingInfo.deltaOffset) !== null && _a !== void 0 ? _a : 0, "px)") : undefined
    },
    children: jsx(Divider, {
      className: "Mui-TableHeadCell-ResizeHandle-Divider",
      flexItem: true,
      orientation: "vertical",
      sx: {
        borderRadius: '2px',
        borderWidth: '2px',
        height: '24px',
        touchAction: 'none',
        transition: column.getIsResizing() ? undefined : 'all 150ms ease-in-out',
        userSelect: 'none',
        zIndex: 4
      }
    })
  });
};
var MRT_TableHeadCellSortLabel = function MRT_TableHeadCellSortLabel(_ref40) {
  var header = _ref40.header,
    table = _ref40.table,
    tableCellProps = _ref40.tableCellProps;
  var getState = table.getState,
    _table$options31 = table.options,
    ArrowDownwardIcon = _table$options31.icons.ArrowDownwardIcon,
    localization = _table$options31.localization;
  var column = header.column;
  var columnDef = column.columnDef;
  var _getState26 = getState(),
    sorting = _getState26.sorting;
  var sortTooltip = column.getIsSorted() ? column.getIsSorted() === 'desc' ? localization.sortedByColumnDesc.replace('{column}', columnDef.header) : localization.sortedByColumnAsc.replace('{column}', columnDef.header) : localization.unsorted;
  return jsx(Tooltip, {
    arrow: true,
    placement: "top",
    title: sortTooltip,
    children: jsx(Badge, {
      badgeContent: sorting.length > 1 ? column.getSortIndex() + 1 : 0,
      overlap: "circular",
      children: jsx(TableSortLabel, {
        "aria-label": sortTooltip,
        active: !!column.getIsSorted(),
        direction: column.getIsSorted() ? column.getIsSorted() : undefined,
        sx: {
          flex: '0 0',
          width: '2.4ch',
          transform: (tableCellProps === null || tableCellProps === void 0 ? void 0 : tableCellProps.align) !== 'right' ? 'translateX(-0.5ch)' : undefined
        },
        IconComponent: ArrowDownwardIcon,
        onClick: function onClick(e) {
          var _a;
          e.stopPropagation();
          (_a = header.column.getToggleSortingHandler()) === null || _a === void 0 ? void 0 : _a(e);
        }
      })
    })
  });
};
var MRT_TableHeadCell = function MRT_TableHeadCell(_ref41) {
  var header = _ref41.header,
    table = _ref41.table;
  var _a, _b, _c, _d, _f, _g;
  var theme = useTheme();
  var getState = table.getState,
    _table$options32 = table.options,
    enableColumnActions = _table$options32.enableColumnActions,
    enableColumnDragging = _table$options32.enableColumnDragging,
    enableColumnOrdering = _table$options32.enableColumnOrdering,
    enableGrouping = _table$options32.enableGrouping,
    enableMultiSort = _table$options32.enableMultiSort,
    layoutMode = _table$options32.layoutMode,
    muiTableHeadCellProps = _table$options32.muiTableHeadCellProps,
    tableHeadCellRefs = table.refs.tableHeadCellRefs,
    setHoveredColumn = table.setHoveredColumn;
  var _getState27 = getState(),
    density = _getState27.density,
    draggingColumn = _getState27.draggingColumn,
    grouping = _getState27.grouping,
    hoveredColumn = _getState27.hoveredColumn,
    showColumnFilters = _getState27.showColumnFilters;
  var column = header.column;
  var columnDef = column.columnDef;
  var columnDefType = columnDef.columnDefType;
  var mTableHeadCellProps = muiTableHeadCellProps instanceof Function ? muiTableHeadCellProps({
    column: column,
    table: table
  }) : muiTableHeadCellProps;
  var mcTableHeadCellProps = columnDef.muiTableHeadCellProps instanceof Function ? columnDef.muiTableHeadCellProps({
    column: column,
    table: table
  }) : columnDef.muiTableHeadCellProps;
  var tableCellProps = Object.assign(Object.assign({}, mTableHeadCellProps), mcTableHeadCellProps);
  var showColumnActions = (enableColumnActions || columnDef.enableColumnActions) && columnDef.enableColumnActions !== false;
  var showDragHandle = enableColumnDragging !== false && columnDef.enableColumnDragging !== false && (enableColumnDragging || enableColumnOrdering && columnDef.enableColumnOrdering !== false || enableGrouping && columnDef.enableGrouping !== false && !grouping.includes(column.id));
  var headerPL = useMemo(function () {
    var pl = 0;
    if (column.getCanSort()) pl++;
    if (showColumnActions) pl += 1.75;
    if (showDragHandle) pl += 1.25;
    return pl;
  }, [showColumnActions, showDragHandle]);
  var draggingBorder = useMemo(function () {
    return (draggingColumn === null || draggingColumn === void 0 ? void 0 : draggingColumn.id) === column.id ? "1px dashed ".concat(theme.palette.text.secondary) : (hoveredColumn === null || hoveredColumn === void 0 ? void 0 : hoveredColumn.id) === column.id ? "2px dashed ".concat(theme.palette.primary.main) : undefined;
  }, [draggingColumn, hoveredColumn]);
  var draggingBorders = draggingBorder ? {
    borderLeft: draggingBorder,
    borderRight: draggingBorder,
    borderTop: draggingBorder
  } : undefined;
  var handleDragEnter = function handleDragEnter(_e) {
    if (enableGrouping && (hoveredColumn === null || hoveredColumn === void 0 ? void 0 : hoveredColumn.id) === 'drop-zone') {
      setHoveredColumn(null);
    }
    if (enableColumnOrdering && draggingColumn && columnDefType !== 'group') {
      setHoveredColumn(columnDef.enableColumnOrdering !== false ? column : null);
    }
  };
  var headerElement = (columnDef === null || columnDef === void 0 ? void 0 : columnDef.Header) instanceof Function ? (_a = columnDef === null || columnDef === void 0 ? void 0 : columnDef.Header) === null || _a === void 0 ? void 0 : _a.call(columnDef, {
    column: column,
    header: header,
    table: table
  }) : (_b = columnDef === null || columnDef === void 0 ? void 0 : columnDef.Header) !== null && _b !== void 0 ? _b : columnDef.header;
  return jsxs(TableCell, Object.assign({
    align: columnDefType === 'group' ? 'center' : 'left',
    colSpan: header.colSpan,
    onDragEnter: handleDragEnter,
    ref: function ref(node) {
      if (node) {
        tableHeadCellRefs.current[column.id] = node;
      }
    }
  }, tableCellProps, {
    sx: function sx(theme) {
      return Object.assign(Object.assign({
        flexDirection: layoutMode === 'grid' ? 'column' : undefined,
        fontWeight: 'bold',
        overflow: 'visible',
        p: density === 'compact' ? '0.5rem' : density === 'comfortable' ? columnDefType === 'display' ? '0.75rem' : '1rem' : columnDefType === 'display' ? '1rem 1.25rem' : '1.5rem',
        pb: columnDefType === 'display' ? 0 : showColumnFilters || density === 'compact' ? '0.4rem' : '0.6rem',
        pt: columnDefType === 'group' || density === 'compact' ? '0.25rem' : density === 'comfortable' ? '.75rem' : '1.25rem',
        userSelect: enableMultiSort && column.getCanSort() ? 'none' : undefined,
        verticalAlign: 'top',
        zIndex: column.getIsResizing() || (draggingColumn === null || draggingColumn === void 0 ? void 0 : draggingColumn.id) === column.id ? 3 : column.getIsPinned() && columnDefType !== 'group' ? 2 : 1
      }, getCommonCellStyles({
        column: column,
        header: header,
        table: table,
        tableCellProps: tableCellProps,
        theme: theme
      })), draggingBorders);
    },
    children: [header.isPlaceholder ? null : jsxs(Box, {
      className: "Mui-TableHeadCell-Content",
      sx: {
        alignItems: 'center',
        display: 'flex',
        flexDirection: (tableCellProps === null || tableCellProps === void 0 ? void 0 : tableCellProps.align) === 'right' ? 'row-reverse' : 'row',
        justifyContent: columnDefType === 'group' || (tableCellProps === null || tableCellProps === void 0 ? void 0 : tableCellProps.align) === 'center' ? 'center' : column.getCanResize() ? 'space-between' : 'flex-start',
        position: 'relative',
        width: '100%'
      },
      children: [jsxs(Box, {
        className: "Mui-TableHeadCell-Content-Labels",
        onClick: column.getToggleSortingHandler(),
        sx: {
          alignItems: 'center',
          cursor: column.getCanSort() && columnDefType !== 'group' ? 'pointer' : undefined,
          display: 'flex',
          flexDirection: (tableCellProps === null || tableCellProps === void 0 ? void 0 : tableCellProps.align) === 'right' ? 'row-reverse' : 'row',
          overflow: columnDefType === 'data' ? 'hidden' : undefined,
          pl: (tableCellProps === null || tableCellProps === void 0 ? void 0 : tableCellProps.align) === 'center' ? "".concat(headerPL, "rem") : undefined
        },
        children: [jsx(Box, {
          className: "Mui-TableHeadCell-Content-Wrapper",
          sx: {
            minWidth: "".concat(Math.min((_d = (_c = columnDef.header) === null || _c === void 0 ? void 0 : _c.length) !== null && _d !== void 0 ? _d : 0, 5), "ch"),
            overflow: columnDefType === 'data' ? 'hidden' : undefined,
            textOverflow: 'ellipsis',
            whiteSpace: ((_g = (_f = columnDef.header) === null || _f === void 0 ? void 0 : _f.length) !== null && _g !== void 0 ? _g : 0) < 20 ? 'nowrap' : 'normal',
            '&:hover': {
              textOverflow: 'clip'
            }
          },
          title: columnDefType === 'data' ? columnDef.header : undefined,
          children: headerElement
        }), column.getCanSort() && jsx(MRT_TableHeadCellSortLabel, {
          header: header,
          table: table,
          tableCellProps: tableCellProps
        }), column.getCanFilter() && jsx(MRT_TableHeadCellFilterLabel, {
          header: header,
          table: table
        })]
      }), columnDefType !== 'group' && jsxs(Box, {
        className: "Mui-TableHeadCell-Content-Actions",
        sx: {
          whiteSpace: 'nowrap'
        },
        children: [showDragHandle && jsx(MRT_TableHeadCellGrabHandle, {
          column: column,
          table: table,
          tableHeadCellRef: {
            current: tableHeadCellRefs.current[column.id]
          }
        }), showColumnActions && jsx(MRT_TableHeadCellColumnActionsButton, {
          header: header,
          table: table
        })]
      }), column.getCanResize() && jsx(MRT_TableHeadCellResizeHandle, {
        header: header,
        table: table
      })]
    }), column.getCanFilter() && jsx(MRT_TableHeadCellFilterContainer, {
      header: header,
      table: table
    })]
  }));
};
var MRT_TableHeadRow = function MRT_TableHeadRow(_ref42) {
  var headerGroup = _ref42.headerGroup,
    table = _ref42.table,
    virtualColumns = _ref42.virtualColumns,
    virtualPaddingLeft = _ref42.virtualPaddingLeft,
    virtualPaddingRight = _ref42.virtualPaddingRight;
  var _table$options33 = table.options,
    layoutMode = _table$options33.layoutMode,
    muiTableHeadRowProps = _table$options33.muiTableHeadRowProps;
  var tableRowProps = muiTableHeadRowProps instanceof Function ? muiTableHeadRowProps({
    headerGroup: headerGroup,
    table: table
  }) : muiTableHeadRowProps;
  return jsxs(TableRow, Object.assign({}, tableRowProps, {
    sx: function sx(theme) {
      return Object.assign({
        backgroundColor: lighten(theme.palette.background.default, 0.04),
        boxShadow: "4px 0 8px ".concat(alpha(theme.palette.common.black, 0.1)),
        display: layoutMode === 'grid' ? 'flex' : 'table-row',
        top: 0
      }, (tableRowProps === null || tableRowProps === void 0 ? void 0 : tableRowProps.sx) instanceof Function ? tableRowProps === null || tableRowProps === void 0 ? void 0 : tableRowProps.sx(theme) : tableRowProps === null || tableRowProps === void 0 ? void 0 : tableRowProps.sx);
    },
    children: [virtualPaddingLeft ? jsx("th", {
      style: {
        display: 'flex',
        width: virtualPaddingLeft
      }
    }) : null, (virtualColumns !== null && virtualColumns !== void 0 ? virtualColumns : headerGroup.headers).map(function (headerOrVirtualHeader) {
      var header = virtualColumns ? headerGroup.headers[headerOrVirtualHeader.index] : headerOrVirtualHeader;
      return jsx(MRT_TableHeadCell, {
        header: header,
        table: table
      }, header.id);
    }), virtualPaddingRight ? jsx("th", {
      style: {
        display: 'flex',
        width: virtualPaddingRight
      }
    }) : null]
  }));
};
var MRT_TableHead = function MRT_TableHead(_ref43) {
  var table = _ref43.table,
    virtualColumns = _ref43.virtualColumns,
    virtualPaddingLeft = _ref43.virtualPaddingLeft,
    virtualPaddingRight = _ref43.virtualPaddingRight;
  var getHeaderGroups = table.getHeaderGroups,
    getState = table.getState,
    _table$options34 = table.options,
    enableStickyHeader = _table$options34.enableStickyHeader,
    layoutMode = _table$options34.layoutMode,
    muiTableHeadProps = _table$options34.muiTableHeadProps;
  var _getState28 = getState(),
    isFullScreen = _getState28.isFullScreen;
  var tableHeadProps = muiTableHeadProps instanceof Function ? muiTableHeadProps({
    table: table
  }) : muiTableHeadProps;
  var stickyHeader = enableStickyHeader || isFullScreen;
  return jsx(TableHead, Object.assign({}, tableHeadProps, {
    sx: function sx(theme) {
      return Object.assign({
        display: layoutMode === 'grid' ? 'grid' : 'table-row-group',
        opacity: 0.97,
        position: stickyHeader ? 'sticky' : 'relative',
        top: stickyHeader && layoutMode === 'grid' ? 0 : undefined,
        zIndex: stickyHeader ? 2 : undefined
      }, (tableHeadProps === null || tableHeadProps === void 0 ? void 0 : tableHeadProps.sx) instanceof Function ? tableHeadProps === null || tableHeadProps === void 0 ? void 0 : tableHeadProps.sx(theme) : tableHeadProps === null || tableHeadProps === void 0 ? void 0 : tableHeadProps.sx);
    },
    children: getHeaderGroups().map(function (headerGroup) {
      return jsx(MRT_TableHeadRow, {
        headerGroup: headerGroup,
        table: table,
        virtualColumns: virtualColumns,
        virtualPaddingLeft: virtualPaddingLeft,
        virtualPaddingRight: virtualPaddingRight
      }, headerGroup.id);
    })
  }));
};
var MRT_EditCellTextField = function MRT_EditCellTextField(_ref44) {
  var cell = _ref44.cell,
    showLabel = _ref44.showLabel,
    table = _ref44.table;
  var _a, _b, _c;
  var getState = table.getState,
    muiTableBodyCellEditTextFieldProps = table.options.muiTableBodyCellEditTextFieldProps,
    editInputRefs = table.refs.editInputRefs,
    setEditingCell = table.setEditingCell,
    setEditingRow = table.setEditingRow;
  var column = cell.column,
    row = cell.row;
  var columnDef = column.columnDef;
  var _getState29 = getState(),
    editingRow = _getState29.editingRow;
  var _useState23 = useState(function () {
      return cell.getValue();
    }),
    _useState24 = _slicedToArray(_useState23, 2),
    value = _useState24[0],
    setValue = _useState24[1];
  var mTableBodyCellEditTextFieldProps = muiTableBodyCellEditTextFieldProps instanceof Function ? muiTableBodyCellEditTextFieldProps({
    cell: cell,
    column: column,
    row: row,
    table: table
  }) : muiTableBodyCellEditTextFieldProps;
  var mcTableBodyCellEditTextFieldProps = columnDef.muiTableBodyCellEditTextFieldProps instanceof Function ? columnDef.muiTableBodyCellEditTextFieldProps({
    cell: cell,
    column: column,
    row: row,
    table: table
  }) : columnDef.muiTableBodyCellEditTextFieldProps;
  var textFieldProps = Object.assign(Object.assign({}, mTableBodyCellEditTextFieldProps), mcTableBodyCellEditTextFieldProps);
  var isSelectEdit = columnDef.editVariant === 'select';
  var saveRow = function saveRow(newValue) {
    if (editingRow) {
      setEditingRow(Object.assign(Object.assign({}, editingRow), {
        _valuesCache: Object.assign(Object.assign({}, editingRow._valuesCache), _defineProperty({}, column.id, newValue))
      }));
    }
  };
  var handleChange = function handleChange(event) {
    var _a;
    (_a = textFieldProps.onChange) === null || _a === void 0 ? void 0 : _a.call(textFieldProps, event);
    setValue(event.target.value);
    if (textFieldProps === null || textFieldProps === void 0 ? void 0 : textFieldProps.select) {
      saveRow(event.target.value);
    }
  };
  var handleBlur = function handleBlur(event) {
    var _a;
    (_a = textFieldProps.onBlur) === null || _a === void 0 ? void 0 : _a.call(textFieldProps, event);
    saveRow(value);
    setEditingCell(null);
  };
  var handleEnterKeyDown = function handleEnterKeyDown(event) {
    var _a, _b;
    (_a = textFieldProps.onKeyDown) === null || _a === void 0 ? void 0 : _a.call(textFieldProps, event);
    if (event.key === 'Enter') {
      (_b = editInputRefs.current[column.id]) === null || _b === void 0 ? void 0 : _b.blur();
    }
  };
  if (columnDef.Edit) {
    return jsx(Fragment, {
      children: (_a = columnDef.Edit) === null || _a === void 0 ? void 0 : _a.call(columnDef, {
        cell: cell,
        column: column,
        row: row,
        table: table
      })
    });
  }
  return jsx(TextField, Object.assign({
    disabled: (columnDef.enableEditing instanceof Function ? columnDef.enableEditing(row) : columnDef.enableEditing) === false,
    fullWidth: true,
    inputRef: function inputRef(_inputRef3) {
      if (_inputRef3) {
        editInputRefs.current[column.id] = _inputRef3;
        if (textFieldProps.inputRef) {
          textFieldProps.inputRef = _inputRef3;
        }
      }
    },
    label: showLabel ? column.columnDef.header : undefined,
    margin: "none",
    name: column.id,
    placeholder: columnDef.header,
    select: isSelectEdit,
    value: value,
    variant: "standard"
  }, textFieldProps, {
    onClick: function onClick(e) {
      var _a;
      e.stopPropagation();
      (_a = textFieldProps === null || textFieldProps === void 0 ? void 0 : textFieldProps.onClick) === null || _a === void 0 ? void 0 : _a.call(textFieldProps, e);
    },
    onBlur: handleBlur,
    onChange: handleChange,
    onKeyDown: handleEnterKeyDown,
    children: (_b = textFieldProps.children) !== null && _b !== void 0 ? _b : (_c = columnDef === null || columnDef === void 0 ? void 0 : columnDef.editSelectOptions) === null || _c === void 0 ? void 0 : _c.map(function (option) {
      var value;
      var text;
      if (typeof option !== 'object') {
        value = option;
        text = option;
      } else {
        value = option.value;
        text = option.text;
      }
      return jsx(MenuItem, {
        sx: {
          display: 'flex',
          m: 0,
          alignItems: 'center',
          gap: '0.5rem'
        },
        value: value,
        children: text
      }, value);
    })
  }));
};
var MRT_CopyButton = function MRT_CopyButton(_ref45) {
  var cell = _ref45.cell,
    children = _ref45.children,
    table = _ref45.table;
  var _a;
  var _table$options35 = table.options,
    localization = _table$options35.localization,
    muiTableBodyCellCopyButtonProps = _table$options35.muiTableBodyCellCopyButtonProps;
  var column = cell.column,
    row = cell.row;
  var columnDef = column.columnDef;
  var _useState25 = useState(false),
    _useState26 = _slicedToArray(_useState25, 2),
    copied = _useState26[0],
    setCopied = _useState26[1];
  var handleCopy = function handleCopy(event, text) {
    event.stopPropagation();
    navigator.clipboard.writeText(text);
    setCopied(true);
    setTimeout(function () {
      return setCopied(false);
    }, 4000);
  };
  var mTableBodyCellCopyButtonProps = muiTableBodyCellCopyButtonProps instanceof Function ? muiTableBodyCellCopyButtonProps({
    cell: cell,
    column: column,
    row: row,
    table: table
  }) : muiTableBodyCellCopyButtonProps;
  var mcTableBodyCellCopyButtonProps = columnDef.muiTableBodyCellCopyButtonProps instanceof Function ? columnDef.muiTableBodyCellCopyButtonProps({
    cell: cell,
    column: column,
    row: row,
    table: table
  }) : columnDef.muiTableBodyCellCopyButtonProps;
  var buttonProps = Object.assign(Object.assign({}, mTableBodyCellCopyButtonProps), mcTableBodyCellCopyButtonProps);
  return jsx(Tooltip, {
    arrow: true,
    enterDelay: 1000,
    enterNextDelay: 1000,
    placement: "top",
    title: (_a = buttonProps === null || buttonProps === void 0 ? void 0 : buttonProps.title) !== null && _a !== void 0 ? _a : copied ? localization.copiedToClipboard : localization.clickToCopy,
    children: jsx(Button, Object.assign({
      onClick: function onClick(e) {
        return handleCopy(e, cell.getValue());
      },
      size: "small",
      type: "button",
      variant: "text"
    }, buttonProps, {
      sx: function sx(theme) {
        return Object.assign({
          backgroundColor: 'transparent',
          border: 'none',
          color: 'inherit',
          cursor: 'copy',
          fontFamily: 'inherit',
          fontSize: 'inherit',
          letterSpacing: 'inherit',
          m: '-0.25rem',
          minWidth: 'unset',
          textAlign: 'inherit',
          textTransform: 'inherit'
        }, (buttonProps === null || buttonProps === void 0 ? void 0 : buttonProps.sx) instanceof Function ? buttonProps.sx(theme) : buttonProps === null || buttonProps === void 0 ? void 0 : buttonProps.sx);
      },
      title: undefined,
      children: children
    }))
  });
};
var MRT_TableBodyRowGrabHandle = function MRT_TableBodyRowGrabHandle(_ref46) {
  var cell = _ref46.cell,
    rowRef = _ref46.rowRef,
    table = _ref46.table;
  var muiTableBodyRowDragHandleProps = table.options.muiTableBodyRowDragHandleProps;
  var row = cell.row;
  var iconButtonProps = muiTableBodyRowDragHandleProps instanceof Function ? muiTableBodyRowDragHandleProps({
    row: row,
    table: table
  }) : muiTableBodyRowDragHandleProps;
  var handleDragStart = function handleDragStart(event) {
    var _a;
    (_a = iconButtonProps === null || iconButtonProps === void 0 ? void 0 : iconButtonProps.onDragStart) === null || _a === void 0 ? void 0 : _a.call(iconButtonProps, event);
    event.dataTransfer.setDragImage(rowRef.current, 0, 0);
    table.setDraggingRow(row);
  };
  var handleDragEnd = function handleDragEnd(event) {
    var _a;
    (_a = iconButtonProps === null || iconButtonProps === void 0 ? void 0 : iconButtonProps.onDragEnd) === null || _a === void 0 ? void 0 : _a.call(iconButtonProps, event);
    table.setDraggingRow(null);
    table.setHoveredRow(null);
  };
  return jsx(MRT_GrabHandleButton, {
    iconButtonProps: iconButtonProps,
    onDragStart: handleDragStart,
    onDragEnd: handleDragEnd,
    table: table
  });
};
var allowedTypes = ['string', 'number'];
var MRT_TableBodyCellValue = function MRT_TableBodyCellValue(_ref47) {
  var cell = _ref47.cell,
    table = _ref47.table;
  var _a, _b, _c;
  var getState = table.getState,
    enableFilterMatchHighlighting = table.options.enableFilterMatchHighlighting;
  var column = cell.column,
    row = cell.row;
  var columnDef = column.columnDef;
  var _getState30 = getState(),
    globalFilter = _getState30.globalFilter,
    globalFilterFn = _getState30.globalFilterFn;
  var filterValue = column.getFilterValue();
  var renderedCellValue = cell.getIsAggregated() && columnDef.AggregatedCell ? columnDef.AggregatedCell({
    cell: cell,
    column: column,
    row: row,
    table: table
  }) : row.getIsGrouped() && !cell.getIsGrouped() ? null : cell.getIsGrouped() && columnDef.GroupedCell ? columnDef.GroupedCell({
    cell: cell,
    column: column,
    row: row,
    table: table
  }) : undefined;
  var isGroupedValue = renderedCellValue !== undefined;
  if (!isGroupedValue) {
    renderedCellValue = cell.renderValue();
  }
  if (enableFilterMatchHighlighting && columnDef.enableFilterMatchHighlighting !== false && renderedCellValue && allowedTypes.includes(typeof renderedCellValue) && (filterValue && allowedTypes.includes(typeof filterValue) && columnDef.filterVariant === 'text' || globalFilter && allowedTypes.includes(typeof globalFilter) && column.getCanGlobalFilter())) {
    var chunks = highlightWords === null || highlightWords === void 0 ? void 0 : highlightWords({
      text: renderedCellValue === null || renderedCellValue === void 0 ? void 0 : renderedCellValue.toString(),
      query: ((_a = filterValue !== null && filterValue !== void 0 ? filterValue : globalFilter) !== null && _a !== void 0 ? _a : '').toString(),
      matchExactly: (filterValue ? columnDef._filterFn : globalFilterFn) !== 'fuzzy'
    });
    if ((chunks === null || chunks === void 0 ? void 0 : chunks.length) > 1 || ((_b = chunks === null || chunks === void 0 ? void 0 : chunks[0]) === null || _b === void 0 ? void 0 : _b.match)) {
      renderedCellValue = jsx("span", {
        "aria-label": renderedCellValue,
        role: "note",
        children: (_c = chunks === null || chunks === void 0 ? void 0 : chunks.map(function (_ref48) {
          var key = _ref48.key,
            match = _ref48.match,
            text = _ref48.text;
          return jsx(Box, {
            "aria-hidden": "true",
            component: "span",
            sx: match ? {
              backgroundColor: function backgroundColor(theme) {
                return theme.palette.mode === 'dark' ? darken(theme.palette.warning.dark, 0.25) : lighten(theme.palette.warning.light, 0.5);
              },
              borderRadius: '2px',
              color: function color(theme) {
                return theme.palette.mode === 'dark' ? 'white' : 'black';
              },
              padding: '2px 1px'
            } : undefined,
            children: text
          }, key);
        })) !== null && _c !== void 0 ? _c : renderedCellValue
      });
    }
  }
  if (columnDef.Cell && !isGroupedValue) {
    renderedCellValue = columnDef.Cell({
      cell: cell,
      renderedCellValue: renderedCellValue,
      column: column,
      row: row,
      table: table
    });
  }
  return jsx(Fragment, {
    children: renderedCellValue
  });
};
var MRT_TableBodyCell = function MRT_TableBodyCell(_ref49) {
  var cell = _ref49.cell,
    measureElement = _ref49.measureElement,
    numRows = _ref49.numRows,
    rowIndex = _ref49.rowIndex,
    rowRef = _ref49.rowRef,
    table = _ref49.table,
    virtualCell = _ref49.virtualCell;
  var _a, _b, _c, _d;
  var theme = useTheme();
  var getState = table.getState,
    _table$options36 = table.options,
    editingMode = _table$options36.editingMode,
    enableClickToCopy = _table$options36.enableClickToCopy,
    enableColumnOrdering = _table$options36.enableColumnOrdering,
    enableEditing = _table$options36.enableEditing,
    enableGrouping = _table$options36.enableGrouping,
    enableRowNumbers = _table$options36.enableRowNumbers,
    layoutMode = _table$options36.layoutMode,
    muiTableBodyCellProps = _table$options36.muiTableBodyCellProps,
    muiTableBodyCellSkeletonProps = _table$options36.muiTableBodyCellSkeletonProps,
    rowNumberMode = _table$options36.rowNumberMode,
    editInputRefs = table.refs.editInputRefs,
    setEditingCell = table.setEditingCell,
    setHoveredColumn = table.setHoveredColumn;
  var _getState31 = getState(),
    draggingColumn = _getState31.draggingColumn,
    draggingRow = _getState31.draggingRow,
    editingCell = _getState31.editingCell,
    editingRow = _getState31.editingRow,
    hoveredColumn = _getState31.hoveredColumn,
    hoveredRow = _getState31.hoveredRow,
    density = _getState31.density,
    isLoading = _getState31.isLoading,
    showSkeletons = _getState31.showSkeletons;
  var column = cell.column,
    row = cell.row;
  var columnDef = column.columnDef;
  var columnDefType = columnDef.columnDefType;
  var mTableCellBodyProps = muiTableBodyCellProps instanceof Function ? muiTableBodyCellProps({
    cell: cell,
    column: column,
    row: row,
    table: table
  }) : muiTableBodyCellProps;
  var mcTableCellBodyProps = columnDef.muiTableBodyCellProps instanceof Function ? columnDef.muiTableBodyCellProps({
    cell: cell,
    column: column,
    row: row,
    table: table
  }) : columnDef.muiTableBodyCellProps;
  var tableCellProps = Object.assign(Object.assign({}, mTableCellBodyProps), mcTableCellBodyProps);
  var skeletonProps = muiTableBodyCellSkeletonProps instanceof Function ? muiTableBodyCellSkeletonProps({
    cell: cell,
    column: column,
    row: row,
    table: table
  }) : muiTableBodyCellSkeletonProps;
  var _useState27 = useState(0),
    _useState28 = _slicedToArray(_useState27, 2),
    skeletonWidth = _useState28[0],
    setSkeletonWidth = _useState28[1];
  useEffect(function () {
    return setSkeletonWidth(isLoading || showSkeletons ? columnDefType === 'display' ? column.getSize() / 2 : Math.round(Math.random() * (column.getSize() - column.getSize() / 3) + column.getSize() / 3) : 100);
  }, []);
  var draggingBorders = useMemo(function () {
    var isDraggingColumn = (draggingColumn === null || draggingColumn === void 0 ? void 0 : draggingColumn.id) === column.id;
    var isHoveredColumn = (hoveredColumn === null || hoveredColumn === void 0 ? void 0 : hoveredColumn.id) === column.id;
    var isDraggingRow = (draggingRow === null || draggingRow === void 0 ? void 0 : draggingRow.id) === row.id;
    var isHoveredRow = (hoveredRow === null || hoveredRow === void 0 ? void 0 : hoveredRow.id) === row.id;
    var isFirstColumn = getIsFirstColumn(column, table);
    var isLastColumn = getIsLastColumn(column, table);
    var isLastRow = rowIndex === numRows - 1;
    var borderStyle = isDraggingColumn || isDraggingRow ? "1px dashed ".concat(theme.palette.text.secondary, " !important") : isHoveredColumn || isHoveredRow ? "2px dashed ".concat(theme.palette.primary.main, " !important") : undefined;
    return borderStyle ? {
      borderLeft: isDraggingColumn || isHoveredColumn || (isDraggingRow || isHoveredRow) && isFirstColumn ? borderStyle : undefined,
      borderRight: isDraggingColumn || isHoveredColumn || (isDraggingRow || isHoveredRow) && isLastColumn ? borderStyle : undefined,
      borderBottom: isDraggingRow || isHoveredRow || isLastRow ? borderStyle : undefined,
      borderTop: isDraggingRow || isHoveredRow ? borderStyle : undefined
    } : undefined;
  }, [draggingColumn, draggingRow, hoveredColumn, hoveredRow, rowIndex]);
  var isEditable = (enableEditing instanceof Function ? enableEditing(row) : enableEditing) && (columnDef.enableEditing instanceof Function ? columnDef.enableEditing(row) : columnDef.enableEditing) !== false;
  var isEditing = isEditable && editingMode !== 'modal' && (editingMode === 'table' || (editingRow === null || editingRow === void 0 ? void 0 : editingRow.id) === row.id || (editingCell === null || editingCell === void 0 ? void 0 : editingCell.id) === cell.id) && !row.getIsGrouped();
  var handleDoubleClick = function handleDoubleClick(event) {
    var _a;
    (_a = tableCellProps === null || tableCellProps === void 0 ? void 0 : tableCellProps.onDoubleClick) === null || _a === void 0 ? void 0 : _a.call(tableCellProps, event);
    if (isEditable && editingMode === 'cell') {
      setEditingCell(cell);
      queueMicrotask(function () {
        var _a;
        var textField = editInputRefs.current[column.id];
        if (textField) {
          textField.focus();
          (_a = textField.select) === null || _a === void 0 ? void 0 : _a.call(textField);
        }
      });
    }
  };
  var handleDragEnter = function handleDragEnter(e) {
    var _a;
    (_a = tableCellProps === null || tableCellProps === void 0 ? void 0 : tableCellProps.onDragEnter) === null || _a === void 0 ? void 0 : _a.call(tableCellProps, e);
    if (enableGrouping && (hoveredColumn === null || hoveredColumn === void 0 ? void 0 : hoveredColumn.id) === 'drop-zone') {
      setHoveredColumn(null);
    }
    if (enableColumnOrdering && draggingColumn) {
      setHoveredColumn(columnDef.enableColumnOrdering !== false ? column : null);
    }
  };
  return jsx(TableCell, Object.assign({
    "data-index": virtualCell === null || virtualCell === void 0 ? void 0 : virtualCell.index,
    ref: function ref(node) {
      if (node) {
        measureElement === null || measureElement === void 0 ? void 0 : measureElement(node);
      }
    }
  }, tableCellProps, {
    onDragEnter: handleDragEnter,
    onDoubleClick: handleDoubleClick,
    sx: function sx(theme) {
      return Object.assign(Object.assign({
        alignItems: layoutMode === 'grid' ? 'center' : undefined,
        cursor: isEditable && editingMode === 'cell' ? 'pointer' : 'inherit',
        justifyContent: layoutMode === 'grid' ? tableCellProps.align : undefined,
        overflow: 'hidden',
        p: density === 'compact' ? columnDefType === 'display' ? '0 0.5rem' : '0.5rem' : density === 'comfortable' ? columnDefType === 'display' ? '0.5rem 0.75rem' : '1rem' : columnDefType === 'display' ? '1rem 1.25rem' : '1.5rem',
        pl: column.id === 'mrt-row-expand' ? "".concat(row.depth + (density === 'compact' ? 0.5 : density === 'comfortable' ? 0.75 : 1.25), "rem") : undefined,
        textOverflow: columnDefType !== 'display' ? 'ellipsis' : undefined,
        whiteSpace: density === 'compact' ? 'nowrap' : 'normal',
        zIndex: (draggingColumn === null || draggingColumn === void 0 ? void 0 : draggingColumn.id) === column.id ? 2 : column.getIsPinned() ? 1 : 0,
        '&:hover': {
          outline: ['table', 'cell'].includes(editingMode !== null && editingMode !== void 0 ? editingMode : '') ? "1px solid ".concat(theme.palette.text.secondary) : undefined,
          outlineOffset: '-1px',
          textOverflow: 'clip'
        }
      }, getCommonCellStyles({
        column: column,
        table: table,
        theme: theme,
        tableCellProps: tableCellProps
      })), draggingBorders);
    },
    children: jsxs(Fragment, {
      children: [cell.getIsPlaceholder() ? (_b = (_a = columnDef.PlaceholderCell) === null || _a === void 0 ? void 0 : _a.call(columnDef, {
        cell: cell,
        column: column,
        row: row,
        table: table
      })) !== null && _b !== void 0 ? _b : null : isLoading || showSkeletons ? jsx(Skeleton, Object.assign({
        animation: "wave",
        height: 20,
        width: skeletonWidth
      }, skeletonProps)) : enableRowNumbers && rowNumberMode === 'static' && column.id === 'mrt-row-numbers' ? rowIndex + 1 : column.id === 'mrt-row-drag' ? jsx(MRT_TableBodyRowGrabHandle, {
        cell: cell,
        rowRef: rowRef,
        table: table
      }) : columnDefType === 'display' && (column.id === 'mrt-row-select' || column.id === 'mrt-row-expand' || !row.getIsGrouped()) ? (_c = columnDef.Cell) === null || _c === void 0 ? void 0 : _c.call(columnDef, {
        cell: cell,
        renderedCellValue: cell.renderValue(),
        column: column,
        row: row,
        table: table
      }) : isEditing ? jsx(MRT_EditCellTextField, {
        cell: cell,
        table: table
      }) : (enableClickToCopy || columnDef.enableClickToCopy) && columnDef.enableClickToCopy !== false ? jsx(MRT_CopyButton, {
        cell: cell,
        table: table,
        children: jsx(MRT_TableBodyCellValue, {
          cell: cell,
          table: table
        })
      }) : jsx(MRT_TableBodyCellValue, {
        cell: cell,
        table: table
      }), cell.getIsGrouped() && !columnDef.GroupedCell && jsxs(Fragment, {
        children: [" (", (_d = row.subRows) === null || _d === void 0 ? void 0 : _d.length, ")"]
      })]
    })
  }));
};
var Memo_MRT_TableBodyCell = memo(MRT_TableBodyCell, function (prev, next) {
  return next.cell === prev.cell;
});
var MRT_TableDetailPanel = function MRT_TableDetailPanel(_ref50) {
  var parentRowRef = _ref50.parentRowRef,
    row = _ref50.row,
    rowIndex = _ref50.rowIndex,
    table = _ref50.table,
    virtualRow = _ref50.virtualRow;
  var getVisibleLeafColumns = table.getVisibleLeafColumns,
    getState = table.getState,
    _table$options37 = table.options,
    layoutMode = _table$options37.layoutMode,
    muiTableBodyRowProps = _table$options37.muiTableBodyRowProps,
    muiTableDetailPanelProps = _table$options37.muiTableDetailPanelProps,
    renderDetailPanel = _table$options37.renderDetailPanel;
  var _getState32 = getState(),
    isLoading = _getState32.isLoading;
  var tableRowProps = muiTableBodyRowProps instanceof Function ? muiTableBodyRowProps({
    isDetailPanel: true,
    row: row,
    staticRowIndex: rowIndex,
    table: table
  }) : muiTableBodyRowProps;
  var tableCellProps = muiTableDetailPanelProps instanceof Function ? muiTableDetailPanelProps({
    row: row,
    table: table
  }) : muiTableDetailPanelProps;
  return jsx(TableRow, Object.assign({
    className: "Mui-TableBodyCell-DetailPanel"
  }, tableRowProps, {
    sx: function sx(theme) {
      var _a, _b;
      return Object.assign({
        display: layoutMode === 'grid' ? 'flex' : 'table-row',
        position: virtualRow ? 'absolute' : undefined,
        top: virtualRow ? "".concat((_b = (_a = parentRowRef.current) === null || _a === void 0 ? void 0 : _a.getBoundingClientRect()) === null || _b === void 0 ? void 0 : _b.height, "px") : undefined,
        transform: virtualRow ? "translateY(".concat(virtualRow === null || virtualRow === void 0 ? void 0 : virtualRow.start, "px)") : undefined,
        width: '100%',
        zIndex: virtualRow ? 2 : undefined
      }, (tableRowProps === null || tableRowProps === void 0 ? void 0 : tableRowProps.sx) instanceof Function ? tableRowProps.sx(theme) : tableRowProps === null || tableRowProps === void 0 ? void 0 : tableRowProps.sx);
    },
    children: jsx(TableCell, Object.assign({
      className: "Mui-TableBodyCell-DetailPanel",
      colSpan: getVisibleLeafColumns().length
    }, tableCellProps, {
      sx: function sx(theme) {
        return Object.assign({
          backgroundColor: virtualRow ? lighten(theme.palette.background.default, 0.06) : undefined,
          borderBottom: !row.getIsExpanded() ? 'none' : undefined,
          display: layoutMode === 'grid' ? 'flex' : 'table-cell',
          pb: row.getIsExpanded() ? '1rem' : 0,
          pt: row.getIsExpanded() ? '1rem' : 0,
          transition: 'all 150ms ease-in-out',
          width: "".concat(table.getTotalSize(), "px")
        }, (tableCellProps === null || tableCellProps === void 0 ? void 0 : tableCellProps.sx) instanceof Function ? tableCellProps.sx(theme) : tableCellProps === null || tableCellProps === void 0 ? void 0 : tableCellProps.sx);
      },
      children: renderDetailPanel && jsx(Collapse, {
        in: row.getIsExpanded(),
        mountOnEnter: true,
        unmountOnExit: true,
        children: !isLoading && renderDetailPanel({
          row: row,
          table: table
        })
      })
    }))
  }));
};
var MRT_TableBodyRow = function MRT_TableBodyRow(_ref51) {
  var columnVirtualizer = _ref51.columnVirtualizer,
    measureElement = _ref51.measureElement,
    numRows = _ref51.numRows,
    row = _ref51.row,
    rowIndex = _ref51.rowIndex,
    table = _ref51.table,
    virtualColumns = _ref51.virtualColumns,
    virtualPaddingLeft = _ref51.virtualPaddingLeft,
    virtualPaddingRight = _ref51.virtualPaddingRight,
    virtualRow = _ref51.virtualRow;
  var getState = table.getState,
    _table$options38 = table.options,
    enableRowOrdering = _table$options38.enableRowOrdering,
    layoutMode = _table$options38.layoutMode,
    memoMode = _table$options38.memoMode,
    muiTableBodyRowProps = _table$options38.muiTableBodyRowProps,
    renderDetailPanel = _table$options38.renderDetailPanel,
    setHoveredRow = table.setHoveredRow;
  var _getState33 = getState(),
    draggingColumn = _getState33.draggingColumn,
    draggingRow = _getState33.draggingRow,
    editingCell = _getState33.editingCell,
    editingRow = _getState33.editingRow,
    hoveredRow = _getState33.hoveredRow;
  var tableRowProps = muiTableBodyRowProps instanceof Function ? muiTableBodyRowProps({
    row: row,
    staticRowIndex: rowIndex,
    table: table
  }) : muiTableBodyRowProps;
  var handleDragEnter = function handleDragEnter(_e) {
    if (enableRowOrdering && draggingRow) {
      setHoveredRow(row);
    }
  };
  var rowRef = useRef(null);
  return jsxs(Fragment, {
    children: [jsxs(TableRow, Object.assign({
      "data-index": virtualRow === null || virtualRow === void 0 ? void 0 : virtualRow.index,
      onDragEnter: handleDragEnter,
      selected: row.getIsSelected(),
      ref: function ref(node) {
        if (node) {
          rowRef.current = node;
          measureElement === null || measureElement === void 0 ? void 0 : measureElement(node);
        }
      }
    }, tableRowProps, {
      sx: function sx(theme) {
        return Object.assign({
          backgroundColor: lighten(theme.palette.background.default, 0.06),
          boxSizing: 'border-box',
          display: layoutMode === 'grid' ? 'flex' : 'table-row',
          opacity: (draggingRow === null || draggingRow === void 0 ? void 0 : draggingRow.id) === row.id || (hoveredRow === null || hoveredRow === void 0 ? void 0 : hoveredRow.id) === row.id ? 0.5 : 1,
          position: virtualRow ? 'absolute' : undefined,
          transition: virtualRow ? 'none' : 'all 150ms ease-in-out',
          top: virtualRow ? 0 : undefined,
          width: '100%',
          '&:hover td': {
            backgroundColor: (tableRowProps === null || tableRowProps === void 0 ? void 0 : tableRowProps.hover) !== false ? row.getIsSelected() ? "".concat(alpha(theme.palette.primary.main, 0.2)) : theme.palette.mode === 'dark' ? "".concat(lighten(theme.palette.background.default, 0.12)) : "".concat(darken(theme.palette.background.default, 0.05)) : undefined
          }
        }, (tableRowProps === null || tableRowProps === void 0 ? void 0 : tableRowProps.sx) instanceof Function ? tableRowProps.sx(theme) : tableRowProps === null || tableRowProps === void 0 ? void 0 : tableRowProps.sx);
      },
      style: Object.assign({
        transform: virtualRow ? "translateY(".concat(virtualRow === null || virtualRow === void 0 ? void 0 : virtualRow.start, "px)") : undefined
      }, tableRowProps === null || tableRowProps === void 0 ? void 0 : tableRowProps.style),
      children: [virtualPaddingLeft ? jsx("td", {
        style: {
          display: 'flex',
          width: virtualPaddingLeft
        }
      }) : null, (virtualColumns !== null && virtualColumns !== void 0 ? virtualColumns : row.getVisibleCells()).map(function (cellOrVirtualCell) {
        var cell = columnVirtualizer ? row.getVisibleCells()[cellOrVirtualCell.index] : cellOrVirtualCell;
        var props = {
          cell: cell,
          measureElement: columnVirtualizer === null || columnVirtualizer === void 0 ? void 0 : columnVirtualizer.measureElement,
          numRows: numRows,
          rowIndex: rowIndex,
          rowRef: rowRef,
          table: table,
          virtualCell: columnVirtualizer ? cellOrVirtualCell : undefined
        };
        return memoMode === 'cells' && cell.column.columnDef.columnDefType === 'data' && !draggingColumn && !draggingRow && (editingCell === null || editingCell === void 0 ? void 0 : editingCell.id) !== cell.id && (editingRow === null || editingRow === void 0 ? void 0 : editingRow.id) !== row.id ? jsx(Memo_MRT_TableBodyCell, Object.assign({}, props), cell.id) : jsx(MRT_TableBodyCell, Object.assign({}, props), cell.id);
      }), virtualPaddingRight ? jsx("td", {
        style: {
          display: 'flex',
          width: virtualPaddingRight
        }
      }) : null]
    })), renderDetailPanel && !row.getIsGrouped() && jsx(MRT_TableDetailPanel, {
      parentRowRef: rowRef,
      row: row,
      rowIndex: rowIndex,
      table: table,
      virtualRow: virtualRow
    })]
  });
};
var Memo_MRT_TableBodyRow = memo(MRT_TableBodyRow, function (prev, next) {
  return prev.row === next.row && prev.rowIndex === next.rowIndex;
});
var MRT_TableBody = function MRT_TableBody(_ref52) {
  var columnVirtualizer = _ref52.columnVirtualizer,
    table = _ref52.table,
    virtualColumns = _ref52.virtualColumns,
    virtualPaddingLeft = _ref52.virtualPaddingLeft,
    virtualPaddingRight = _ref52.virtualPaddingRight;
  var _a, _b, _c, _d;
  var getRowModel = table.getRowModel,
    getPrePaginationRowModel = table.getPrePaginationRowModel,
    getState = table.getState,
    _table$options39 = table.options,
    enableGlobalFilterRankedResults = _table$options39.enableGlobalFilterRankedResults,
    enablePagination = _table$options39.enablePagination,
    enableRowVirtualization = _table$options39.enableRowVirtualization,
    layoutMode = _table$options39.layoutMode,
    localization = _table$options39.localization,
    manualExpanding = _table$options39.manualExpanding,
    manualFiltering = _table$options39.manualFiltering,
    manualGrouping = _table$options39.manualGrouping,
    manualPagination = _table$options39.manualPagination,
    manualSorting = _table$options39.manualSorting,
    memoMode = _table$options39.memoMode,
    muiTableBodyProps = _table$options39.muiTableBodyProps,
    renderEmptyRowsFallback = _table$options39.renderEmptyRowsFallback,
    rowVirtualizerInstanceRef = _table$options39.rowVirtualizerInstanceRef,
    rowVirtualizerProps = _table$options39.rowVirtualizerProps,
    virtualizerInstanceRef = _table$options39.virtualizerInstanceRef,
    virtualizerProps = _table$options39.virtualizerProps,
    _table$refs = table.refs,
    tableContainerRef = _table$refs.tableContainerRef,
    tablePaperRef = _table$refs.tablePaperRef;
  var _getState34 = getState(),
    columnFilters = _getState34.columnFilters,
    density = _getState34.density,
    expanded = _getState34.expanded,
    globalFilter = _getState34.globalFilter,
    globalFilterFn = _getState34.globalFilterFn,
    pagination = _getState34.pagination,
    sorting = _getState34.sorting;
  var tableBodyProps = muiTableBodyProps instanceof Function ? muiTableBodyProps({
    table: table
  }) : muiTableBodyProps;
  var vProps_old = virtualizerProps instanceof Function ? virtualizerProps({
    table: table
  }) : virtualizerProps;
  var vProps = rowVirtualizerProps instanceof Function ? rowVirtualizerProps({
    table: table
  }) : rowVirtualizerProps;
  var shouldRankResults = useMemo(function () {
    return !manualExpanding && !manualFiltering && !manualGrouping && !manualSorting && enableGlobalFilterRankedResults && globalFilter && globalFilterFn === 'fuzzy' && expanded !== true && !Object.values(sorting).some(Boolean) && !Object.values(expanded).some(Boolean);
  }, [enableGlobalFilterRankedResults, expanded, globalFilter, manualExpanding, manualFiltering, manualGrouping, manualSorting, sorting]);
  var rows = useMemo(function () {
    if (!shouldRankResults) return getRowModel().rows;
    var rankedRows = getPrePaginationRowModel().rows.sort(function (a, b) {
      return rankGlobalFuzzy(a, b);
    });
    if (enablePagination && !manualPagination) {
      var start = pagination.pageIndex * pagination.pageSize;
      return rankedRows.slice(start, start + pagination.pageSize);
    }
    return rankedRows;
  }, [shouldRankResults, shouldRankResults ? getPrePaginationRowModel().rows : getRowModel().rows, pagination.pageIndex, pagination.pageSize]);
  var rowVirtualizer = enableRowVirtualization ? useVirtualizer(Object.assign(Object.assign({
    count: rows.length,
    estimateSize: function estimateSize() {
      return density === 'compact' ? 37 : density === 'comfortable' ? 58 : 73;
    },
    getScrollElement: function getScrollElement() {
      return tableContainerRef.current;
    },
    measureElement: typeof window !== 'undefined' && navigator.userAgent.indexOf('Firefox') === -1 ? function (element) {
      return element === null || element === void 0 ? void 0 : element.getBoundingClientRect().height;
    } : undefined,
    overscan: 4
  }, vProps_old), vProps)) : undefined;
  if (rowVirtualizerInstanceRef && rowVirtualizer) {
    rowVirtualizerInstanceRef.current = rowVirtualizer;
  }
  //deprecated
  if (virtualizerInstanceRef && rowVirtualizer) {
    virtualizerInstanceRef.current = rowVirtualizer;
  }
  var virtualRows = rowVirtualizer ? rowVirtualizer.getVirtualItems() : undefined;
  return jsx(TableBody, Object.assign({}, tableBodyProps, {
    sx: function sx(theme) {
      return Object.assign({
        display: layoutMode === 'grid' ? 'grid' : 'table-row-group',
        height: rowVirtualizer ? "".concat(rowVirtualizer.getTotalSize(), "px") : 'inherit',
        minHeight: !rows.length ? '100px' : undefined,
        position: 'relative'
      }, (tableBodyProps === null || tableBodyProps === void 0 ? void 0 : tableBodyProps.sx) instanceof Function ? tableBodyProps === null || tableBodyProps === void 0 ? void 0 : tableBodyProps.sx(theme) : tableBodyProps === null || tableBodyProps === void 0 ? void 0 : tableBodyProps.sx);
    },
    children: (_a = tableBodyProps === null || tableBodyProps === void 0 ? void 0 : tableBodyProps.children) !== null && _a !== void 0 ? _a : !rows.length ? jsx("tr", {
      style: {
        display: layoutMode === 'grid' ? 'grid' : 'table-row'
      },
      children: jsx("td", {
        colSpan: table.getVisibleLeafColumns().length,
        style: {
          display: layoutMode === 'grid' ? 'grid' : 'table-cell'
        },
        children: (_b = renderEmptyRowsFallback === null || renderEmptyRowsFallback === void 0 ? void 0 : renderEmptyRowsFallback({
          table: table
        })) !== null && _b !== void 0 ? _b : jsx(Typography, {
          sx: {
            color: 'text.secondary',
            fontStyle: 'italic',
            maxWidth: "min(100vw, ".concat((_d = (_c = tablePaperRef.current) === null || _c === void 0 ? void 0 : _c.clientWidth) !== null && _d !== void 0 ? _d : 360, "px)"),
            py: '2rem',
            textAlign: 'center',
            width: '100%'
          },
          children: globalFilter || columnFilters.length ? localization.noResultsFound : localization.noRecordsToDisplay
        })
      })
    }) : jsx(Fragment, {
      children: (virtualRows !== null && virtualRows !== void 0 ? virtualRows : rows).map(function (rowOrVirtualRow, rowIndex) {
        var row = rowVirtualizer ? rows[rowOrVirtualRow.index] : rowOrVirtualRow;
        var props = {
          columnVirtualizer: columnVirtualizer,
          measureElement: rowVirtualizer === null || rowVirtualizer === void 0 ? void 0 : rowVirtualizer.measureElement,
          numRows: rows.length,
          row: row,
          rowIndex: rowVirtualizer ? rowOrVirtualRow.index : rowIndex,
          table: table,
          virtualColumns: virtualColumns,
          virtualPaddingLeft: virtualPaddingLeft,
          virtualPaddingRight: virtualPaddingRight,
          virtualRow: rowVirtualizer ? rowOrVirtualRow : undefined
        };
        return memoMode === 'rows' ? jsx(Memo_MRT_TableBodyRow, Object.assign({}, props), row.id) : jsx(MRT_TableBodyRow, Object.assign({}, props), row.id);
      })
    })
  }));
};
var Memo_MRT_TableBody = memo(MRT_TableBody, function (prev, next) {
  return prev.table.options.data === next.table.options.data;
});
var MRT_TableFooterCell = function MRT_TableFooterCell(_ref53) {
  var footer = _ref53.footer,
    table = _ref53.table;
  var _a, _b, _c;
  var getState = table.getState,
    _table$options40 = table.options,
    layoutMode = _table$options40.layoutMode,
    muiTableFooterCellProps = _table$options40.muiTableFooterCellProps;
  var _getState35 = getState(),
    density = _getState35.density;
  var column = footer.column;
  var columnDef = column.columnDef;
  var columnDefType = columnDef.columnDefType;
  var mTableFooterCellProps = muiTableFooterCellProps instanceof Function ? muiTableFooterCellProps({
    column: column,
    table: table
  }) : muiTableFooterCellProps;
  var mcTableFooterCellProps = columnDef.muiTableFooterCellProps instanceof Function ? columnDef.muiTableFooterCellProps({
    column: column,
    table: table
  }) : columnDef.muiTableFooterCellProps;
  var tableCellProps = Object.assign(Object.assign({}, mTableFooterCellProps), mcTableFooterCellProps);
  return jsx(TableCell, Object.assign({
    align: columnDefType === 'group' ? 'center' : 'left',
    colSpan: footer.colSpan,
    variant: "head"
  }, tableCellProps, {
    sx: function sx(theme) {
      return Object.assign({
        display: layoutMode === 'grid' ? 'grid' : 'table-cell',
        fontWeight: 'bold',
        justifyContent: columnDefType === 'group' ? 'center' : undefined,
        p: density === 'compact' ? '0.5rem' : density === 'comfortable' ? '1rem' : '1.5rem',
        verticalAlign: 'top',
        zIndex: column.getIsPinned() && columnDefType !== 'group' ? 2 : 1
      }, getCommonCellStyles({
        column: column,
        table: table,
        theme: theme,
        tableCellProps: tableCellProps
      }));
    },
    children: jsx(Fragment, {
      children: footer.isPlaceholder ? null : (_c = (_b = columnDef.Footer instanceof Function ? (_a = columnDef.Footer) === null || _a === void 0 ? void 0 : _a.call(columnDef, {
        column: column,
        footer: footer,
        table: table
      }) : columnDef.Footer) !== null && _b !== void 0 ? _b : columnDef.footer) !== null && _c !== void 0 ? _c : null
    })
  }));
};
var MRT_TableFooterRow = function MRT_TableFooterRow(_ref54) {
  var footerGroup = _ref54.footerGroup,
    table = _ref54.table,
    virtualColumns = _ref54.virtualColumns,
    virtualPaddingLeft = _ref54.virtualPaddingLeft,
    virtualPaddingRight = _ref54.virtualPaddingRight;
  var _a;
  var _table$options41 = table.options,
    layoutMode = _table$options41.layoutMode,
    muiTableFooterRowProps = _table$options41.muiTableFooterRowProps; // if no content in row, skip row
  if (!((_a = footerGroup.headers) === null || _a === void 0 ? void 0 : _a.some(function (header) {
    return typeof header.column.columnDef.footer === 'string' && !!header.column.columnDef.footer || header.column.columnDef.Footer;
  }))) return null;
  var tableRowProps = muiTableFooterRowProps instanceof Function ? muiTableFooterRowProps({
    footerGroup: footerGroup,
    table: table
  }) : muiTableFooterRowProps;
  return jsxs(TableRow, Object.assign({}, tableRowProps, {
    sx: function sx(theme) {
      return Object.assign({
        backgroundColor: lighten(theme.palette.background.default, 0.04),
        display: layoutMode === 'grid' ? 'flex' : 'table-row',
        width: '100%'
      }, (tableRowProps === null || tableRowProps === void 0 ? void 0 : tableRowProps.sx) instanceof Function ? tableRowProps === null || tableRowProps === void 0 ? void 0 : tableRowProps.sx(theme) : tableRowProps === null || tableRowProps === void 0 ? void 0 : tableRowProps.sx);
    },
    children: [virtualPaddingLeft ? jsx("th", {
      style: {
        display: 'flex',
        width: virtualPaddingLeft
      }
    }) : null, (virtualColumns !== null && virtualColumns !== void 0 ? virtualColumns : footerGroup.headers).map(function (footerOrVirtualFooter) {
      var footer = virtualColumns ? footerGroup.headers[footerOrVirtualFooter.index] : footerOrVirtualFooter;
      return jsx(MRT_TableFooterCell, {
        footer: footer,
        table: table
      }, footer.id);
    }), virtualPaddingRight ? jsx("th", {
      style: {
        display: 'flex',
        width: virtualPaddingRight
      }
    }) : null]
  }));
};
var MRT_TableFooter = function MRT_TableFooter(_ref55) {
  var table = _ref55.table,
    virtualColumns = _ref55.virtualColumns,
    virtualPaddingLeft = _ref55.virtualPaddingLeft,
    virtualPaddingRight = _ref55.virtualPaddingRight;
  var getFooterGroups = table.getFooterGroups,
    getState = table.getState,
    _table$options42 = table.options,
    enableStickyFooter = _table$options42.enableStickyFooter,
    layoutMode = _table$options42.layoutMode,
    muiTableFooterProps = _table$options42.muiTableFooterProps;
  var _getState36 = getState(),
    isFullScreen = _getState36.isFullScreen;
  var tableFooterProps = muiTableFooterProps instanceof Function ? muiTableFooterProps({
    table: table
  }) : muiTableFooterProps;
  var stickFooter = (isFullScreen || enableStickyFooter) && enableStickyFooter !== false;
  return jsx(TableFooter, Object.assign({}, tableFooterProps, {
    sx: function sx(theme) {
      return Object.assign({
        bottom: stickFooter ? 0 : undefined,
        display: layoutMode === 'grid' ? 'grid' : 'table-row-group',
        opacity: stickFooter ? 0.97 : undefined,
        outline: stickFooter ? theme.palette.mode === 'light' ? "1px solid ".concat(theme.palette.grey[300]) : "1px solid ".concat(theme.palette.grey[700]) : undefined,
        position: stickFooter ? 'sticky' : undefined,
        zIndex: stickFooter ? 1 : undefined
      }, (tableFooterProps === null || tableFooterProps === void 0 ? void 0 : tableFooterProps.sx) instanceof Function ? tableFooterProps === null || tableFooterProps === void 0 ? void 0 : tableFooterProps.sx(theme) : tableFooterProps === null || tableFooterProps === void 0 ? void 0 : tableFooterProps.sx);
    },
    children: getFooterGroups().map(function (footerGroup) {
      return jsx(MRT_TableFooterRow, {
        footerGroup: footerGroup,
        table: table,
        virtualColumns: virtualColumns,
        virtualPaddingLeft: virtualPaddingLeft,
        virtualPaddingRight: virtualPaddingRight
      }, footerGroup.id);
    })
  }));
};
var MRT_Table = function MRT_Table(_ref56) {
  var table = _ref56.table;
  var _a, _b, _c, _d;
  var getFlatHeaders = table.getFlatHeaders,
    getState = table.getState,
    _table$options43 = table.options,
    columns = _table$options43.columns,
    columnVirtualizerInstanceRef = _table$options43.columnVirtualizerInstanceRef,
    columnVirtualizerProps = _table$options43.columnVirtualizerProps,
    enableColumnResizing = _table$options43.enableColumnResizing,
    enableColumnVirtualization = _table$options43.enableColumnVirtualization,
    enablePinning = _table$options43.enablePinning,
    enableStickyHeader = _table$options43.enableStickyHeader,
    enableTableFooter = _table$options43.enableTableFooter,
    enableTableHead = _table$options43.enableTableHead,
    layoutMode = _table$options43.layoutMode,
    memoMode = _table$options43.memoMode,
    muiTableProps = _table$options43.muiTableProps,
    tableContainerRef = table.refs.tableContainerRef;
  var _getState37 = getState(),
    columnPinning = _getState37.columnPinning,
    columnSizing = _getState37.columnSizing,
    columnSizingInfo = _getState37.columnSizingInfo,
    columnVisibility = _getState37.columnVisibility,
    isFullScreen = _getState37.isFullScreen;
  var tableProps = muiTableProps instanceof Function ? muiTableProps({
    table: table
  }) : muiTableProps;
  var vProps = columnVirtualizerProps instanceof Function ? columnVirtualizerProps({
    table: table
  }) : columnVirtualizerProps;
  var columnSizeVars = useMemo(function () {
    var headers = getFlatHeaders();
    var colSizes = {};
    for (var i = 0; i < headers.length; i++) {
      var header = headers[i];
      var colSize = header.getSize();
      colSizes["--header-".concat(parseCSSVarId(header.id), "-size")] = colSize;
      colSizes["--col-".concat(parseCSSVarId(header.column.id), "-size")] = colSize;
    }
    return colSizes;
  }, [columns, columnSizing, columnSizingInfo, columnVisibility]);
  //get first 16 column widths and average them
  var averageColumnWidth = useMemo(function () {
    var _a, _b, _c, _d;
    if (!enableColumnVirtualization) return 0;
    var columnsWidths = (_d = (_c = (_b = (_a = table.getRowModel().rows[0]) === null || _a === void 0 ? void 0 : _a.getCenterVisibleCells()) === null || _b === void 0 ? void 0 : _b.slice(0, 16)) === null || _c === void 0 ? void 0 : _c.map(function (cell) {
      return cell.column.getSize() * 1.2;
    })) !== null && _d !== void 0 ? _d : [];
    return columnsWidths.reduce(function (a, b) {
      return a + b;
    }, 0) / columnsWidths.length;
  }, [table.getRowModel().rows, columnPinning, columnVisibility]);
  var _useMemo = useMemo(function () {
      return enableColumnVirtualization && enablePinning ? [table.getLeftLeafColumns().map(function (c) {
        return c.getPinnedIndex();
      }), table.getRightLeafColumns().map(function (c) {
        return table.getVisibleLeafColumns().length - c.getPinnedIndex() - 1;
      })] : [[], []];
    }, [columnPinning, enableColumnVirtualization, enablePinning]),
    _useMemo2 = _slicedToArray(_useMemo, 2),
    leftPinnedIndexes = _useMemo2[0],
    rightPinnedIndexes = _useMemo2[1];
  var columnVirtualizer = enableColumnVirtualization ? useVirtualizer(Object.assign({
    count: table.getVisibleLeafColumns().length,
    estimateSize: function estimateSize() {
      return averageColumnWidth;
    },
    getScrollElement: function getScrollElement() {
      return tableContainerRef.current;
    },
    horizontal: true,
    overscan: 3,
    rangeExtractor: useCallback(function (range) {
      return _toConsumableArray(new Set([].concat(_toConsumableArray(leftPinnedIndexes), _toConsumableArray(defaultRangeExtractor(range)), _toConsumableArray(rightPinnedIndexes))));
    }, [leftPinnedIndexes, rightPinnedIndexes])
  }, vProps)) : undefined;
  if (columnVirtualizerInstanceRef && columnVirtualizer) {
    columnVirtualizerInstanceRef.current = columnVirtualizer;
  }
  var virtualColumns = columnVirtualizer ? columnVirtualizer.getVirtualItems() : undefined;
  var virtualPaddingLeft;
  var virtualPaddingRight;
  if (columnVirtualizer && (virtualColumns === null || virtualColumns === void 0 ? void 0 : virtualColumns.length)) {
    virtualPaddingLeft = (_b = (_a = virtualColumns[leftPinnedIndexes.length]) === null || _a === void 0 ? void 0 : _a.start) !== null && _b !== void 0 ? _b : 0;
    virtualPaddingRight = columnVirtualizer.getTotalSize() - ((_d = (_c = virtualColumns[virtualColumns.length - 1 - rightPinnedIndexes.length]) === null || _c === void 0 ? void 0 : _c.end) !== null && _d !== void 0 ? _d : 0);
  }
  var props = {
    table: table,
    virtualColumns: virtualColumns,
    virtualPaddingLeft: virtualPaddingLeft,
    virtualPaddingRight: virtualPaddingRight
  };
  return jsxs(Table, Object.assign({
    stickyHeader: enableStickyHeader || isFullScreen
  }, tableProps, {
    sx: function sx(theme) {
      return Object.assign({
        borderCollapse: 'separate',
        display: layoutMode === 'grid' ? 'grid' : 'table',
        tableLayout: layoutMode !== 'grid' && enableColumnResizing ? 'fixed' : undefined
      }, (tableProps === null || tableProps === void 0 ? void 0 : tableProps.sx) instanceof Function ? tableProps.sx(theme) : tableProps === null || tableProps === void 0 ? void 0 : tableProps.sx);
    },
    style: Object.assign(Object.assign({}, columnSizeVars), tableProps === null || tableProps === void 0 ? void 0 : tableProps.style),
    children: [enableTableHead && jsx(MRT_TableHead, Object.assign({}, props)), memoMode === 'table-body' || columnSizingInfo.isResizingColumn ? jsx(Memo_MRT_TableBody, Object.assign({
      columnVirtualizer: columnVirtualizer
    }, props)) : jsx(MRT_TableBody, Object.assign({
      columnVirtualizer: columnVirtualizer
    }, props)), enableTableFooter && jsx(MRT_TableFooter, Object.assign({}, props))]
  }));
};
var useIsomorphicLayoutEffect = typeof window !== 'undefined' ? useLayoutEffect : useEffect;
var MRT_TableContainer = function MRT_TableContainer(_ref57) {
  var table = _ref57.table;
  var getState = table.getState,
    _table$options44 = table.options,
    enableStickyHeader = _table$options44.enableStickyHeader,
    muiTableContainerProps = _table$options44.muiTableContainerProps,
    _table$refs2 = table.refs,
    tableContainerRef = _table$refs2.tableContainerRef,
    bottomToolbarRef = _table$refs2.bottomToolbarRef,
    topToolbarRef = _table$refs2.topToolbarRef;
  var _getState38 = getState(),
    isFullScreen = _getState38.isFullScreen;
  var _useState29 = useState(0),
    _useState30 = _slicedToArray(_useState29, 2),
    totalToolbarHeight = _useState30[0],
    setTotalToolbarHeight = _useState30[1];
  var tableContainerProps = muiTableContainerProps instanceof Function ? muiTableContainerProps({
    table: table
  }) : muiTableContainerProps;
  useIsomorphicLayoutEffect(function () {
    var _a, _b, _c, _d;
    var topToolbarHeight = typeof document !== 'undefined' ? (_b = (_a = topToolbarRef.current) === null || _a === void 0 ? void 0 : _a.offsetHeight) !== null && _b !== void 0 ? _b : 0 : 0;
    var bottomToolbarHeight = typeof document !== 'undefined' ? (_d = (_c = bottomToolbarRef === null || bottomToolbarRef === void 0 ? void 0 : bottomToolbarRef.current) === null || _c === void 0 ? void 0 : _c.offsetHeight) !== null && _d !== void 0 ? _d : 0 : 0;
    setTotalToolbarHeight(topToolbarHeight + bottomToolbarHeight);
  });
  return jsx(TableContainer, Object.assign({}, tableContainerProps, {
    ref: function ref(node) {
      if (node) {
        tableContainerRef.current = node;
        if (tableContainerProps === null || tableContainerProps === void 0 ? void 0 : tableContainerProps.ref) {
          //@ts-ignore
          tableContainerProps.ref.current = node;
        }
      }
    },
    sx: function sx(theme) {
      return Object.assign({
        maxWidth: '100%',
        maxHeight: enableStickyHeader ? "clamp(350px, calc(100vh - ".concat(totalToolbarHeight, "px), 9999px)") : undefined,
        overflow: 'auto'
      }, (tableContainerProps === null || tableContainerProps === void 0 ? void 0 : tableContainerProps.sx) instanceof Function ? tableContainerProps.sx(theme) : tableContainerProps === null || tableContainerProps === void 0 ? void 0 : tableContainerProps.sx);
    },
    style: Object.assign({
      maxHeight: isFullScreen ? "calc(100vh - ".concat(totalToolbarHeight, "px)") : undefined
    }, tableContainerProps === null || tableContainerProps === void 0 ? void 0 : tableContainerProps.style),
    children: jsx(MRT_Table, {
      table: table
    })
  }));
};
var MRT_TablePaper = function MRT_TablePaper(_ref58) {
  var table = _ref58.table;
  var getState = table.getState,
    _table$options45 = table.options,
    enableBottomToolbar = _table$options45.enableBottomToolbar,
    enableTopToolbar = _table$options45.enableTopToolbar,
    muiTablePaperProps = _table$options45.muiTablePaperProps,
    renderBottomToolbar = _table$options45.renderBottomToolbar,
    renderTopToolbar = _table$options45.renderTopToolbar,
    tablePaperRef = table.refs.tablePaperRef;
  var _getState39 = getState(),
    isFullScreen = _getState39.isFullScreen;
  var tablePaperProps = muiTablePaperProps instanceof Function ? muiTablePaperProps({
    table: table
  }) : muiTablePaperProps;
  return jsxs(Paper, Object.assign({
    elevation: 2
  }, tablePaperProps, {
    ref: function ref(_ref59) {
      tablePaperRef.current = _ref59;
      if (tablePaperProps === null || tablePaperProps === void 0 ? void 0 : tablePaperProps.ref) {
        //@ts-ignore
        tablePaperProps.ref.current = _ref59;
      }
    },
    sx: function sx(theme) {
      return Object.assign({
        transition: 'all 150ms ease-in-out'
      }, (tablePaperProps === null || tablePaperProps === void 0 ? void 0 : tablePaperProps.sx) instanceof Function ? tablePaperProps === null || tablePaperProps === void 0 ? void 0 : tablePaperProps.sx(theme) : tablePaperProps === null || tablePaperProps === void 0 ? void 0 : tablePaperProps.sx);
    },
    style: Object.assign(Object.assign({}, tablePaperProps === null || tablePaperProps === void 0 ? void 0 : tablePaperProps.style), isFullScreen ? {
      height: '100vh',
      margin: 0,
      maxHeight: '100vh',
      maxWidth: '100vw',
      padding: 0,
      width: '100vw'
    } : {}),
    children: [enableTopToolbar && (renderTopToolbar instanceof Function ? renderTopToolbar({
      table: table
    }) : renderTopToolbar !== null && renderTopToolbar !== void 0 ? renderTopToolbar : jsx(MRT_TopToolbar, {
      table: table
    })), jsx(MRT_TableContainer, {
      table: table
    }), enableBottomToolbar && (renderBottomToolbar instanceof Function ? renderBottomToolbar({
      table: table
    }) : renderBottomToolbar !== null && renderBottomToolbar !== void 0 ? renderBottomToolbar : jsx(MRT_BottomToolbar, {
      table: table
    }))]
  }));
};
var MRT_EditRowModal = function MRT_EditRowModal(_ref60) {
  var open = _ref60.open,
    row = _ref60.row,
    table = _ref60.table;
  var localization = table.options.localization;
  return jsxs(Dialog, {
    open: open,
    children: [jsx(DialogTitle, {
      textAlign: "center",
      children: localization.edit
    }), jsx(DialogContent, {
      children: jsx("form", {
        onSubmit: function onSubmit(e) {
          return e.preventDefault();
        },
        children: jsx(Stack, {
          sx: {
            gap: '1.5rem',
            minWidth: {
              xs: '300px',
              sm: '360px',
              md: '400px'
            },
            pt: '1rem',
            width: '100%'
          },
          children: row.getAllCells().filter(function (cell) {
            return cell.column.columnDef.columnDefType === 'data';
          }).map(function (cell) {
            return jsx(MRT_EditCellTextField, {
              cell: cell,
              showLabel: true,
              table: table
            }, cell.id);
          })
        })
      })
    }), jsx(DialogActions, {
      sx: {
        p: '1.25rem'
      },
      children: jsx(MRT_EditActionButtons, {
        row: row,
        table: table,
        variant: "text"
      })
    })]
  });
};
var MRT_TableRoot = function MRT_TableRoot(props) {
  var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m, _o, _p, _q, _r, _s, _t, _u, _v, _w, _x, _y, _z, _0, _1, _2, _3, _4, _5, _6, _7, _8, _9, _10, _11, _12, _13;
  var bottomToolbarRef = useRef(null);
  var editInputRefs = useRef({});
  var filterInputRefs = useRef({});
  var searchInputRef = useRef(null);
  var tableContainerRef = useRef(null);
  var tableHeadCellRefs = useRef({});
  var tablePaperRef = useRef(null);
  var topToolbarRef = useRef(null);
  var initialState = useMemo(function () {
    var _a, _b, _c;
    var initState = (_a = props.initialState) !== null && _a !== void 0 ? _a : {};
    initState.columnOrder = (_b = initState.columnOrder) !== null && _b !== void 0 ? _b : getDefaultColumnOrderIds(props);
    initState.globalFilterFn = (_c = props.globalFilterFn) !== null && _c !== void 0 ? _c : 'fuzzy';
    return initState;
  }, []);
  var _useState31 = useState(function () {
      return Object.assign.apply(Object, [{}].concat(_toConsumableArray(getAllLeafColumnDefs(props.columns).map(function (col) {
        var _a, _b, _c, _d;
        return _defineProperty({}, getColumnId(col), col.filterFn instanceof Function ? (_a = col.filterFn.name) !== null && _a !== void 0 ? _a : 'custom' : (_d = (_b = col.filterFn) !== null && _b !== void 0 ? _b : (_c = initialState === null || initialState === void 0 ? void 0 : initialState.columnFilterFns) === null || _c === void 0 ? void 0 : _c[getColumnId(col)]) !== null && _d !== void 0 ? _d : getDefaultColumnFilterFn(col));
      }))));
    }),
    _useState32 = _slicedToArray(_useState31, 2),
    columnFilterFns = _useState32[0],
    setColumnFilterFns = _useState32[1];
  var _useState33 = useState((_a = initialState.columnOrder) !== null && _a !== void 0 ? _a : []),
    _useState34 = _slicedToArray(_useState33, 2),
    columnOrder = _useState34[0],
    setColumnOrder = _useState34[1];
  var _useState35 = useState((_b = initialState === null || initialState === void 0 ? void 0 : initialState.density) !== null && _b !== void 0 ? _b : 'comfortable'),
    _useState36 = _slicedToArray(_useState35, 2),
    density = _useState36[0],
    setDensity = _useState36[1];
  var _useState37 = useState((_c = initialState.draggingColumn) !== null && _c !== void 0 ? _c : null),
    _useState38 = _slicedToArray(_useState37, 2),
    draggingColumn = _useState38[0],
    setDraggingColumn = _useState38[1];
  var _useState39 = useState((_d = initialState.draggingRow) !== null && _d !== void 0 ? _d : null),
    _useState40 = _slicedToArray(_useState39, 2),
    draggingRow = _useState40[0],
    setDraggingRow = _useState40[1];
  var _useState41 = useState((_e = initialState.editingCell) !== null && _e !== void 0 ? _e : null),
    _useState42 = _slicedToArray(_useState41, 2),
    editingCell = _useState42[0],
    setEditingCell = _useState42[1];
  var _useState43 = useState((_f = initialState.editingRow) !== null && _f !== void 0 ? _f : null),
    _useState44 = _slicedToArray(_useState43, 2),
    editingRow = _useState44[0],
    setEditingRow = _useState44[1];
  var _useState45 = useState((_g = initialState.globalFilterFn) !== null && _g !== void 0 ? _g : 'fuzzy'),
    _useState46 = _slicedToArray(_useState45, 2),
    globalFilterFn = _useState46[0],
    setGlobalFilterFn = _useState46[1];
  var _useState47 = useState((_h = initialState.grouping) !== null && _h !== void 0 ? _h : []),
    _useState48 = _slicedToArray(_useState47, 2),
    grouping = _useState48[0],
    setGrouping = _useState48[1];
  var _useState49 = useState((_j = initialState.hoveredColumn) !== null && _j !== void 0 ? _j : null),
    _useState50 = _slicedToArray(_useState49, 2),
    hoveredColumn = _useState50[0],
    setHoveredColumn = _useState50[1];
  var _useState51 = useState((_k = initialState.hoveredRow) !== null && _k !== void 0 ? _k : null),
    _useState52 = _slicedToArray(_useState51, 2),
    hoveredRow = _useState52[0],
    setHoveredRow = _useState52[1];
  var _useState53 = useState((_l = initialState === null || initialState === void 0 ? void 0 : initialState.isFullScreen) !== null && _l !== void 0 ? _l : false),
    _useState54 = _slicedToArray(_useState53, 2),
    isFullScreen = _useState54[0],
    setIsFullScreen = _useState54[1];
  var _useState55 = useState((_o = (_m = props.initialState) === null || _m === void 0 ? void 0 : _m.showAlertBanner) !== null && _o !== void 0 ? _o : false),
    _useState56 = _slicedToArray(_useState55, 2),
    showAlertBanner = _useState56[0],
    setShowAlertBanner = _useState56[1];
  var _useState57 = useState((_p = initialState === null || initialState === void 0 ? void 0 : initialState.showColumnFilters) !== null && _p !== void 0 ? _p : false),
    _useState58 = _slicedToArray(_useState57, 2),
    showColumnFilters = _useState58[0],
    setShowColumnFilters = _useState58[1];
  var _useState59 = useState((_q = initialState === null || initialState === void 0 ? void 0 : initialState.showGlobalFilter) !== null && _q !== void 0 ? _q : false),
    _useState60 = _slicedToArray(_useState59, 2),
    showGlobalFilter = _useState60[0],
    setShowGlobalFilter = _useState60[1];
  var _useState61 = useState((_r = initialState === null || initialState === void 0 ? void 0 : initialState.showToolbarDropZone) !== null && _r !== void 0 ? _r : false),
    _useState62 = _slicedToArray(_useState61, 2),
    showToolbarDropZone = _useState62[0],
    setShowToolbarDropZone = _useState62[1];
  var displayColumns = useMemo(function () {
    var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m, _o, _p, _q, _r, _s;
    return [((_b = (_a = props.state) === null || _a === void 0 ? void 0 : _a.columnOrder) !== null && _b !== void 0 ? _b : columnOrder).includes('mrt-row-drag') && Object.assign(Object.assign(Object.assign({
      header: props.localization.move,
      size: 60
    }, props.defaultDisplayColumn), (_c = props.displayColumnDefOptions) === null || _c === void 0 ? void 0 : _c['mrt-row-drag']), {
      id: 'mrt-row-drag'
    }), ((_e = (_d = props.state) === null || _d === void 0 ? void 0 : _d.columnOrder) !== null && _e !== void 0 ? _e : columnOrder).includes('mrt-row-actions') && Object.assign(Object.assign(Object.assign({
      Cell: function Cell(_ref62) {
        var cell = _ref62.cell,
          row = _ref62.row;
        return jsx(MRT_ToggleRowActionMenuButton, {
          cell: cell,
          row: row,
          table: table
        });
      },
      header: props.localization.actions,
      size: 70
    }, props.defaultDisplayColumn), (_f = props.displayColumnDefOptions) === null || _f === void 0 ? void 0 : _f['mrt-row-actions']), {
      id: 'mrt-row-actions'
    }), ((_h = (_g = props.state) === null || _g === void 0 ? void 0 : _g.columnOrder) !== null && _h !== void 0 ? _h : columnOrder).includes('mrt-row-expand') && showExpandColumn(props, (_k = (_j = props.state) === null || _j === void 0 ? void 0 : _j.grouping) !== null && _k !== void 0 ? _k : grouping) && Object.assign(Object.assign(Object.assign({
      Cell: function Cell(_ref63) {
        var row = _ref63.row;
        return jsx(MRT_ExpandButton, {
          row: row,
          table: table
        });
      },
      Header: props.enableExpandAll ? function () {
        return jsx(MRT_ExpandAllButton, {
          table: table
        });
      } : null,
      header: props.localization.expand,
      size: 60
    }, props.defaultDisplayColumn), (_l = props.displayColumnDefOptions) === null || _l === void 0 ? void 0 : _l['mrt-row-expand']), {
      id: 'mrt-row-expand'
    }), ((_o = (_m = props.state) === null || _m === void 0 ? void 0 : _m.columnOrder) !== null && _o !== void 0 ? _o : columnOrder).includes('mrt-row-select') && Object.assign(Object.assign(Object.assign({
      Cell: function Cell(_ref64) {
        var row = _ref64.row;
        return jsx(MRT_SelectCheckbox, {
          row: row,
          table: table
        });
      },
      Header: props.enableSelectAll && props.enableMultiRowSelection ? function () {
        return jsx(MRT_SelectCheckbox, {
          selectAll: true,
          table: table
        });
      } : null,
      header: props.localization.select,
      size: 60
    }, props.defaultDisplayColumn), (_p = props.displayColumnDefOptions) === null || _p === void 0 ? void 0 : _p['mrt-row-select']), {
      id: 'mrt-row-select'
    }), ((_r = (_q = props.state) === null || _q === void 0 ? void 0 : _q.columnOrder) !== null && _r !== void 0 ? _r : columnOrder).includes('mrt-row-numbers') && Object.assign(Object.assign(Object.assign({
      Cell: function Cell(_ref65) {
        var row = _ref65.row;
        return row.index + 1;
      },
      Header: function Header() {
        return props.localization.rowNumber;
      },
      header: props.localization.rowNumbers,
      size: 60
    }, props.defaultDisplayColumn), (_s = props.displayColumnDefOptions) === null || _s === void 0 ? void 0 : _s['mrt-row-numbers']), {
      id: 'mrt-row-numbers'
    })].filter(Boolean);
  }, [columnOrder, grouping, props.displayColumnDefOptions, props.editingMode, props.enableColumnDragging, props.enableColumnFilterModes, props.enableColumnOrdering, props.enableEditing, props.enableExpandAll, props.enableExpanding, props.enableGrouping, props.enableRowActions, props.enableRowDragging, props.enableRowNumbers, props.enableRowOrdering, props.enableRowSelection, props.enableSelectAll, props.localization, props.positionActionsColumn, props.renderDetailPanel, props.renderRowActionMenuItems, props.renderRowActions, (_s = props.state) === null || _s === void 0 ? void 0 : _s.columnOrder, (_t = props.state) === null || _t === void 0 ? void 0 : _t.grouping]);
  var columnDefs = useMemo(function () {
    var _a, _b, _c;
    return prepareColumns({
      aggregationFns: props.aggregationFns,
      columnDefs: [].concat(_toConsumableArray(displayColumns), _toConsumableArray(props.columns)),
      columnFilterFns: (_b = (_a = props.state) === null || _a === void 0 ? void 0 : _a.columnFilterFns) !== null && _b !== void 0 ? _b : columnFilterFns,
      defaultDisplayColumn: (_c = props.defaultDisplayColumn) !== null && _c !== void 0 ? _c : {},
      filterFns: props.filterFns,
      sortingFns: props.sortingFns
    });
  }, [columnFilterFns, displayColumns, props.columns, (_u = props.state) === null || _u === void 0 ? void 0 : _u.columnFilterFns]);
  var data = useMemo(function () {
    var _a, _b, _c, _d, _e;
    return (((_a = props.state) === null || _a === void 0 ? void 0 : _a.isLoading) || ((_b = props.state) === null || _b === void 0 ? void 0 : _b.showSkeletons)) && !props.data.length ? _toConsumableArray(Array(((_d = (_c = props.state) === null || _c === void 0 ? void 0 : _c.pagination) === null || _d === void 0 ? void 0 : _d.pageSize) || ((_e = initialState === null || initialState === void 0 ? void 0 : initialState.pagination) === null || _e === void 0 ? void 0 : _e.pageSize) || 10).fill(null)).map(function () {
      return Object.assign.apply(Object, [{}].concat(_toConsumableArray(getAllLeafColumnDefs(props.columns).map(function (col) {
        return _defineProperty({}, getColumnId(col), null);
      }))));
    }) : props.data;
  }, [props.data, (_v = props.state) === null || _v === void 0 ? void 0 : _v.isLoading, (_w = props.state) === null || _w === void 0 ? void 0 : _w.showSkeletons]);
  //@ts-ignore
  var table = Object.assign(Object.assign({}, useReactTable(Object.assign(Object.assign({
    getCoreRowModel: getCoreRowModel(),
    getExpandedRowModel: props.enableExpanding || props.enableGrouping ? getExpandedRowModel() : undefined,
    getFacetedMinMaxValues: props.enableFacetedValues ? getFacetedMinMaxValues() : undefined,
    getFacetedRowModel: props.enableFacetedValues ? getFacetedRowModel() : undefined,
    getFacetedUniqueValues: props.enableFacetedValues ? getFacetedUniqueValues() : undefined,
    getFilteredRowModel: props.enableColumnFilters || props.enableGlobalFilter || props.enableFilters ? getFilteredRowModel() : undefined,
    getGroupedRowModel: props.enableGrouping ? getGroupedRowModel() : undefined,
    getPaginationRowModel: props.enablePagination ? getPaginationRowModel() : undefined,
    getSortedRowModel: props.enableSorting ? getSortedRowModel() : undefined,
    onColumnOrderChange: setColumnOrder,
    onGroupingChange: setGrouping,
    getSubRows: function getSubRows(row) {
      return row === null || row === void 0 ? void 0 : row.subRows;
    }
  }, props), {
    //@ts-ignore
    columns: columnDefs,
    data: data,
    globalFilterFn: (_y = (_x = props.filterFns) === null || _x === void 0 ? void 0 : _x[globalFilterFn]) !== null && _y !== void 0 ? _y : (_z = props.filterFns) === null || _z === void 0 ? void 0 : _z.fuzzy,
    initialState: initialState,
    state: Object.assign({
      columnFilterFns: columnFilterFns,
      columnOrder: columnOrder,
      density: density,
      draggingColumn: draggingColumn,
      draggingRow: draggingRow,
      editingCell: editingCell,
      editingRow: editingRow,
      globalFilterFn: globalFilterFn,
      grouping: grouping,
      hoveredColumn: hoveredColumn,
      hoveredRow: hoveredRow,
      isFullScreen: isFullScreen,
      showAlertBanner: showAlertBanner,
      showColumnFilters: showColumnFilters,
      showGlobalFilter: showGlobalFilter,
      showToolbarDropZone: showToolbarDropZone
    }, props.state)
  }))), {
    refs: {
      bottomToolbarRef: bottomToolbarRef,
      editInputRefs: editInputRefs,
      filterInputRefs: filterInputRefs,
      searchInputRef: searchInputRef,
      tableContainerRef: tableContainerRef,
      tableHeadCellRefs: tableHeadCellRefs,
      tablePaperRef: tablePaperRef,
      topToolbarRef: topToolbarRef
    },
    setColumnFilterFns: (_0 = props.onColumnFilterFnsChange) !== null && _0 !== void 0 ? _0 : setColumnFilterFns,
    setDensity: (_1 = props.onDensityChange) !== null && _1 !== void 0 ? _1 : setDensity,
    setDraggingColumn: (_2 = props.onDraggingColumnChange) !== null && _2 !== void 0 ? _2 : setDraggingColumn,
    setDraggingRow: (_3 = props.onDraggingRowChange) !== null && _3 !== void 0 ? _3 : setDraggingRow,
    setEditingCell: (_4 = props.onEditingCellChange) !== null && _4 !== void 0 ? _4 : setEditingCell,
    setEditingRow: (_5 = props.onEditingRowChange) !== null && _5 !== void 0 ? _5 : setEditingRow,
    setGlobalFilterFn: (_6 = props.onGlobalFilterFnChange) !== null && _6 !== void 0 ? _6 : setGlobalFilterFn,
    setHoveredColumn: (_7 = props.onHoveredColumnChange) !== null && _7 !== void 0 ? _7 : setHoveredColumn,
    setHoveredRow: (_8 = props.onHoveredRowChange) !== null && _8 !== void 0 ? _8 : setHoveredRow,
    setIsFullScreen: (_9 = props.onIsFullScreenChange) !== null && _9 !== void 0 ? _9 : setIsFullScreen,
    setShowAlertBanner: (_10 = props.onShowAlertBannerChange) !== null && _10 !== void 0 ? _10 : setShowAlertBanner,
    setShowColumnFilters: (_11 = props.onShowColumnFiltersChange) !== null && _11 !== void 0 ? _11 : setShowColumnFilters,
    setShowGlobalFilter: (_12 = props.onShowGlobalFilterChange) !== null && _12 !== void 0 ? _12 : setShowGlobalFilter,
    setShowToolbarDropZone: (_13 = props.onShowToolbarDropZoneChange) !== null && _13 !== void 0 ? _13 : setShowToolbarDropZone
  });
  if (props.tableFeatures) {
    props.tableFeatures.forEach(function (feature) {
      Object.assign(table, feature(table));
    });
  }
  if (props.tableInstanceRef) {
    props.tableInstanceRef.current = table;
  }
  var initialBodyHeight = useRef();
  useEffect(function () {
    if (typeof window !== 'undefined') {
      initialBodyHeight.current = document.body.style.height;
    }
  }, []);
  useEffect(function () {
    if (typeof window !== 'undefined') {
      if (table.getState().isFullScreen) {
        document.body.style.height = '100vh';
      } else {
        document.body.style.height = initialBodyHeight.current;
      }
    }
  }, [table.getState().isFullScreen]);
  //if page index is out of bounds, set it to the last page
  useEffect(function () {
    var _a;
    var _table$getState$pagin = table.getState().pagination,
      pageIndex = _table$getState$pagin.pageIndex,
      pageSize = _table$getState$pagin.pageSize;
    var totalRowCount = (_a = props.rowCount) !== null && _a !== void 0 ? _a : table.getPrePaginationRowModel().rows.length;
    var firstVisibleRowIndex = pageIndex * pageSize;
    if (firstVisibleRowIndex > totalRowCount) {
      table.setPageIndex(Math.floor(totalRowCount / pageSize));
    }
  }, [props.rowCount, table.getPrePaginationRowModel().rows.length]);
  return jsxs(Fragment, {
    children: [jsx(Dialog, {
      PaperComponent: Box,
      TransitionComponent: !props.enableRowVirtualization ? Grow : undefined,
      disablePortal: true,
      fullScreen: true,
      keepMounted: false,
      onClose: function onClose() {
        return table.setIsFullScreen(false);
      },
      open: table.getState().isFullScreen,
      transitionDuration: 400,
      children: jsx(MRT_TablePaper, {
        table: table
      })
    }), !table.getState().isFullScreen && jsx(MRT_TablePaper, {
      table: table
    }), editingRow && props.editingMode === 'modal' && jsx(MRT_EditRowModal, {
      row: editingRow,
      table: table,
      open: true
    })]
  });
};
var MaterialReactTable = function MaterialReactTable(_a) {
  var _b;
  var aggregationFns = _a.aggregationFns,
    _a$autoResetExpanded = _a.autoResetExpanded,
    autoResetExpanded = _a$autoResetExpanded === void 0 ? false : _a$autoResetExpanded,
    _a$columnResizeMode = _a.columnResizeMode,
    columnResizeMode = _a$columnResizeMode === void 0 ? 'onChange' : _a$columnResizeMode,
    defaultColumn = _a.defaultColumn,
    defaultDisplayColumn = _a.defaultDisplayColumn,
    _a$editingMode = _a.editingMode,
    editingMode = _a$editingMode === void 0 ? 'modal' : _a$editingMode,
    _a$enableBottomToolba = _a.enableBottomToolbar,
    enableBottomToolbar = _a$enableBottomToolba === void 0 ? true : _a$enableBottomToolba,
    _a$enableColumnAction = _a.enableColumnActions,
    enableColumnActions = _a$enableColumnAction === void 0 ? true : _a$enableColumnAction,
    _a$enableColumnFilter = _a.enableColumnFilters,
    enableColumnFilters = _a$enableColumnFilter === void 0 ? true : _a$enableColumnFilter,
    _a$enableColumnOrderi = _a.enableColumnOrdering,
    enableColumnOrdering = _a$enableColumnOrderi === void 0 ? false : _a$enableColumnOrderi,
    _a$enableColumnResizi = _a.enableColumnResizing,
    enableColumnResizing = _a$enableColumnResizi === void 0 ? false : _a$enableColumnResizi,
    _a$enableDensityToggl = _a.enableDensityToggle,
    enableDensityToggle = _a$enableDensityToggl === void 0 ? true : _a$enableDensityToggl,
    _a$enableExpandAll = _a.enableExpandAll,
    enableExpandAll = _a$enableExpandAll === void 0 ? true : _a$enableExpandAll,
    enableExpanding = _a.enableExpanding,
    _a$enableFilterMatchH = _a.enableFilterMatchHighlighting,
    enableFilterMatchHighlighting = _a$enableFilterMatchH === void 0 ? true : _a$enableFilterMatchH,
    _a$enableFilters = _a.enableFilters,
    enableFilters = _a$enableFilters === void 0 ? true : _a$enableFilters,
    _a$enableFullScreenTo = _a.enableFullScreenToggle,
    enableFullScreenToggle = _a$enableFullScreenTo === void 0 ? true : _a$enableFullScreenTo,
    _a$enableGlobalFilter = _a.enableGlobalFilter,
    enableGlobalFilter = _a$enableGlobalFilter === void 0 ? true : _a$enableGlobalFilter,
    _a$enableGlobalFilter2 = _a.enableGlobalFilterRankedResults,
    enableGlobalFilterRankedResults = _a$enableGlobalFilter2 === void 0 ? true : _a$enableGlobalFilter2,
    _a$enableGrouping = _a.enableGrouping,
    enableGrouping = _a$enableGrouping === void 0 ? false : _a$enableGrouping,
    _a$enableHiding = _a.enableHiding,
    enableHiding = _a$enableHiding === void 0 ? true : _a$enableHiding,
    _a$enableMultiRowSele = _a.enableMultiRowSelection,
    enableMultiRowSelection = _a$enableMultiRowSele === void 0 ? true : _a$enableMultiRowSele,
    _a$enableMultiSort = _a.enableMultiSort,
    enableMultiSort = _a$enableMultiSort === void 0 ? true : _a$enableMultiSort,
    _a$enablePagination = _a.enablePagination,
    enablePagination = _a$enablePagination === void 0 ? true : _a$enablePagination,
    _a$enablePinning = _a.enablePinning,
    enablePinning = _a$enablePinning === void 0 ? false : _a$enablePinning,
    _a$enableRowSelection = _a.enableRowSelection,
    enableRowSelection = _a$enableRowSelection === void 0 ? false : _a$enableRowSelection,
    _a$enableSelectAll = _a.enableSelectAll,
    enableSelectAll = _a$enableSelectAll === void 0 ? true : _a$enableSelectAll,
    _a$enableSorting = _a.enableSorting,
    enableSorting = _a$enableSorting === void 0 ? true : _a$enableSorting,
    _a$enableStickyHeader = _a.enableStickyHeader,
    enableStickyHeader = _a$enableStickyHeader === void 0 ? false : _a$enableStickyHeader,
    _a$enableTableFooter = _a.enableTableFooter,
    enableTableFooter = _a$enableTableFooter === void 0 ? true : _a$enableTableFooter,
    _a$enableTableHead = _a.enableTableHead,
    enableTableHead = _a$enableTableHead === void 0 ? true : _a$enableTableHead,
    _a$enableToolbarInter = _a.enableToolbarInternalActions,
    enableToolbarInternalActions = _a$enableToolbarInter === void 0 ? true : _a$enableToolbarInter,
    _a$enableTopToolbar = _a.enableTopToolbar,
    enableTopToolbar = _a$enableTopToolbar === void 0 ? true : _a$enableTopToolbar,
    filterFns = _a.filterFns,
    icons = _a.icons,
    _a$layoutMode = _a.layoutMode,
    layoutMode = _a$layoutMode === void 0 ? 'semantic' : _a$layoutMode,
    localization = _a.localization,
    manualFiltering = _a.manualFiltering,
    manualGrouping = _a.manualGrouping,
    manualPagination = _a.manualPagination,
    manualSorting = _a.manualSorting,
    _a$positionActionsCol = _a.positionActionsColumn,
    positionActionsColumn = _a$positionActionsCol === void 0 ? 'first' : _a$positionActionsCol,
    _a$positionExpandColu = _a.positionExpandColumn,
    positionExpandColumn = _a$positionExpandColu === void 0 ? 'first' : _a$positionExpandColu,
    _a$positionGlobalFilt = _a.positionGlobalFilter,
    positionGlobalFilter = _a$positionGlobalFilt === void 0 ? 'right' : _a$positionGlobalFilt,
    _a$positionPagination = _a.positionPagination,
    positionPagination = _a$positionPagination === void 0 ? 'bottom' : _a$positionPagination,
    _a$positionToolbarAle = _a.positionToolbarAlertBanner,
    positionToolbarAlertBanner = _a$positionToolbarAle === void 0 ? 'top' : _a$positionToolbarAle,
    _a$positionToolbarDro = _a.positionToolbarDropZone,
    positionToolbarDropZone = _a$positionToolbarDro === void 0 ? 'top' : _a$positionToolbarDro,
    _a$rowNumberMode = _a.rowNumberMode,
    rowNumberMode = _a$rowNumberMode === void 0 ? 'original' : _a$rowNumberMode,
    _a$selectAllMode = _a.selectAllMode,
    selectAllMode = _a$selectAllMode === void 0 ? 'page' : _a$selectAllMode,
    sortingFns = _a.sortingFns,
    rest = __rest(_a, ["aggregationFns", "autoResetExpanded", "columnResizeMode", "defaultColumn", "defaultDisplayColumn", "editingMode", "enableBottomToolbar", "enableColumnActions", "enableColumnFilters", "enableColumnOrdering", "enableColumnResizing", "enableDensityToggle", "enableExpandAll", "enableExpanding", "enableFilterMatchHighlighting", "enableFilters", "enableFullScreenToggle", "enableGlobalFilter", "enableGlobalFilterRankedResults", "enableGrouping", "enableHiding", "enableMultiRowSelection", "enableMultiSort", "enablePagination", "enablePinning", "enableRowSelection", "enableSelectAll", "enableSorting", "enableStickyHeader", "enableTableFooter", "enableTableHead", "enableToolbarInternalActions", "enableTopToolbar", "filterFns", "icons", "layoutMode", "localization", "manualFiltering", "manualGrouping", "manualPagination", "manualSorting", "positionActionsColumn", "positionExpandColumn", "positionGlobalFilter", "positionPagination", "positionToolbarAlertBanner", "positionToolbarDropZone", "rowNumberMode", "selectAllMode", "sortingFns"]);
  var _icons = useMemo(function () {
    return Object.assign(Object.assign({}, MRT_Default_Icons), icons);
  }, [icons]);
  var _localization = useMemo(function () {
    return Object.assign(Object.assign({}, MRT_Localization_EN), localization);
  }, [localization]);
  var _aggregationFns = useMemo(function () {
    return Object.assign(Object.assign({}, MRT_AggregationFns), aggregationFns);
  }, []);
  var _filterFns = useMemo(function () {
    return Object.assign(Object.assign({}, MRT_FilterFns), filterFns);
  }, []);
  var _sortingFns = useMemo(function () {
    return Object.assign(Object.assign({}, MRT_SortingFns), sortingFns);
  }, []);
  var _defaultColumn = useMemo(function () {
    return Object.assign(Object.assign({}, MRT_DefaultColumn), defaultColumn);
  }, [defaultColumn]);
  var _defaultDisplayColumn = useMemo(function () {
    return Object.assign(Object.assign({}, MRT_DefaultDisplayColumn), defaultDisplayColumn);
  }, [defaultDisplayColumn]);
  if (rest.enableRowVirtualization || rest.enableColumnVirtualization) {
    layoutMode = 'grid';
  }
  if (rest.enableRowVirtualization) {
    enableStickyHeader = true;
  }
  if (enablePagination === false && manualPagination === undefined) {
    manualPagination = true;
  }
  if (!((_b = rest.data) === null || _b === void 0 ? void 0 : _b.length)) {
    manualFiltering = true;
    manualGrouping = true;
    manualPagination = true;
    manualSorting = true;
  }
  return jsx(MRT_TableRoot, Object.assign({
    aggregationFns: _aggregationFns,
    autoResetExpanded: autoResetExpanded,
    columnResizeMode: columnResizeMode,
    defaultColumn: _defaultColumn,
    defaultDisplayColumn: _defaultDisplayColumn,
    editingMode: editingMode,
    enableBottomToolbar: enableBottomToolbar,
    enableColumnActions: enableColumnActions,
    enableColumnFilters: enableColumnFilters,
    enableColumnOrdering: enableColumnOrdering,
    enableColumnResizing: enableColumnResizing,
    enableDensityToggle: enableDensityToggle,
    enableExpandAll: enableExpandAll,
    enableExpanding: enableExpanding,
    enableFilterMatchHighlighting: enableFilterMatchHighlighting,
    enableFilters: enableFilters,
    enableFullScreenToggle: enableFullScreenToggle,
    enableGlobalFilter: enableGlobalFilter,
    enableGlobalFilterRankedResults: enableGlobalFilterRankedResults,
    enableGrouping: enableGrouping,
    enableHiding: enableHiding,
    enableMultiRowSelection: enableMultiRowSelection,
    enableMultiSort: enableMultiSort,
    enablePagination: enablePagination,
    enablePinning: enablePinning,
    enableRowSelection: enableRowSelection,
    enableSelectAll: enableSelectAll,
    enableSorting: enableSorting,
    enableStickyHeader: enableStickyHeader,
    enableTableFooter: enableTableFooter,
    enableTableHead: enableTableHead,
    enableToolbarInternalActions: enableToolbarInternalActions,
    enableTopToolbar: enableTopToolbar,
    filterFns: _filterFns,
    icons: _icons,
    layoutMode: layoutMode,
    localization: _localization,
    manualFiltering: manualFiltering,
    manualGrouping: manualGrouping,
    manualPagination: manualPagination,
    manualSorting: manualSorting,
    positionActionsColumn: positionActionsColumn,
    positionExpandColumn: positionExpandColumn,
    positionGlobalFilter: positionGlobalFilter,
    positionPagination: positionPagination,
    positionToolbarAlertBanner: positionToolbarAlertBanner,
    positionToolbarDropZone: positionToolbarDropZone,
    rowNumberMode: rowNumberMode,
    selectAllMode: selectAllMode,
    sortingFns: _sortingFns
  }, rest));
};
export { MRT_AggregationFns, MRT_BottomToolbar, MRT_CopyButton, MRT_EditActionButtons, MRT_ExpandButton, MRT_FilterFns, MRT_FilterOptionMenu, MRT_FullScreenToggleButton, MRT_GlobalFilterTextField, MRT_GrabHandleButton, MRT_ShowHideColumnsButton, MRT_SortingFns, MRT_TableHeadCellFilterContainer, MRT_TablePagination, MRT_ToggleDensePaddingButton, MRT_ToggleFiltersButton, MRT_ToggleGlobalFilterButton, MRT_ToggleRowActionMenuButton, MRT_ToolbarAlertBanner, MRT_ToolbarDropZone, MRT_ToolbarInternalButtons, MRT_TopToolbar, MaterialReactTable, MaterialReactTable as default };